/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AmazonPollyTtsSettings,
  AnthropicLlmSettings,
  ApiKeySettings,
  ApplyProposalsResponse,
  AsrModelInfo,
  AssemblyAiAsrSettings,
  AzureAsrSettings,
  AzureBlobStorageConfig,
  AzureBlobStorageSettings,
  AzureTtsSettings,
  BenchmarkIterationResultData,
  BenchmarkStats,
  BuilderConfig,
  BuilderOperationMode,
  BuilderOperationModeListResponse,
  BuilderSkill,
  BuilderSkillListResponse,
  BuilderStreamEvent,
  CartesiaTtsSettings,
  ChannelCatalogResponse,
  ChannelInfo,
  CohereLlmSettings,
  ConversationTimelineResponse,
  CostManagementConfig,
  CreateBuilderOperationModeRequest,
  CreateBuilderSkillRequest,
  CreateToolRequest,
  DataExtractionEntry,
  DeepgramAsrSettings,
  DeepgramTtsSettings,
  DeepSeekLlmSettings,
  DeleteBuilderOperationModeRequest,
  DeleteBuilderSkillRequest,
  DeployTelegramWebhookResponse,
  DocumentCategoryResponse,
  Effect,
  ElevenLabsAsrSettings,
  ElevenLabsTtsSettings,
  ExpectedValueEntry,
  ExportBundle,
  ExportFormat,
  FieldDescriptor,
  FillerSettings,
  FireworksAILlmSettings,
  FunnelQuery,
  FunnelQueryResponse,
  GcsStorageConfig,
  GcsStorageSettings,
  GeminiLlmSettings,
  GroqLlmSettings,
  LanguageInfo,
  LatencyPercentilesResponse,
  LatencyStatsResponse,
  LatencyTrendResponse,
  ListFilterOperation,
  LlmModelInfo,
  LlmSettings,
  LocalStorageConfig,
  LocalStorageSettings,
  Methodology,
  MigrationJob,
  MigrationPreview,
  MistralLlmSettings,
  ModerationProviderInfo,
  OllamaLlmSettings,
  OpenAILegacyLlmSettings,
  OpenAILlmSettings,
  OpenAiTtsSettings,
  OpenRouterLlmSettings,
  ParameterValue,
  PerplexityLlmSettings,
  ProjectBuilderReply,
  ProjectBuilderSession,
  ProjectBuilderSessionList,
  ProjectExchangeBundleV1,
  ProjectExchangeImportResult,
  ProviderModelLimits,
  QuestionAnswer,
  RelativeTime,
  S3StorageConfig,
  S3StorageSettings,
  SampleCopyConfig,
  SavedFunnelQuery,
  SavedSliceQuery,
  ScenarioRunStatus,
  SecretListResponse,
  SecretValueResponse,
  ServerVadConfig,
  SliceQuery,
  SliceQueryResponse,
  SourceCatalogResponse,
  SpeechmaticsAsrSettings,
  StageAction,
  StageActionParameter,
  TelegramChannelConfig,
  TogetherAILlmSettings,
  TokenUsageStatsResponse,
  TokenUsageTrendResponse,
  ToolParameter,
  TtsModelInfo,
  TwilioMessagingChannelConfig,
  TwilioVoiceChannelConfig,
  UpdateBuilderOperationModeRequest,
  UpdateBuilderSkillRequest,
  UpdateToolRequest,
  VoiceInfo,
  WhatsAppChannelConfig,
  XAILlmSettings,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Api<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Creates a new operator user with the specified credentials and roles
   *
   * @tags Operators
   * @name OperatorsCreate
   * @summary Create a new operator user
   * @request POST:/api/operators
   * @secure
   */
  operatorsCreate = (
    data: {
      /**
       * Unique identifier for the operator user (auto-generated if not provided)
       * @minLength 1
       */
      id: string;
      /**
       * Display name for the operator user
       * @minLength 1
       */
      name: string;
      /**
       * Array of role identifiers assigned to the operator (at least one required). Valid roles: super_admin, content_manager, support, developer, viewer
       * @minItems 1
       */
      roles: (
        | "super_admin"
        | "content_manager"
        | "support"
        | "developer"
        | "viewer"
      )[];
      /**
       * Operator user password (will be hashed)
       * @minLength 1
       */
      password: string;
      /** Optional metadata as key-value pairs */
      metadata?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the operator user */
        id: string;
        /** Display name of the operator user */
        name: string;
        /** Array of role identifiers assigned to the operator */
        roles: string[];
        /** Metadata as key-value pairs */
        metadata?: Record<string, any>;
        /** Current version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the operator user was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the operator user was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/operators`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of operator users with optional filtering
   *
   * @tags Operators
   * @name OperatorsList
   * @summary List operator users
   * @request GET:/api/operators
   * @secure
   */
  operatorsList = (
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of operator users in the current page */
        items: {
          /** Unique identifier for the operator user */
          id: string;
          /** Display name of the operator user */
          name: string;
          /** Array of role identifiers assigned to the operator */
          roles: string[];
          /** Metadata as key-value pairs */
          metadata?: Record<string, any>;
          /** Current version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the operator user was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the operator user was last updated
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /**
         * Total number of operator users matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/operators`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single operator user by their unique identifier
   *
   * @tags Operators
   * @name OperatorsDetail
   * @summary Get operator user by ID
   * @request GET:/api/operators/{id}
   * @secure
   */
  operatorsDetail = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        /** Unique identifier for the operator user */
        id: string;
        /** Display name of the operator user */
        name: string;
        /** Array of role identifiers assigned to the operator */
        roles: string[];
        /** Metadata as key-value pairs */
        metadata?: Record<string, any>;
        /** Current version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the operator user was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the operator user was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/operators/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing operator user with optimistic locking
   *
   * @tags Operators
   * @name OperatorsUpdate
   * @summary Update operator user
   * @request PUT:/api/operators/{id}
   * @secure
   */
  operatorsUpdate = (
    id: string,
    data: {
      /**
       * Current version number for optimistic locking (prevents concurrent updates)
       * @min 0
       * @exclusiveMin true
       */
      version: number;
      /**
       * Updated display name for the operator user
       * @minLength 1
       */
      name?: string;
      /**
       * Updated array of role identifiers. Valid roles: super_admin, content_manager, support, developer, viewer
       * @minItems 1
       */
      roles?: (
        | "super_admin"
        | "content_manager"
        | "support"
        | "developer"
        | "viewer"
      )[];
      /**
       * New password (will be hashed)
       * @minLength 1
       */
      password?: string;
      /** Updated metadata (merges with existing) */
      metadata?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the operator user */
        id: string;
        /** Display name of the operator user */
        name: string;
        /** Array of role identifiers assigned to the operator */
        roles: string[];
        /** Metadata as key-value pairs */
        metadata?: Record<string, any>;
        /** Current version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the operator user was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the operator user was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/operators/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes an operator user with optimistic locking
   *
   * @tags Operators
   * @name OperatorsDelete
   * @summary Delete operator user
   * @request DELETE:/api/operators/{id}
   * @secure
   */
  operatorsDelete = (
    id: string,
    data: {
      /**
       * Current version number for optimistic locking (prevents concurrent deletions)
       * @min 0
       * @exclusiveMin true
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/operators/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific operator user
   *
   * @tags Operators
   * @name OperatorsAuditLogsList
   * @summary Get operator audit logs
   * @request GET:/api/operators/{id}/audit-logs
   * @secure
   */
  operatorsAuditLogsList = (id: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/operators/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Retrieves the profile information of the currently logged-in operator user
   *
   * @tags Profile
   * @name ProfileList
   * @summary Get own profile
   * @request GET:/api/profile
   * @secure
   */
  profileList = (params: RequestParams = {}) =>
    this.request<
      {
        /** Unique identifier for the operator user */
        id: string;
        /** Display name of the operator user */
        name: string;
        /** Array of role identifiers assigned to the operator */
        roles: string[];
        /** Metadata as key-value pairs */
        metadata?: Record<string, any>;
        /** Current version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the operator user was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the operator user was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/profile`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates the profile of the currently logged-in operator user. Allows changing display name and/or password. When changing password, the old password must be provided for verification.
   *
   * @tags Profile
   * @name ProfileCreate
   * @summary Update own profile
   * @request POST:/api/profile
   * @secure
   */
  profileCreate = (
    data: {
      /**
       * Updated display name for the operator user
       * @minLength 1
       */
      name?: string;
      /**
       * Current password (required when changing password)
       * @minLength 1
       */
      oldPassword?: string;
      /**
       * New password to set (requires oldPassword)
       * @minLength 1
       */
      newPassword?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the operator user */
        id: string;
        /** Display name of the operator user */
        name: string;
        /** Array of role identifiers assigned to the operator */
        roles: string[];
        /** Metadata as key-value pairs */
        metadata?: Record<string, any>;
        /** Current version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the operator user was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the operator user was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/profile`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Authenticate an operator user with email/ID and password. Returns access and refresh tokens.
   *
   * @tags Authentication
   * @name AuthLoginCreate
   * @summary Login with credentials
   * @request POST:/api/auth/login
   * @secure
   */
  authLoginCreate = (
    data: {
      /**
       * Operator user ID or email
       * @minLength 1
       */
      id: string;
      /**
       * Operator user password
       * @minLength 1
       */
      password: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** JWT access token */
        accessToken: string;
        /** JWT refresh token */
        refreshToken: string;
        /**
         * Access token expiry time in seconds
         * @min 0
         * @exclusiveMin true
         */
        expiresIn: number;
        /** Operator user ID */
        operatorId: string;
        /** Operator display name */
        displayName: string;
        /** Array of role identifiers */
        roles: string[];
        /** Effective permissions derived from assigned roles (deduplicated union) */
        permissions: string[];
      },
      void
    >({
      path: `/api/auth/login`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get a new access token using a valid refresh token
   *
   * @tags Authentication
   * @name AuthRefreshCreate
   * @summary Refresh access token
   * @request POST:/api/auth/refresh
   * @secure
   */
  authRefreshCreate = (
    data: {
      /**
       * Valid refresh token
       * @minLength 1
       */
      refreshToken: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** New JWT access token (expires in 15 minutes) */
        accessToken: string;
        /**
         * Access token expiry time in seconds
         * @min 0
         * @exclusiveMin true
         */
        expiresIn: number;
        /** Up-to-date array of role identifiers (re-fetched from database) */
        roles: string[];
        /** Up-to-date effective permissions derived from current roles (deduplicated union) */
        permissions: string[];
      },
      void
    >({
      path: `/api/auth/refresh`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns whether the system has been initialized with at least one operator account
   *
   * @tags Setup
   * @name SetupStatusList
   * @summary Check system setup status
   * @request GET:/api/setup/status
   * @secure
   */
  setupStatusList = (params: RequestParams = {}) =>
    this.request<
      {
        /** Whether the system has been set up with at least one operator account */
        isSetup: boolean;
        /** Descriptive message about the setup status */
        message: string;
      },
      any
    >({
      path: `/api/setup/status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates the first operator account with super_admin role. This endpoint only works when no operator accounts exist. Returns operator details and authentication tokens for immediate login.
   *
   * @tags Setup
   * @name SetupInitialOperatorCreate
   * @summary Create initial operator account
   * @request POST:/api/setup/initial-operator
   * @secure
   */
  setupInitialOperatorCreate = (
    data: {
      /**
       * Unique identifier for the operator user (typically an email address)
       * @minLength 1
       */
      id: string;
      /**
       * Display name for the operator user
       * @minLength 1
       */
      name: string;
      /**
       * Operator user password (minimum 8 characters, will be hashed)
       * @minLength 8
       */
      password: string;
      /** Optional metadata as key-value pairs */
      metadata?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Created operator user details */
        operator: {
          /** Unique identifier for the operator user */
          id: string;
          /** Display name of the operator user */
          name: string;
          /** Array of role identifiers assigned to the operator */
          roles: string[];
          /** Metadata as key-value pairs */
          metadata?: Record<string, any>;
          /**
           * Timestamp when the operator user was created
           * @format date-time
           */
          createdAt: string | null;
        };
        /** JWT access token for immediate authentication */
        accessToken: string;
        /** JWT refresh token for obtaining new access tokens */
        refreshToken: string;
        /**
         * Access token expiry time in seconds
         * @min 0
         * @exclusiveMin true
         */
        expiresIn: number;
      },
      void
    >({
      path: `/api/setup/initial-operator`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new project that groups stages, agents, classifiers, context transformers, tools, knowledge, actions, and issues
   *
   * @tags Projects
   * @name ProjectsCreate
   * @summary Create a new project
   * @request POST:/api/projects
   * @secure
   */
  projectsCreate = (
    data: {
      /**
       * The name of the project
       * @minLength 1
       * @maxLength 255
       */
      name: string;
      /** A description of the project */
      description?: string | null;
      /** Optional ASR configuration settings */
      asrConfig?: {
        /** ID of the ASR provider (e.g., "azure-speech", "openai-whisper") */
        asrProviderId?: string;
        /** ASR-specific settings including model, language preferences, etc. */
        settings?:
          | AzureAsrSettings
          | ElevenLabsAsrSettings
          | DeepgramAsrSettings
          | AssemblyAiAsrSettings
          | SpeechmaticsAsrSettings;
        /** Placeholder text to use when speech is unintelligible or cannot be transcribed */
        unintelligiblePlaceholder?: string;
        /** Whether to enable voice activity detection to automatically start/stop recording based on speech presence */
        voiceActivityDetection?: boolean;
        /** Server-side VAD configuration. When set, the server autonomously detects speech boundaries — clients send continuous audio without calling start/end_user_voice_input. */
        serverVad?: ServerVadConfig;
      };
      /**
       * Whether conversations can accept voice input (requires asrConfig fully populated)
       * @default true
       */
      acceptVoice?: boolean;
      /**
       * Whether conversations generate voice responses (requires ttsConfig fully populated in Stages)
       * @default true
       */
      generateVoice?: boolean;
      /** Optional storage configuration for conversation artifacts */
      storageConfig?: {
        /** ID of the storage provider (e.g., "s3-provider", "azure-blob-provider") */
        storageProviderId?: string;
        /** Storage-specific settings including bucket, prefix, etc. */
        settings?:
          | S3StorageSettings
          | AzureBlobStorageSettings
          | GcsStorageSettings
          | LocalStorageSettings;
      };
      /** Optional content moderation configuration */
      moderationConfig?: {
        /** Whether content moderation is enabled for this project */
        enabled: boolean;
        /** ID of the LLM provider used for moderation (must support moderation API, e.g. OpenAI or Mistral) */
        llmProviderId: string;
        /** List of category names that should cause the input to be blocked. If omitted or empty, any flagged category will block the input. Category names are provider-specific. OpenAI categories: harassment, harassment/threatening, hate, hate/threatening, illicit, illicit/violent, self-harm, self-harm/instructions, self-harm/intent, sexual, sexual/minors, violence, violence/graphic. Mistral categories: sexual, hate_and_discrimination, violence_and_threats, dangerous_and_criminal_content, selfharm, health, financial, law, pii. */
        blockedCategories?: string[];
        /** Moderation execution mode. "strict" (default): moderation runs before all other processing — the turn is held until the moderation result is available. "standard": moderation runs after filler generation, in parallel with classification/knowledge retrieval (processTextInput), reducing perceived latency while still blocking flagged input before classification results are acted upon. */
        mode?: "strict" | "standard";
      };
      /** Optional project-level LLM token cost management configuration */
      costManagementConfig?: CostManagementConfig;
      /** Key-value store of constants used in templating and conversation logic */
      constants?: Record<string, ParameterValue>;
      /** Additional metadata for the project */
      metadata?: Record<string, any>;
      /** IANA timezone identifier used as the default for conversations in this project, e.g. Europe/Warsaw or America/New_York. Defaults to UTC when not set. */
      timezone?: string | null;
      /** ISO language code for the project, e.g. en-US or pl-PL. Used as a hint for language-aware LLM prompts. */
      languageCode?: string | null;
      /**
       * When enabled, users are automatically created on first WebSocket connection if they do not exist, using the provided user ID and an empty profile
       * @default false
       */
      autoCreateUsers?: boolean;
      /**
       * Descriptors defining the data schema for user profile variables in this project
       * @default []
       */
      userProfileVariableDescriptors?: FieldDescriptor[];
      /** ID of the classifier used to evaluate guardrails for all conversations in this project. When set, all project guardrails are evaluated against this classifier on every user input turn. */
      defaultGuardrailClassifierId?: string | null;
      /** Sample copy configuration including the default classifier used to evaluate prompt triggers. */
      sampleCopyConfig?: SampleCopyConfig;
      /** Optional project builder AI assistant configuration. Required to use the project builder feature. */
      builderConfig?: BuilderConfig;
      /** ID of the stage to start new conversations at when no stageId is provided at conversation start time. Acts as the project-level default starting stage. */
      startingStageId?: string | null;
      /**
       * Timeout in seconds for active conversations with no activity. Set to 0 or omit to disable. Conversations that have been inactive for longer than this value will be automatically aborted.
       * @min 0
       */
      conversationTimeoutSeconds?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** The unique identifier of the project */
        id: string;
        /** The name of the project */
        name: string;
        /** A description of the project */
        description: string | null;
        /** ASR configuration settings */
        asrConfig?: {
          /** ID of the ASR provider (e.g., "azure-speech", "openai-whisper") */
          asrProviderId?: string;
          /** ASR-specific settings including model, language preferences, etc. */
          settings?:
            | AzureAsrSettings
            | ElevenLabsAsrSettings
            | DeepgramAsrSettings
            | AssemblyAiAsrSettings
            | SpeechmaticsAsrSettings;
          /** Placeholder text to use when speech is unintelligible or cannot be transcribed */
          unintelligiblePlaceholder?: string;
          /** Whether to enable voice activity detection to automatically start/stop recording based on speech presence */
          voiceActivityDetection?: boolean;
          /** Server-side VAD configuration. When set, the server autonomously detects speech boundaries — clients send continuous audio without calling start/end_user_voice_input. */
          serverVad?: ServerVadConfig;
        } | null;
        /** Whether conversations can accept voice input (requires asrConfig fully populated) */
        acceptVoice: boolean;
        /** Whether conversations generate voice responses (requires ttsConfig fully populated in Stages) */
        generateVoice: boolean;
        /** Storage configuration for conversation artifacts */
        storageConfig?: {
          /** ID of the storage provider (e.g., "s3-provider", "azure-blob-provider") */
          storageProviderId?: string;
          /** Storage-specific settings including bucket, prefix, etc. */
          settings?:
            | S3StorageSettings
            | AzureBlobStorageSettings
            | GcsStorageSettings
            | LocalStorageSettings;
        } | null;
        /** Content moderation configuration */
        moderationConfig: {
          /** Whether content moderation is enabled for this project */
          enabled: boolean;
          /** ID of the LLM provider used for moderation (must support moderation API, e.g. OpenAI or Mistral) */
          llmProviderId: string;
          /** List of category names that should cause the input to be blocked. If omitted or empty, any flagged category will block the input. Category names are provider-specific. OpenAI categories: harassment, harassment/threatening, hate, hate/threatening, illicit, illicit/violent, self-harm, self-harm/instructions, self-harm/intent, sexual, sexual/minors, violence, violence/graphic. Mistral categories: sexual, hate_and_discrimination, violence_and_threats, dangerous_and_criminal_content, selfharm, health, financial, law, pii. */
          blockedCategories?: string[];
          /** Moderation execution mode. "strict" (default): moderation runs before all other processing — the turn is held until the moderation result is available. "standard": moderation runs after filler generation, in parallel with classification/knowledge retrieval (processTextInput), reducing perceived latency while still blocking flagged input before classification results are acted upon. */
          mode?: "strict" | "standard";
        } | null;
        /** Project-level LLM token cost management configuration */
        costManagementConfig: CostManagementConfig;
        /** Key-value store of constants used in templating and conversation logic */
        constants: Record<string, ParameterValue>;
        /** Additional metadata for the project */
        metadata: Record<string, any>;
        /** IANA timezone identifier used as the default for conversations in this project, e.g. Europe/Warsaw or America/New_York. Null means UTC. */
        timezone: string | null;
        /** ISO language code for the project, e.g. en-US or pl-PL. Null if not set. */
        languageCode: string | null;
        /** When enabled, users are automatically created on first WebSocket connection if they do not exist, using the provided user ID and an empty profile */
        autoCreateUsers: boolean;
        /** Descriptors defining the data schema for user profile variables in this project */
        userProfileVariableDescriptors: FieldDescriptor[];
        /** ID of the classifier used to evaluate guardrails for all conversations in this project */
        defaultGuardrailClassifierId: string | null;
        /** Sample copy configuration including the default classifier used to evaluate prompt triggers. */
        sampleCopyConfig?: {
          /** ID of the classifier used to evaluate sample copy prompt triggers for all stages in this project. Individual sample copies can override this with classifierOverrideId. */
          defaultClassifierId?: string;
        } | null;
        /** Project builder AI assistant configuration */
        builderConfig?: {
          /** ID of the LLM provider used to power the project builder AI assistant */
          llmProviderId: string;
          /** LLM provider-specific settings for the project builder assistant */
          llmSettings?:
            | OpenAILlmSettings
            | OpenAILegacyLlmSettings
            | AnthropicLlmSettings
            | GeminiLlmSettings
            | GroqLlmSettings
            | MistralLlmSettings
            | DeepSeekLlmSettings
            | OpenRouterLlmSettings
            | TogetherAILlmSettings
            | FireworksAILlmSettings
            | PerplexityLlmSettings
            | CohereLlmSettings
            | XAILlmSettings
            | OllamaLlmSettings;
          /** Deprecated - for backward compatibility; ignored if llmSettings.model is present. The model to use for the project builder assistant. This field is ignored if llmSettings.model is provided, which takes precedence. */
          llmModel?: string;
          /** Per-entity-category LLM provider and settings overrides. When set for a category, the builder will prefer that provider and model over the global default when proposing entities of that type. */
          hints?: {
            /** LLM override for stage entities */
            stages?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for classifier entities */
            classifiers?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for context transformer entities */
            transformers?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for tool entities */
            tools?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
          };
        } | null;
        /** ID of the stage to start new conversations at when no stageId is provided at conversation start time. Null means no default is set. */
        startingStageId: string | null;
        /** Timeout in seconds for active conversations with no activity. Null or 0 means no timeout. */
        conversationTimeoutSeconds: number | null;
        /** ID of the methodology assigned to this project, or null if none is assigned */
        methodologyId: string | null;
        /** The version number of the project */
        version: number;
        /**
         * The timestamp when the project was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * The timestamp when the project was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /**
         * The timestamp when the project was archived, or null if the project is not archived
         * @format date-time
         */
        archivedAt: string | null;
        /** The ID of the operator who archived the project, or null if the project is not archived */
        archivedBy: string | null;
      },
      void
    >({
      path: `/api/projects`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of projects with optional filtering, sorting, and searching. Use ?archived=true to list archived projects.
   *
   * @tags Projects
   * @name ProjectsList
   * @summary List projects
   * @request GET:/api/projects
   * @secure
   */
  projectsList = (
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
      /** When true, returns only archived projects. When omitted or false, returns only active (non-archived) projects. */
      archived?: "true" | "false";
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of projects */
        items: {
          /** The unique identifier of the project */
          id: string;
          /** The name of the project */
          name: string;
          /** A description of the project */
          description: string | null;
          /** ASR configuration settings */
          asrConfig?: {
            /** ID of the ASR provider (e.g., "azure-speech", "openai-whisper") */
            asrProviderId?: string;
            /** ASR-specific settings including model, language preferences, etc. */
            settings?:
              | AzureAsrSettings
              | ElevenLabsAsrSettings
              | DeepgramAsrSettings
              | AssemblyAiAsrSettings
              | SpeechmaticsAsrSettings;
            /** Placeholder text to use when speech is unintelligible or cannot be transcribed */
            unintelligiblePlaceholder?: string;
            /** Whether to enable voice activity detection to automatically start/stop recording based on speech presence */
            voiceActivityDetection?: boolean;
            /** Server-side VAD configuration. When set, the server autonomously detects speech boundaries — clients send continuous audio without calling start/end_user_voice_input. */
            serverVad?: ServerVadConfig;
          } | null;
          /** Whether conversations can accept voice input (requires asrConfig fully populated) */
          acceptVoice: boolean;
          /** Whether conversations generate voice responses (requires ttsConfig fully populated in Stages) */
          generateVoice: boolean;
          /** Storage configuration for conversation artifacts */
          storageConfig?: {
            /** ID of the storage provider (e.g., "s3-provider", "azure-blob-provider") */
            storageProviderId?: string;
            /** Storage-specific settings including bucket, prefix, etc. */
            settings?:
              | S3StorageSettings
              | AzureBlobStorageSettings
              | GcsStorageSettings
              | LocalStorageSettings;
          } | null;
          /** Content moderation configuration */
          moderationConfig: {
            /** Whether content moderation is enabled for this project */
            enabled: boolean;
            /** ID of the LLM provider used for moderation (must support moderation API, e.g. OpenAI or Mistral) */
            llmProviderId: string;
            /** List of category names that should cause the input to be blocked. If omitted or empty, any flagged category will block the input. Category names are provider-specific. OpenAI categories: harassment, harassment/threatening, hate, hate/threatening, illicit, illicit/violent, self-harm, self-harm/instructions, self-harm/intent, sexual, sexual/minors, violence, violence/graphic. Mistral categories: sexual, hate_and_discrimination, violence_and_threats, dangerous_and_criminal_content, selfharm, health, financial, law, pii. */
            blockedCategories?: string[];
            /** Moderation execution mode. "strict" (default): moderation runs before all other processing — the turn is held until the moderation result is available. "standard": moderation runs after filler generation, in parallel with classification/knowledge retrieval (processTextInput), reducing perceived latency while still blocking flagged input before classification results are acted upon. */
            mode?: "strict" | "standard";
          } | null;
          /** Project-level LLM token cost management configuration */
          costManagementConfig: CostManagementConfig;
          /** Key-value store of constants used in templating and conversation logic */
          constants: Record<string, ParameterValue>;
          /** Additional metadata for the project */
          metadata: Record<string, any>;
          /** IANA timezone identifier used as the default for conversations in this project, e.g. Europe/Warsaw or America/New_York. Null means UTC. */
          timezone: string | null;
          /** ISO language code for the project, e.g. en-US or pl-PL. Null if not set. */
          languageCode: string | null;
          /** When enabled, users are automatically created on first WebSocket connection if they do not exist, using the provided user ID and an empty profile */
          autoCreateUsers: boolean;
          /** Descriptors defining the data schema for user profile variables in this project */
          userProfileVariableDescriptors: FieldDescriptor[];
          /** ID of the classifier used to evaluate guardrails for all conversations in this project */
          defaultGuardrailClassifierId: string | null;
          /** Sample copy configuration including the default classifier used to evaluate prompt triggers. */
          sampleCopyConfig?: {
            /** ID of the classifier used to evaluate sample copy prompt triggers for all stages in this project. Individual sample copies can override this with classifierOverrideId. */
            defaultClassifierId?: string;
          } | null;
          /** Project builder AI assistant configuration */
          builderConfig?: {
            /** ID of the LLM provider used to power the project builder AI assistant */
            llmProviderId: string;
            /** LLM provider-specific settings for the project builder assistant */
            llmSettings?:
              | OpenAILlmSettings
              | OpenAILegacyLlmSettings
              | AnthropicLlmSettings
              | GeminiLlmSettings
              | GroqLlmSettings
              | MistralLlmSettings
              | DeepSeekLlmSettings
              | OpenRouterLlmSettings
              | TogetherAILlmSettings
              | FireworksAILlmSettings
              | PerplexityLlmSettings
              | CohereLlmSettings
              | XAILlmSettings
              | OllamaLlmSettings;
            /** Deprecated - for backward compatibility; ignored if llmSettings.model is present. The model to use for the project builder assistant. This field is ignored if llmSettings.model is provided, which takes precedence. */
            llmModel?: string;
            /** Per-entity-category LLM provider and settings overrides. When set for a category, the builder will prefer that provider and model over the global default when proposing entities of that type. */
            hints?: {
              /** LLM override for stage entities */
              stages?: {
                /** ID of the LLM provider to use for this entity category */
                llmProviderId?: string;
                /** LLM provider-specific settings for this entity category */
                llmSettings?:
                  | OpenAILlmSettings
                  | OpenAILegacyLlmSettings
                  | AnthropicLlmSettings
                  | GeminiLlmSettings
                  | GroqLlmSettings
                  | MistralLlmSettings
                  | DeepSeekLlmSettings
                  | OpenRouterLlmSettings
                  | TogetherAILlmSettings
                  | FireworksAILlmSettings
                  | PerplexityLlmSettings
                  | CohereLlmSettings
                  | XAILlmSettings
                  | OllamaLlmSettings;
                /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
                modelDisplayName?: string;
              };
              /** LLM override for classifier entities */
              classifiers?: {
                /** ID of the LLM provider to use for this entity category */
                llmProviderId?: string;
                /** LLM provider-specific settings for this entity category */
                llmSettings?:
                  | OpenAILlmSettings
                  | OpenAILegacyLlmSettings
                  | AnthropicLlmSettings
                  | GeminiLlmSettings
                  | GroqLlmSettings
                  | MistralLlmSettings
                  | DeepSeekLlmSettings
                  | OpenRouterLlmSettings
                  | TogetherAILlmSettings
                  | FireworksAILlmSettings
                  | PerplexityLlmSettings
                  | CohereLlmSettings
                  | XAILlmSettings
                  | OllamaLlmSettings;
                /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
                modelDisplayName?: string;
              };
              /** LLM override for context transformer entities */
              transformers?: {
                /** ID of the LLM provider to use for this entity category */
                llmProviderId?: string;
                /** LLM provider-specific settings for this entity category */
                llmSettings?:
                  | OpenAILlmSettings
                  | OpenAILegacyLlmSettings
                  | AnthropicLlmSettings
                  | GeminiLlmSettings
                  | GroqLlmSettings
                  | MistralLlmSettings
                  | DeepSeekLlmSettings
                  | OpenRouterLlmSettings
                  | TogetherAILlmSettings
                  | FireworksAILlmSettings
                  | PerplexityLlmSettings
                  | CohereLlmSettings
                  | XAILlmSettings
                  | OllamaLlmSettings;
                /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
                modelDisplayName?: string;
              };
              /** LLM override for tool entities */
              tools?: {
                /** ID of the LLM provider to use for this entity category */
                llmProviderId?: string;
                /** LLM provider-specific settings for this entity category */
                llmSettings?:
                  | OpenAILlmSettings
                  | OpenAILegacyLlmSettings
                  | AnthropicLlmSettings
                  | GeminiLlmSettings
                  | GroqLlmSettings
                  | MistralLlmSettings
                  | DeepSeekLlmSettings
                  | OpenRouterLlmSettings
                  | TogetherAILlmSettings
                  | FireworksAILlmSettings
                  | PerplexityLlmSettings
                  | CohereLlmSettings
                  | XAILlmSettings
                  | OllamaLlmSettings;
                /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
                modelDisplayName?: string;
              };
            };
          } | null;
          /** ID of the stage to start new conversations at when no stageId is provided at conversation start time. Null means no default is set. */
          startingStageId: string | null;
          /** Timeout in seconds for active conversations with no activity. Null or 0 means no timeout. */
          conversationTimeoutSeconds: number | null;
          /** ID of the methodology assigned to this project, or null if none is assigned */
          methodologyId: string | null;
          /** The version number of the project */
          version: number;
          /**
           * The timestamp when the project was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * The timestamp when the project was last updated
           * @format date-time
           */
          updatedAt: string | null;
          /**
           * The timestamp when the project was archived, or null if the project is not archived
           * @format date-time
           */
          archivedAt: string | null;
          /** The ID of the operator who archived the project, or null if the project is not archived */
          archivedBy: string | null;
        }[];
        /** Total number of projects */
        total: number;
      },
      any
    >({
      path: `/api/projects`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single project by its unique identifier
   *
   * @tags Projects
   * @name ProjectsDetail
   * @summary Get project by ID
   * @request GET:/api/projects/{id}
   * @secure
   */
  projectsDetail = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        /** The unique identifier of the project */
        id: string;
        /** The name of the project */
        name: string;
        /** A description of the project */
        description: string | null;
        /** ASR configuration settings */
        asrConfig?: {
          /** ID of the ASR provider (e.g., "azure-speech", "openai-whisper") */
          asrProviderId?: string;
          /** ASR-specific settings including model, language preferences, etc. */
          settings?:
            | AzureAsrSettings
            | ElevenLabsAsrSettings
            | DeepgramAsrSettings
            | AssemblyAiAsrSettings
            | SpeechmaticsAsrSettings;
          /** Placeholder text to use when speech is unintelligible or cannot be transcribed */
          unintelligiblePlaceholder?: string;
          /** Whether to enable voice activity detection to automatically start/stop recording based on speech presence */
          voiceActivityDetection?: boolean;
          /** Server-side VAD configuration. When set, the server autonomously detects speech boundaries — clients send continuous audio without calling start/end_user_voice_input. */
          serverVad?: ServerVadConfig;
        } | null;
        /** Whether conversations can accept voice input (requires asrConfig fully populated) */
        acceptVoice: boolean;
        /** Whether conversations generate voice responses (requires ttsConfig fully populated in Stages) */
        generateVoice: boolean;
        /** Storage configuration for conversation artifacts */
        storageConfig?: {
          /** ID of the storage provider (e.g., "s3-provider", "azure-blob-provider") */
          storageProviderId?: string;
          /** Storage-specific settings including bucket, prefix, etc. */
          settings?:
            | S3StorageSettings
            | AzureBlobStorageSettings
            | GcsStorageSettings
            | LocalStorageSettings;
        } | null;
        /** Content moderation configuration */
        moderationConfig: {
          /** Whether content moderation is enabled for this project */
          enabled: boolean;
          /** ID of the LLM provider used for moderation (must support moderation API, e.g. OpenAI or Mistral) */
          llmProviderId: string;
          /** List of category names that should cause the input to be blocked. If omitted or empty, any flagged category will block the input. Category names are provider-specific. OpenAI categories: harassment, harassment/threatening, hate, hate/threatening, illicit, illicit/violent, self-harm, self-harm/instructions, self-harm/intent, sexual, sexual/minors, violence, violence/graphic. Mistral categories: sexual, hate_and_discrimination, violence_and_threats, dangerous_and_criminal_content, selfharm, health, financial, law, pii. */
          blockedCategories?: string[];
          /** Moderation execution mode. "strict" (default): moderation runs before all other processing — the turn is held until the moderation result is available. "standard": moderation runs after filler generation, in parallel with classification/knowledge retrieval (processTextInput), reducing perceived latency while still blocking flagged input before classification results are acted upon. */
          mode?: "strict" | "standard";
        } | null;
        /** Project-level LLM token cost management configuration */
        costManagementConfig: CostManagementConfig;
        /** Key-value store of constants used in templating and conversation logic */
        constants: Record<string, ParameterValue>;
        /** Additional metadata for the project */
        metadata: Record<string, any>;
        /** IANA timezone identifier used as the default for conversations in this project, e.g. Europe/Warsaw or America/New_York. Null means UTC. */
        timezone: string | null;
        /** ISO language code for the project, e.g. en-US or pl-PL. Null if not set. */
        languageCode: string | null;
        /** When enabled, users are automatically created on first WebSocket connection if they do not exist, using the provided user ID and an empty profile */
        autoCreateUsers: boolean;
        /** Descriptors defining the data schema for user profile variables in this project */
        userProfileVariableDescriptors: FieldDescriptor[];
        /** ID of the classifier used to evaluate guardrails for all conversations in this project */
        defaultGuardrailClassifierId: string | null;
        /** Sample copy configuration including the default classifier used to evaluate prompt triggers. */
        sampleCopyConfig?: {
          /** ID of the classifier used to evaluate sample copy prompt triggers for all stages in this project. Individual sample copies can override this with classifierOverrideId. */
          defaultClassifierId?: string;
        } | null;
        /** Project builder AI assistant configuration */
        builderConfig?: {
          /** ID of the LLM provider used to power the project builder AI assistant */
          llmProviderId: string;
          /** LLM provider-specific settings for the project builder assistant */
          llmSettings?:
            | OpenAILlmSettings
            | OpenAILegacyLlmSettings
            | AnthropicLlmSettings
            | GeminiLlmSettings
            | GroqLlmSettings
            | MistralLlmSettings
            | DeepSeekLlmSettings
            | OpenRouterLlmSettings
            | TogetherAILlmSettings
            | FireworksAILlmSettings
            | PerplexityLlmSettings
            | CohereLlmSettings
            | XAILlmSettings
            | OllamaLlmSettings;
          /** Deprecated - for backward compatibility; ignored if llmSettings.model is present. The model to use for the project builder assistant. This field is ignored if llmSettings.model is provided, which takes precedence. */
          llmModel?: string;
          /** Per-entity-category LLM provider and settings overrides. When set for a category, the builder will prefer that provider and model over the global default when proposing entities of that type. */
          hints?: {
            /** LLM override for stage entities */
            stages?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for classifier entities */
            classifiers?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for context transformer entities */
            transformers?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for tool entities */
            tools?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
          };
        } | null;
        /** ID of the stage to start new conversations at when no stageId is provided at conversation start time. Null means no default is set. */
        startingStageId: string | null;
        /** Timeout in seconds for active conversations with no activity. Null or 0 means no timeout. */
        conversationTimeoutSeconds: number | null;
        /** ID of the methodology assigned to this project, or null if none is assigned */
        methodologyId: string | null;
        /** The version number of the project */
        version: number;
        /**
         * The timestamp when the project was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * The timestamp when the project was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /**
         * The timestamp when the project was archived, or null if the project is not archived
         * @format date-time
         */
        archivedAt: string | null;
        /** The ID of the operator who archived the project, or null if the project is not archived */
        archivedBy: string | null;
      },
      void
    >({
      path: `/api/projects/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing project with optimistic locking support
   *
   * @tags Projects
   * @name ProjectsUpdate
   * @summary Update project
   * @request PUT:/api/projects/{id}
   * @secure
   */
  projectsUpdate = (
    id: string,
    data: {
      /**
       * The updated name of the project
       * @minLength 1
       * @maxLength 255
       */
      name?: string;
      /** The updated description of the project */
      description?: string | null;
      /** Updated ASR configuration settings */
      asrConfig?: {
        /** ID of the ASR provider (e.g., "azure-speech", "openai-whisper") */
        asrProviderId?: string;
        /** ASR-specific settings including model, language preferences, etc. */
        settings?:
          | AzureAsrSettings
          | ElevenLabsAsrSettings
          | DeepgramAsrSettings
          | AssemblyAiAsrSettings
          | SpeechmaticsAsrSettings;
        /** Placeholder text to use when speech is unintelligible or cannot be transcribed */
        unintelligiblePlaceholder?: string;
        /** Whether to enable voice activity detection to automatically start/stop recording based on speech presence */
        voiceActivityDetection?: boolean;
        /** Server-side VAD configuration. When set, the server autonomously detects speech boundaries — clients send continuous audio without calling start/end_user_voice_input. */
        serverVad?: ServerVadConfig;
      } | null;
      /** Whether conversations can accept voice input (requires asrConfig fully populated) */
      acceptVoice?: boolean;
      /** Whether conversations generate voice responses (requires ttsConfig fully populated in Stages) */
      generateVoice?: boolean;
      /** Updated storage configuration settings */
      storageConfig?: {
        /** ID of the storage provider (e.g., "s3-provider", "azure-blob-provider") */
        storageProviderId?: string;
        /** Storage-specific settings including bucket, prefix, etc. */
        settings?:
          | S3StorageSettings
          | AzureBlobStorageSettings
          | GcsStorageSettings
          | LocalStorageSettings;
      } | null;
      /** Updated content moderation configuration */
      moderationConfig?: {
        /** Whether content moderation is enabled for this project */
        enabled: boolean;
        /** ID of the LLM provider used for moderation (must support moderation API, e.g. OpenAI or Mistral) */
        llmProviderId: string;
        /** List of category names that should cause the input to be blocked. If omitted or empty, any flagged category will block the input. Category names are provider-specific. OpenAI categories: harassment, harassment/threatening, hate, hate/threatening, illicit, illicit/violent, self-harm, self-harm/instructions, self-harm/intent, sexual, sexual/minors, violence, violence/graphic. Mistral categories: sexual, hate_and_discrimination, violence_and_threats, dangerous_and_criminal_content, selfharm, health, financial, law, pii. */
        blockedCategories?: string[];
        /** Moderation execution mode. "strict" (default): moderation runs before all other processing — the turn is held until the moderation result is available. "standard": moderation runs after filler generation, in parallel with classification/knowledge retrieval (processTextInput), reducing perceived latency while still blocking flagged input before classification results are acted upon. */
        mode?: "strict" | "standard";
      } | null;
      /** Updated project-level LLM token cost management configuration. Set to null to remove. */
      costManagementConfig?: {
        /** Token cap definitions keyed by provider API type and model name */
        limits: Record<string, Record<string, ProviderModelLimits>>;
      } | null;
      /** Updated constants key-value store */
      constants?: Record<string, ParameterValue>;
      /** Updated metadata for the project */
      metadata?: Record<string, any>;
      /** IANA timezone identifier used as the default for conversations in this project, e.g. Europe/Warsaw or America/New_York. Set to null to clear. Defaults to UTC when not set. */
      timezone?: string | null;
      /** ISO language code for the project, e.g. en-US or pl-PL. Set to null to clear. */
      languageCode?: string | null;
      /** When enabled, users are automatically created on first WebSocket connection if they do not exist, using the provided user ID and an empty profile */
      autoCreateUsers?: boolean;
      /** Updated descriptors defining the data schema for user profile variables in this project */
      userProfileVariableDescriptors?: FieldDescriptor[];
      /** Updated ID of the classifier used to evaluate guardrails. Set to null to disable guardrail classification. */
      defaultGuardrailClassifierId?: string | null;
      /** Updated sample copy configuration. Set to null to clear. */
      sampleCopyConfig?: {
        /** ID of the classifier used to evaluate sample copy prompt triggers for all stages in this project. Individual sample copies can override this with classifierOverrideId. */
        defaultClassifierId?: string;
      } | null;
      /** Updated project builder configuration. Set to null to clear. */
      builderConfig?: {
        /** ID of the LLM provider used to power the project builder AI assistant */
        llmProviderId: string;
        /** LLM provider-specific settings for the project builder assistant */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** Deprecated - for backward compatibility; ignored if llmSettings.model is present. The model to use for the project builder assistant. This field is ignored if llmSettings.model is provided, which takes precedence. */
        llmModel?: string;
        /** Per-entity-category LLM provider and settings overrides. When set for a category, the builder will prefer that provider and model over the global default when proposing entities of that type. */
        hints?: {
          /** LLM override for stage entities */
          stages?: {
            /** ID of the LLM provider to use for this entity category */
            llmProviderId?: string;
            /** LLM provider-specific settings for this entity category */
            llmSettings?:
              | OpenAILlmSettings
              | OpenAILegacyLlmSettings
              | AnthropicLlmSettings
              | GeminiLlmSettings
              | GroqLlmSettings
              | MistralLlmSettings
              | DeepSeekLlmSettings
              | OpenRouterLlmSettings
              | TogetherAILlmSettings
              | FireworksAILlmSettings
              | PerplexityLlmSettings
              | CohereLlmSettings
              | XAILlmSettings
              | OllamaLlmSettings;
            /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
            modelDisplayName?: string;
          };
          /** LLM override for classifier entities */
          classifiers?: {
            /** ID of the LLM provider to use for this entity category */
            llmProviderId?: string;
            /** LLM provider-specific settings for this entity category */
            llmSettings?:
              | OpenAILlmSettings
              | OpenAILegacyLlmSettings
              | AnthropicLlmSettings
              | GeminiLlmSettings
              | GroqLlmSettings
              | MistralLlmSettings
              | DeepSeekLlmSettings
              | OpenRouterLlmSettings
              | TogetherAILlmSettings
              | FireworksAILlmSettings
              | PerplexityLlmSettings
              | CohereLlmSettings
              | XAILlmSettings
              | OllamaLlmSettings;
            /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
            modelDisplayName?: string;
          };
          /** LLM override for context transformer entities */
          transformers?: {
            /** ID of the LLM provider to use for this entity category */
            llmProviderId?: string;
            /** LLM provider-specific settings for this entity category */
            llmSettings?:
              | OpenAILlmSettings
              | OpenAILegacyLlmSettings
              | AnthropicLlmSettings
              | GeminiLlmSettings
              | GroqLlmSettings
              | MistralLlmSettings
              | DeepSeekLlmSettings
              | OpenRouterLlmSettings
              | TogetherAILlmSettings
              | FireworksAILlmSettings
              | PerplexityLlmSettings
              | CohereLlmSettings
              | XAILlmSettings
              | OllamaLlmSettings;
            /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
            modelDisplayName?: string;
          };
          /** LLM override for tool entities */
          tools?: {
            /** ID of the LLM provider to use for this entity category */
            llmProviderId?: string;
            /** LLM provider-specific settings for this entity category */
            llmSettings?:
              | OpenAILlmSettings
              | OpenAILegacyLlmSettings
              | AnthropicLlmSettings
              | GeminiLlmSettings
              | GroqLlmSettings
              | MistralLlmSettings
              | DeepSeekLlmSettings
              | OpenRouterLlmSettings
              | TogetherAILlmSettings
              | FireworksAILlmSettings
              | PerplexityLlmSettings
              | CohereLlmSettings
              | XAILlmSettings
              | OllamaLlmSettings;
            /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
            modelDisplayName?: string;
          };
        };
      } | null;
      /** Updated ID of the stage to start new conversations at when no stageId is provided at conversation start time. Set to null to remove the default starting stage. */
      startingStageId?: string | null;
      /**
       * Timeout in seconds for active conversations with no activity. Set to 0 or null to disable. Conversations that have been inactive for longer than this value will be automatically aborted.
       * @min 0
       */
      conversationTimeoutSeconds?: number | null;
      /** The current version number for optimistic locking */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** The unique identifier of the project */
        id: string;
        /** The name of the project */
        name: string;
        /** A description of the project */
        description: string | null;
        /** ASR configuration settings */
        asrConfig?: {
          /** ID of the ASR provider (e.g., "azure-speech", "openai-whisper") */
          asrProviderId?: string;
          /** ASR-specific settings including model, language preferences, etc. */
          settings?:
            | AzureAsrSettings
            | ElevenLabsAsrSettings
            | DeepgramAsrSettings
            | AssemblyAiAsrSettings
            | SpeechmaticsAsrSettings;
          /** Placeholder text to use when speech is unintelligible or cannot be transcribed */
          unintelligiblePlaceholder?: string;
          /** Whether to enable voice activity detection to automatically start/stop recording based on speech presence */
          voiceActivityDetection?: boolean;
          /** Server-side VAD configuration. When set, the server autonomously detects speech boundaries — clients send continuous audio without calling start/end_user_voice_input. */
          serverVad?: ServerVadConfig;
        } | null;
        /** Whether conversations can accept voice input (requires asrConfig fully populated) */
        acceptVoice: boolean;
        /** Whether conversations generate voice responses (requires ttsConfig fully populated in Stages) */
        generateVoice: boolean;
        /** Storage configuration for conversation artifacts */
        storageConfig?: {
          /** ID of the storage provider (e.g., "s3-provider", "azure-blob-provider") */
          storageProviderId?: string;
          /** Storage-specific settings including bucket, prefix, etc. */
          settings?:
            | S3StorageSettings
            | AzureBlobStorageSettings
            | GcsStorageSettings
            | LocalStorageSettings;
        } | null;
        /** Content moderation configuration */
        moderationConfig: {
          /** Whether content moderation is enabled for this project */
          enabled: boolean;
          /** ID of the LLM provider used for moderation (must support moderation API, e.g. OpenAI or Mistral) */
          llmProviderId: string;
          /** List of category names that should cause the input to be blocked. If omitted or empty, any flagged category will block the input. Category names are provider-specific. OpenAI categories: harassment, harassment/threatening, hate, hate/threatening, illicit, illicit/violent, self-harm, self-harm/instructions, self-harm/intent, sexual, sexual/minors, violence, violence/graphic. Mistral categories: sexual, hate_and_discrimination, violence_and_threats, dangerous_and_criminal_content, selfharm, health, financial, law, pii. */
          blockedCategories?: string[];
          /** Moderation execution mode. "strict" (default): moderation runs before all other processing — the turn is held until the moderation result is available. "standard": moderation runs after filler generation, in parallel with classification/knowledge retrieval (processTextInput), reducing perceived latency while still blocking flagged input before classification results are acted upon. */
          mode?: "strict" | "standard";
        } | null;
        /** Project-level LLM token cost management configuration */
        costManagementConfig: CostManagementConfig;
        /** Key-value store of constants used in templating and conversation logic */
        constants: Record<string, ParameterValue>;
        /** Additional metadata for the project */
        metadata: Record<string, any>;
        /** IANA timezone identifier used as the default for conversations in this project, e.g. Europe/Warsaw or America/New_York. Null means UTC. */
        timezone: string | null;
        /** ISO language code for the project, e.g. en-US or pl-PL. Null if not set. */
        languageCode: string | null;
        /** When enabled, users are automatically created on first WebSocket connection if they do not exist, using the provided user ID and an empty profile */
        autoCreateUsers: boolean;
        /** Descriptors defining the data schema for user profile variables in this project */
        userProfileVariableDescriptors: FieldDescriptor[];
        /** ID of the classifier used to evaluate guardrails for all conversations in this project */
        defaultGuardrailClassifierId: string | null;
        /** Sample copy configuration including the default classifier used to evaluate prompt triggers. */
        sampleCopyConfig?: {
          /** ID of the classifier used to evaluate sample copy prompt triggers for all stages in this project. Individual sample copies can override this with classifierOverrideId. */
          defaultClassifierId?: string;
        } | null;
        /** Project builder AI assistant configuration */
        builderConfig?: {
          /** ID of the LLM provider used to power the project builder AI assistant */
          llmProviderId: string;
          /** LLM provider-specific settings for the project builder assistant */
          llmSettings?:
            | OpenAILlmSettings
            | OpenAILegacyLlmSettings
            | AnthropicLlmSettings
            | GeminiLlmSettings
            | GroqLlmSettings
            | MistralLlmSettings
            | DeepSeekLlmSettings
            | OpenRouterLlmSettings
            | TogetherAILlmSettings
            | FireworksAILlmSettings
            | PerplexityLlmSettings
            | CohereLlmSettings
            | XAILlmSettings
            | OllamaLlmSettings;
          /** Deprecated - for backward compatibility; ignored if llmSettings.model is present. The model to use for the project builder assistant. This field is ignored if llmSettings.model is provided, which takes precedence. */
          llmModel?: string;
          /** Per-entity-category LLM provider and settings overrides. When set for a category, the builder will prefer that provider and model over the global default when proposing entities of that type. */
          hints?: {
            /** LLM override for stage entities */
            stages?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for classifier entities */
            classifiers?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for context transformer entities */
            transformers?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for tool entities */
            tools?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
          };
        } | null;
        /** ID of the stage to start new conversations at when no stageId is provided at conversation start time. Null means no default is set. */
        startingStageId: string | null;
        /** Timeout in seconds for active conversations with no activity. Null or 0 means no timeout. */
        conversationTimeoutSeconds: number | null;
        /** ID of the methodology assigned to this project, or null if none is assigned */
        methodologyId: string | null;
        /** The version number of the project */
        version: number;
        /**
         * The timestamp when the project was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * The timestamp when the project was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /**
         * The timestamp when the project was archived, or null if the project is not archived
         * @format date-time
         */
        archivedAt: string | null;
        /** The ID of the operator who archived the project, or null if the project is not archived */
        archivedBy: string | null;
      },
      void
    >({
      path: `/api/projects/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a project and all its associated entities
   *
   * @tags Projects
   * @name ProjectsDelete
   * @summary Delete project
   * @request DELETE:/api/projects/{id}
   * @secure
   */
  projectsDelete = (id: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/projects/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Archives a project. Archived projects cannot be modified. Pass current version for optimistic locking.
   *
   * @tags Projects
   * @name ProjectsArchiveCreate
   * @summary Archive project
   * @request POST:/api/projects/{id}/archive
   * @secure
   */
  projectsArchiveCreate = (
    id: string,
    data: {
      /** The current version number for optimistic locking */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** The unique identifier of the project */
        id: string;
        /** The name of the project */
        name: string;
        /** A description of the project */
        description: string | null;
        /** ASR configuration settings */
        asrConfig?: {
          /** ID of the ASR provider (e.g., "azure-speech", "openai-whisper") */
          asrProviderId?: string;
          /** ASR-specific settings including model, language preferences, etc. */
          settings?:
            | AzureAsrSettings
            | ElevenLabsAsrSettings
            | DeepgramAsrSettings
            | AssemblyAiAsrSettings
            | SpeechmaticsAsrSettings;
          /** Placeholder text to use when speech is unintelligible or cannot be transcribed */
          unintelligiblePlaceholder?: string;
          /** Whether to enable voice activity detection to automatically start/stop recording based on speech presence */
          voiceActivityDetection?: boolean;
          /** Server-side VAD configuration. When set, the server autonomously detects speech boundaries — clients send continuous audio without calling start/end_user_voice_input. */
          serverVad?: ServerVadConfig;
        } | null;
        /** Whether conversations can accept voice input (requires asrConfig fully populated) */
        acceptVoice: boolean;
        /** Whether conversations generate voice responses (requires ttsConfig fully populated in Stages) */
        generateVoice: boolean;
        /** Storage configuration for conversation artifacts */
        storageConfig?: {
          /** ID of the storage provider (e.g., "s3-provider", "azure-blob-provider") */
          storageProviderId?: string;
          /** Storage-specific settings including bucket, prefix, etc. */
          settings?:
            | S3StorageSettings
            | AzureBlobStorageSettings
            | GcsStorageSettings
            | LocalStorageSettings;
        } | null;
        /** Content moderation configuration */
        moderationConfig: {
          /** Whether content moderation is enabled for this project */
          enabled: boolean;
          /** ID of the LLM provider used for moderation (must support moderation API, e.g. OpenAI or Mistral) */
          llmProviderId: string;
          /** List of category names that should cause the input to be blocked. If omitted or empty, any flagged category will block the input. Category names are provider-specific. OpenAI categories: harassment, harassment/threatening, hate, hate/threatening, illicit, illicit/violent, self-harm, self-harm/instructions, self-harm/intent, sexual, sexual/minors, violence, violence/graphic. Mistral categories: sexual, hate_and_discrimination, violence_and_threats, dangerous_and_criminal_content, selfharm, health, financial, law, pii. */
          blockedCategories?: string[];
          /** Moderation execution mode. "strict" (default): moderation runs before all other processing — the turn is held until the moderation result is available. "standard": moderation runs after filler generation, in parallel with classification/knowledge retrieval (processTextInput), reducing perceived latency while still blocking flagged input before classification results are acted upon. */
          mode?: "strict" | "standard";
        } | null;
        /** Project-level LLM token cost management configuration */
        costManagementConfig: CostManagementConfig;
        /** Key-value store of constants used in templating and conversation logic */
        constants: Record<string, ParameterValue>;
        /** Additional metadata for the project */
        metadata: Record<string, any>;
        /** IANA timezone identifier used as the default for conversations in this project, e.g. Europe/Warsaw or America/New_York. Null means UTC. */
        timezone: string | null;
        /** ISO language code for the project, e.g. en-US or pl-PL. Null if not set. */
        languageCode: string | null;
        /** When enabled, users are automatically created on first WebSocket connection if they do not exist, using the provided user ID and an empty profile */
        autoCreateUsers: boolean;
        /** Descriptors defining the data schema for user profile variables in this project */
        userProfileVariableDescriptors: FieldDescriptor[];
        /** ID of the classifier used to evaluate guardrails for all conversations in this project */
        defaultGuardrailClassifierId: string | null;
        /** Sample copy configuration including the default classifier used to evaluate prompt triggers. */
        sampleCopyConfig?: {
          /** ID of the classifier used to evaluate sample copy prompt triggers for all stages in this project. Individual sample copies can override this with classifierOverrideId. */
          defaultClassifierId?: string;
        } | null;
        /** Project builder AI assistant configuration */
        builderConfig?: {
          /** ID of the LLM provider used to power the project builder AI assistant */
          llmProviderId: string;
          /** LLM provider-specific settings for the project builder assistant */
          llmSettings?:
            | OpenAILlmSettings
            | OpenAILegacyLlmSettings
            | AnthropicLlmSettings
            | GeminiLlmSettings
            | GroqLlmSettings
            | MistralLlmSettings
            | DeepSeekLlmSettings
            | OpenRouterLlmSettings
            | TogetherAILlmSettings
            | FireworksAILlmSettings
            | PerplexityLlmSettings
            | CohereLlmSettings
            | XAILlmSettings
            | OllamaLlmSettings;
          /** Deprecated - for backward compatibility; ignored if llmSettings.model is present. The model to use for the project builder assistant. This field is ignored if llmSettings.model is provided, which takes precedence. */
          llmModel?: string;
          /** Per-entity-category LLM provider and settings overrides. When set for a category, the builder will prefer that provider and model over the global default when proposing entities of that type. */
          hints?: {
            /** LLM override for stage entities */
            stages?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for classifier entities */
            classifiers?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for context transformer entities */
            transformers?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for tool entities */
            tools?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
          };
        } | null;
        /** ID of the stage to start new conversations at when no stageId is provided at conversation start time. Null means no default is set. */
        startingStageId: string | null;
        /** Timeout in seconds for active conversations with no activity. Null or 0 means no timeout. */
        conversationTimeoutSeconds: number | null;
        /** ID of the methodology assigned to this project, or null if none is assigned */
        methodologyId: string | null;
        /** The version number of the project */
        version: number;
        /**
         * The timestamp when the project was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * The timestamp when the project was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /**
         * The timestamp when the project was archived, or null if the project is not archived
         * @format date-time
         */
        archivedAt: string | null;
        /** The ID of the operator who archived the project, or null if the project is not archived */
        archivedBy: string | null;
      },
      void
    >({
      path: `/api/projects/${id}/archive`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Restores an archived project to active status. Pass current version for optimistic locking.
   *
   * @tags Projects
   * @name ProjectsUnarchiveCreate
   * @summary Unarchive project
   * @request POST:/api/projects/{id}/unarchive
   * @secure
   */
  projectsUnarchiveCreate = (
    id: string,
    data: {
      /** The current version number for optimistic locking */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** The unique identifier of the project */
        id: string;
        /** The name of the project */
        name: string;
        /** A description of the project */
        description: string | null;
        /** ASR configuration settings */
        asrConfig?: {
          /** ID of the ASR provider (e.g., "azure-speech", "openai-whisper") */
          asrProviderId?: string;
          /** ASR-specific settings including model, language preferences, etc. */
          settings?:
            | AzureAsrSettings
            | ElevenLabsAsrSettings
            | DeepgramAsrSettings
            | AssemblyAiAsrSettings
            | SpeechmaticsAsrSettings;
          /** Placeholder text to use when speech is unintelligible or cannot be transcribed */
          unintelligiblePlaceholder?: string;
          /** Whether to enable voice activity detection to automatically start/stop recording based on speech presence */
          voiceActivityDetection?: boolean;
          /** Server-side VAD configuration. When set, the server autonomously detects speech boundaries — clients send continuous audio without calling start/end_user_voice_input. */
          serverVad?: ServerVadConfig;
        } | null;
        /** Whether conversations can accept voice input (requires asrConfig fully populated) */
        acceptVoice: boolean;
        /** Whether conversations generate voice responses (requires ttsConfig fully populated in Stages) */
        generateVoice: boolean;
        /** Storage configuration for conversation artifacts */
        storageConfig?: {
          /** ID of the storage provider (e.g., "s3-provider", "azure-blob-provider") */
          storageProviderId?: string;
          /** Storage-specific settings including bucket, prefix, etc. */
          settings?:
            | S3StorageSettings
            | AzureBlobStorageSettings
            | GcsStorageSettings
            | LocalStorageSettings;
        } | null;
        /** Content moderation configuration */
        moderationConfig: {
          /** Whether content moderation is enabled for this project */
          enabled: boolean;
          /** ID of the LLM provider used for moderation (must support moderation API, e.g. OpenAI or Mistral) */
          llmProviderId: string;
          /** List of category names that should cause the input to be blocked. If omitted or empty, any flagged category will block the input. Category names are provider-specific. OpenAI categories: harassment, harassment/threatening, hate, hate/threatening, illicit, illicit/violent, self-harm, self-harm/instructions, self-harm/intent, sexual, sexual/minors, violence, violence/graphic. Mistral categories: sexual, hate_and_discrimination, violence_and_threats, dangerous_and_criminal_content, selfharm, health, financial, law, pii. */
          blockedCategories?: string[];
          /** Moderation execution mode. "strict" (default): moderation runs before all other processing — the turn is held until the moderation result is available. "standard": moderation runs after filler generation, in parallel with classification/knowledge retrieval (processTextInput), reducing perceived latency while still blocking flagged input before classification results are acted upon. */
          mode?: "strict" | "standard";
        } | null;
        /** Project-level LLM token cost management configuration */
        costManagementConfig: CostManagementConfig;
        /** Key-value store of constants used in templating and conversation logic */
        constants: Record<string, ParameterValue>;
        /** Additional metadata for the project */
        metadata: Record<string, any>;
        /** IANA timezone identifier used as the default for conversations in this project, e.g. Europe/Warsaw or America/New_York. Null means UTC. */
        timezone: string | null;
        /** ISO language code for the project, e.g. en-US or pl-PL. Null if not set. */
        languageCode: string | null;
        /** When enabled, users are automatically created on first WebSocket connection if they do not exist, using the provided user ID and an empty profile */
        autoCreateUsers: boolean;
        /** Descriptors defining the data schema for user profile variables in this project */
        userProfileVariableDescriptors: FieldDescriptor[];
        /** ID of the classifier used to evaluate guardrails for all conversations in this project */
        defaultGuardrailClassifierId: string | null;
        /** Sample copy configuration including the default classifier used to evaluate prompt triggers. */
        sampleCopyConfig?: {
          /** ID of the classifier used to evaluate sample copy prompt triggers for all stages in this project. Individual sample copies can override this with classifierOverrideId. */
          defaultClassifierId?: string;
        } | null;
        /** Project builder AI assistant configuration */
        builderConfig?: {
          /** ID of the LLM provider used to power the project builder AI assistant */
          llmProviderId: string;
          /** LLM provider-specific settings for the project builder assistant */
          llmSettings?:
            | OpenAILlmSettings
            | OpenAILegacyLlmSettings
            | AnthropicLlmSettings
            | GeminiLlmSettings
            | GroqLlmSettings
            | MistralLlmSettings
            | DeepSeekLlmSettings
            | OpenRouterLlmSettings
            | TogetherAILlmSettings
            | FireworksAILlmSettings
            | PerplexityLlmSettings
            | CohereLlmSettings
            | XAILlmSettings
            | OllamaLlmSettings;
          /** Deprecated - for backward compatibility; ignored if llmSettings.model is present. The model to use for the project builder assistant. This field is ignored if llmSettings.model is provided, which takes precedence. */
          llmModel?: string;
          /** Per-entity-category LLM provider and settings overrides. When set for a category, the builder will prefer that provider and model over the global default when proposing entities of that type. */
          hints?: {
            /** LLM override for stage entities */
            stages?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for classifier entities */
            classifiers?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for context transformer entities */
            transformers?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for tool entities */
            tools?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
          };
        } | null;
        /** ID of the stage to start new conversations at when no stageId is provided at conversation start time. Null means no default is set. */
        startingStageId: string | null;
        /** Timeout in seconds for active conversations with no activity. Null or 0 means no timeout. */
        conversationTimeoutSeconds: number | null;
        /** ID of the methodology assigned to this project, or null if none is assigned */
        methodologyId: string | null;
        /** The version number of the project */
        version: number;
        /**
         * The timestamp when the project was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * The timestamp when the project was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /**
         * The timestamp when the project was archived, or null if the project is not archived
         * @format date-time
         */
        archivedAt: string | null;
        /** The ID of the operator who archived the project, or null if the project is not archived */
        archivedBy: string | null;
      },
      void
    >({
      path: `/api/projects/${id}/unarchive`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific project
   *
   * @tags Projects
   * @name ProjectsAuditLogsList
   * @summary Get project audit logs
   * @request GET:/api/projects/{id}/audit-logs
   * @secure
   */
  projectsAuditLogsList = (id: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/projects/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Assigns a methodology to the project. Optionally creates empty document stubs for each category in the methodology.
   *
   * @tags Projects
   * @name ProjectsMethodologyCreate
   * @summary Assign methodology to project
   * @request POST:/api/projects/{id}/methodology
   * @secure
   */
  projectsMethodologyCreate = (
    id: string,
    data: {
      /** ID of the methodology to assign to the project */
      methodologyId: string;
      /**
       * When true, creates empty document stubs for each category in the methodology (skips categories that already have at least one document)
       * @default false
       */
      createStubs?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** The unique identifier of the project */
        id: string;
        /** The name of the project */
        name: string;
        /** A description of the project */
        description: string | null;
        /** ASR configuration settings */
        asrConfig?: {
          /** ID of the ASR provider (e.g., "azure-speech", "openai-whisper") */
          asrProviderId?: string;
          /** ASR-specific settings including model, language preferences, etc. */
          settings?:
            | AzureAsrSettings
            | ElevenLabsAsrSettings
            | DeepgramAsrSettings
            | AssemblyAiAsrSettings
            | SpeechmaticsAsrSettings;
          /** Placeholder text to use when speech is unintelligible or cannot be transcribed */
          unintelligiblePlaceholder?: string;
          /** Whether to enable voice activity detection to automatically start/stop recording based on speech presence */
          voiceActivityDetection?: boolean;
          /** Server-side VAD configuration. When set, the server autonomously detects speech boundaries — clients send continuous audio without calling start/end_user_voice_input. */
          serverVad?: ServerVadConfig;
        } | null;
        /** Whether conversations can accept voice input (requires asrConfig fully populated) */
        acceptVoice: boolean;
        /** Whether conversations generate voice responses (requires ttsConfig fully populated in Stages) */
        generateVoice: boolean;
        /** Storage configuration for conversation artifacts */
        storageConfig?: {
          /** ID of the storage provider (e.g., "s3-provider", "azure-blob-provider") */
          storageProviderId?: string;
          /** Storage-specific settings including bucket, prefix, etc. */
          settings?:
            | S3StorageSettings
            | AzureBlobStorageSettings
            | GcsStorageSettings
            | LocalStorageSettings;
        } | null;
        /** Content moderation configuration */
        moderationConfig: {
          /** Whether content moderation is enabled for this project */
          enabled: boolean;
          /** ID of the LLM provider used for moderation (must support moderation API, e.g. OpenAI or Mistral) */
          llmProviderId: string;
          /** List of category names that should cause the input to be blocked. If omitted or empty, any flagged category will block the input. Category names are provider-specific. OpenAI categories: harassment, harassment/threatening, hate, hate/threatening, illicit, illicit/violent, self-harm, self-harm/instructions, self-harm/intent, sexual, sexual/minors, violence, violence/graphic. Mistral categories: sexual, hate_and_discrimination, violence_and_threats, dangerous_and_criminal_content, selfharm, health, financial, law, pii. */
          blockedCategories?: string[];
          /** Moderation execution mode. "strict" (default): moderation runs before all other processing — the turn is held until the moderation result is available. "standard": moderation runs after filler generation, in parallel with classification/knowledge retrieval (processTextInput), reducing perceived latency while still blocking flagged input before classification results are acted upon. */
          mode?: "strict" | "standard";
        } | null;
        /** Project-level LLM token cost management configuration */
        costManagementConfig: CostManagementConfig;
        /** Key-value store of constants used in templating and conversation logic */
        constants: Record<string, ParameterValue>;
        /** Additional metadata for the project */
        metadata: Record<string, any>;
        /** IANA timezone identifier used as the default for conversations in this project, e.g. Europe/Warsaw or America/New_York. Null means UTC. */
        timezone: string | null;
        /** ISO language code for the project, e.g. en-US or pl-PL. Null if not set. */
        languageCode: string | null;
        /** When enabled, users are automatically created on first WebSocket connection if they do not exist, using the provided user ID and an empty profile */
        autoCreateUsers: boolean;
        /** Descriptors defining the data schema for user profile variables in this project */
        userProfileVariableDescriptors: FieldDescriptor[];
        /** ID of the classifier used to evaluate guardrails for all conversations in this project */
        defaultGuardrailClassifierId: string | null;
        /** Sample copy configuration including the default classifier used to evaluate prompt triggers. */
        sampleCopyConfig?: {
          /** ID of the classifier used to evaluate sample copy prompt triggers for all stages in this project. Individual sample copies can override this with classifierOverrideId. */
          defaultClassifierId?: string;
        } | null;
        /** Project builder AI assistant configuration */
        builderConfig?: {
          /** ID of the LLM provider used to power the project builder AI assistant */
          llmProviderId: string;
          /** LLM provider-specific settings for the project builder assistant */
          llmSettings?:
            | OpenAILlmSettings
            | OpenAILegacyLlmSettings
            | AnthropicLlmSettings
            | GeminiLlmSettings
            | GroqLlmSettings
            | MistralLlmSettings
            | DeepSeekLlmSettings
            | OpenRouterLlmSettings
            | TogetherAILlmSettings
            | FireworksAILlmSettings
            | PerplexityLlmSettings
            | CohereLlmSettings
            | XAILlmSettings
            | OllamaLlmSettings;
          /** Deprecated - for backward compatibility; ignored if llmSettings.model is present. The model to use for the project builder assistant. This field is ignored if llmSettings.model is provided, which takes precedence. */
          llmModel?: string;
          /** Per-entity-category LLM provider and settings overrides. When set for a category, the builder will prefer that provider and model over the global default when proposing entities of that type. */
          hints?: {
            /** LLM override for stage entities */
            stages?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for classifier entities */
            classifiers?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for context transformer entities */
            transformers?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for tool entities */
            tools?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
          };
        } | null;
        /** ID of the stage to start new conversations at when no stageId is provided at conversation start time. Null means no default is set. */
        startingStageId: string | null;
        /** Timeout in seconds for active conversations with no activity. Null or 0 means no timeout. */
        conversationTimeoutSeconds: number | null;
        /** ID of the methodology assigned to this project, or null if none is assigned */
        methodologyId: string | null;
        /** The version number of the project */
        version: number;
        /**
         * The timestamp when the project was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * The timestamp when the project was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /**
         * The timestamp when the project was archived, or null if the project is not archived
         * @format date-time
         */
        archivedAt: string | null;
        /** The ID of the operator who archived the project, or null if the project is not archived */
        archivedBy: string | null;
      },
      void
    >({
      path: `/api/projects/${id}/methodology`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Removes the methodology assignment from the project using optimistic locking via the version query parameter.
   *
   * @tags Projects
   * @name ProjectsMethodologyDelete
   * @summary Unassign methodology from project
   * @request DELETE:/api/projects/{id}/methodology
   * @secure
   */
  projectsMethodologyDelete = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        /** The unique identifier of the project */
        id: string;
        /** The name of the project */
        name: string;
        /** A description of the project */
        description: string | null;
        /** ASR configuration settings */
        asrConfig?: {
          /** ID of the ASR provider (e.g., "azure-speech", "openai-whisper") */
          asrProviderId?: string;
          /** ASR-specific settings including model, language preferences, etc. */
          settings?:
            | AzureAsrSettings
            | ElevenLabsAsrSettings
            | DeepgramAsrSettings
            | AssemblyAiAsrSettings
            | SpeechmaticsAsrSettings;
          /** Placeholder text to use when speech is unintelligible or cannot be transcribed */
          unintelligiblePlaceholder?: string;
          /** Whether to enable voice activity detection to automatically start/stop recording based on speech presence */
          voiceActivityDetection?: boolean;
          /** Server-side VAD configuration. When set, the server autonomously detects speech boundaries — clients send continuous audio without calling start/end_user_voice_input. */
          serverVad?: ServerVadConfig;
        } | null;
        /** Whether conversations can accept voice input (requires asrConfig fully populated) */
        acceptVoice: boolean;
        /** Whether conversations generate voice responses (requires ttsConfig fully populated in Stages) */
        generateVoice: boolean;
        /** Storage configuration for conversation artifacts */
        storageConfig?: {
          /** ID of the storage provider (e.g., "s3-provider", "azure-blob-provider") */
          storageProviderId?: string;
          /** Storage-specific settings including bucket, prefix, etc. */
          settings?:
            | S3StorageSettings
            | AzureBlobStorageSettings
            | GcsStorageSettings
            | LocalStorageSettings;
        } | null;
        /** Content moderation configuration */
        moderationConfig: {
          /** Whether content moderation is enabled for this project */
          enabled: boolean;
          /** ID of the LLM provider used for moderation (must support moderation API, e.g. OpenAI or Mistral) */
          llmProviderId: string;
          /** List of category names that should cause the input to be blocked. If omitted or empty, any flagged category will block the input. Category names are provider-specific. OpenAI categories: harassment, harassment/threatening, hate, hate/threatening, illicit, illicit/violent, self-harm, self-harm/instructions, self-harm/intent, sexual, sexual/minors, violence, violence/graphic. Mistral categories: sexual, hate_and_discrimination, violence_and_threats, dangerous_and_criminal_content, selfharm, health, financial, law, pii. */
          blockedCategories?: string[];
          /** Moderation execution mode. "strict" (default): moderation runs before all other processing — the turn is held until the moderation result is available. "standard": moderation runs after filler generation, in parallel with classification/knowledge retrieval (processTextInput), reducing perceived latency while still blocking flagged input before classification results are acted upon. */
          mode?: "strict" | "standard";
        } | null;
        /** Project-level LLM token cost management configuration */
        costManagementConfig: CostManagementConfig;
        /** Key-value store of constants used in templating and conversation logic */
        constants: Record<string, ParameterValue>;
        /** Additional metadata for the project */
        metadata: Record<string, any>;
        /** IANA timezone identifier used as the default for conversations in this project, e.g. Europe/Warsaw or America/New_York. Null means UTC. */
        timezone: string | null;
        /** ISO language code for the project, e.g. en-US or pl-PL. Null if not set. */
        languageCode: string | null;
        /** When enabled, users are automatically created on first WebSocket connection if they do not exist, using the provided user ID and an empty profile */
        autoCreateUsers: boolean;
        /** Descriptors defining the data schema for user profile variables in this project */
        userProfileVariableDescriptors: FieldDescriptor[];
        /** ID of the classifier used to evaluate guardrails for all conversations in this project */
        defaultGuardrailClassifierId: string | null;
        /** Sample copy configuration including the default classifier used to evaluate prompt triggers. */
        sampleCopyConfig?: {
          /** ID of the classifier used to evaluate sample copy prompt triggers for all stages in this project. Individual sample copies can override this with classifierOverrideId. */
          defaultClassifierId?: string;
        } | null;
        /** Project builder AI assistant configuration */
        builderConfig?: {
          /** ID of the LLM provider used to power the project builder AI assistant */
          llmProviderId: string;
          /** LLM provider-specific settings for the project builder assistant */
          llmSettings?:
            | OpenAILlmSettings
            | OpenAILegacyLlmSettings
            | AnthropicLlmSettings
            | GeminiLlmSettings
            | GroqLlmSettings
            | MistralLlmSettings
            | DeepSeekLlmSettings
            | OpenRouterLlmSettings
            | TogetherAILlmSettings
            | FireworksAILlmSettings
            | PerplexityLlmSettings
            | CohereLlmSettings
            | XAILlmSettings
            | OllamaLlmSettings;
          /** Deprecated - for backward compatibility; ignored if llmSettings.model is present. The model to use for the project builder assistant. This field is ignored if llmSettings.model is provided, which takes precedence. */
          llmModel?: string;
          /** Per-entity-category LLM provider and settings overrides. When set for a category, the builder will prefer that provider and model over the global default when proposing entities of that type. */
          hints?: {
            /** LLM override for stage entities */
            stages?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for classifier entities */
            classifiers?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for context transformer entities */
            transformers?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
            /** LLM override for tool entities */
            tools?: {
              /** ID of the LLM provider to use for this entity category */
              llmProviderId?: string;
              /** LLM provider-specific settings for this entity category */
              llmSettings?:
                | OpenAILlmSettings
                | OpenAILegacyLlmSettings
                | AnthropicLlmSettings
                | GeminiLlmSettings
                | GroqLlmSettings
                | MistralLlmSettings
                | DeepSeekLlmSettings
                | OpenRouterLlmSettings
                | TogetherAILlmSettings
                | FireworksAILlmSettings
                | PerplexityLlmSettings
                | CohereLlmSettings
                | XAILlmSettings
                | OllamaLlmSettings;
              /** Human-readable name of the model (e.g. "Claude 3.5 Haiku"). Used in builder prompt hints so the AI can reference the model by name. */
              modelDisplayName?: string;
            };
          };
        } | null;
        /** ID of the stage to start new conversations at when no stageId is provided at conversation start time. Null means no default is set. */
        startingStageId: string | null;
        /** Timeout in seconds for active conversations with no activity. Null or 0 means no timeout. */
        conversationTimeoutSeconds: number | null;
        /** ID of the methodology assigned to this project, or null if none is assigned */
        methodologyId: string | null;
        /** The version number of the project */
        version: number;
        /**
         * The timestamp when the project was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * The timestamp when the project was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /**
         * The timestamp when the project was archived, or null if the project is not archived
         * @format date-time
         */
        archivedAt: string | null;
        /** The ID of the operator who archived the project, or null if the project is not archived */
        archivedBy: string | null;
      },
      void
    >({
      path: `/api/projects/${id}/methodology`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of audit logs with optional filtering by entity type, action, user, or date range. Use filters for precise queries: entityType, action (CREATE/UPDATE/DELETE), userId, entityId, or date ranges with operators (gte, lte, between).
   *
   * @tags Audit Logs
   * @name AuditLogsList
   * @summary List audit logs
   * @request GET:/api/audit-logs
   * @secure
   */
  auditLogsList = (
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of audit logs in the current page */
        items: {
          /** Unique identifier for the audit log entry */
          id: string;
          /** ID of the operator user who performed the action */
          userId: string | null;
          /** Action performed (CREATE, UPDATE, DELETE) */
          action: string;
          /** ID of the entity that was modified */
          entityId: string;
          /** Type of the entity (e.g., "operator", "agent", "classifier") */
          entityType: string;
          /** ID of the project associated with the entity */
          projectId: string | null;
          /** Entity state before the change */
          oldEntity: Record<string, any>;
          /** Entity state after the change */
          newEntity: Record<string, any>;
          /**
           * Timestamp when the audit log was created
           * @format date-time
           */
          createdAt: string | null;
        }[];
        /**
         * Total number of audit logs matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/audit-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns aggregated latency statistics (avg, median, p95, min, max) for key turn-level metrics across conversations in the project. Supports filtering by date range, stage, and input source.
   *
   * @tags Analytics
   * @name ProjectsAnalyticsLatencyList
   * @summary Get aggregated latency statistics
   * @request GET:/api/projects/{projectId}/analytics/latency
   * @secure
   */
  projectsAnalyticsLatencyList = (
    projectId: string,
    query?: {
      /**
       * Start of the date range (inclusive). ISO 8601 format.
       * @format date-time
       */
      from?: string | null;
      /**
       * End of the date range (inclusive). ISO 8601 format.
       * @format date-time
       */
      to?: string | null;
      /** Filter by stage ID */
      stageId?: string;
      /** Filter by input source (text or voice) */
      source?: "text" | "voice";
    },
    params: RequestParams = {},
  ) =>
    this.request<LatencyStatsResponse, void>({
      path: `/api/projects/${projectId}/analytics/latency`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns percentile distributions (p50, p75, p90, p95, p99) for key turn-level duration metrics. Useful for understanding latency spread and tail performance.
   *
   * @tags Analytics
   * @name ProjectsAnalyticsLatencyPercentilesList
   * @summary Get latency percentile distributions
   * @request GET:/api/projects/{projectId}/analytics/latency/percentiles
   * @secure
   */
  projectsAnalyticsLatencyPercentilesList = (
    projectId: string,
    query?: {
      /**
       * Start of the date range (inclusive). ISO 8601 format.
       * @format date-time
       */
      from?: string | null;
      /**
       * End of the date range (inclusive). ISO 8601 format.
       * @format date-time
       */
      to?: string | null;
      /** Filter by stage ID */
      stageId?: string;
      /** Filter by input source (text or voice) */
      source?: "text" | "voice";
    },
    params: RequestParams = {},
  ) =>
    this.request<LatencyPercentilesResponse, void>({
      path: `/api/projects/${projectId}/analytics/latency/percentiles`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns a time-series of average latency values bucketed by the specified interval (hour, day, or week). Useful for detecting latency regressions or improvements over time.
   *
   * @tags Analytics
   * @name ProjectsAnalyticsLatencyTrendList
   * @summary Get latency trend over time
   * @request GET:/api/projects/{projectId}/analytics/latency/trend
   * @secure
   */
  projectsAnalyticsLatencyTrendList = (
    projectId: string,
    query?: {
      /**
       * Start of the date range (inclusive). ISO 8601 format.
       * @format date-time
       */
      from?: string | null;
      /**
       * End of the date range (inclusive). ISO 8601 format.
       * @format date-time
       */
      to?: string | null;
      /** Filter by stage ID */
      stageId?: string;
      /** Filter by input source (text or voice) */
      source?: "text" | "voice";
      /**
       * Time bucket interval for the trend (hour, day, or week)
       * @default "day"
       */
      interval?: "hour" | "day" | "week";
    },
    params: RequestParams = {},
  ) =>
    this.request<LatencyTrendResponse, void>({
      path: `/api/projects/${projectId}/analytics/latency/trend`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns an ordered list of per-turn timing breakdowns for a specific conversation. Each turn combines user-side and assistant-side timing into a single row for waterfall visualization.
   *
   * @tags Analytics
   * @name ProjectsAnalyticsConversationsTimelineList
   * @summary Get conversation timeline
   * @request GET:/api/projects/{projectId}/analytics/conversations/{conversationId}/timeline
   * @secure
   */
  projectsAnalyticsConversationsTimelineList = (
    projectId: string,
    conversationId: string,
    params: RequestParams = {},
  ) =>
    this.request<ConversationTimelineResponse, void>({
      path: `/api/projects/${projectId}/analytics/conversations/${conversationId}/timeline`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns aggregated LLM token usage statistics broken down by event type (message, classification, transformation, tool_call). Includes total prompt tokens, completion tokens, and combined totals.
   *
   * @tags Analytics
   * @name ProjectsAnalyticsUsageList
   * @summary Get aggregated token usage statistics
   * @request GET:/api/projects/{projectId}/analytics/usage
   * @secure
   */
  projectsAnalyticsUsageList = (
    projectId: string,
    query?: {
      /**
       * Start of the date range (inclusive). ISO 8601 format.
       * @format date-time
       */
      from?: string | null;
      /**
       * End of the date range (inclusive). ISO 8601 format.
       * @format date-time
       */
      to?: string | null;
      /** Filter by stage ID */
      stageId?: string;
      /** Filter by input source (text or voice) */
      source?: "text" | "voice";
    },
    params: RequestParams = {},
  ) =>
    this.request<TokenUsageStatsResponse, void>({
      path: `/api/projects/${projectId}/analytics/usage`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns a time-series of token consumption bucketed by the specified interval (hour, day, or week). Useful for tracking LLM usage growth and optimizing prompt costs.
   *
   * @tags Analytics
   * @name ProjectsAnalyticsUsageTrendList
   * @summary Get token usage trend over time
   * @request GET:/api/projects/{projectId}/analytics/usage/trend
   * @secure
   */
  projectsAnalyticsUsageTrendList = (
    projectId: string,
    query?: {
      /**
       * Start of the date range (inclusive). ISO 8601 format.
       * @format date-time
       */
      from?: string | null;
      /**
       * End of the date range (inclusive). ISO 8601 format.
       * @format date-time
       */
      to?: string | null;
      /** Filter by stage ID */
      stageId?: string;
      /** Filter by input source (text or voice) */
      source?: "text" | "voice";
      /**
       * Time bucket interval for the trend (hour, day, or week)
       * @default "day"
       */
      interval?: "hour" | "day" | "week";
    },
    params: RequestParams = {},
  ) =>
    this.request<TokenUsageTrendResponse, void>({
      path: `/api/projects/${projectId}/analytics/usage/trend`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the available analytics sources with their queryable dimensions and metrics. Use this to discover what can be queried via the /analytics/query endpoint.
   *
   * @tags Analytics
   * @name ProjectsAnalyticsSourcesList
   * @summary Get analytics source catalog
   * @request GET:/api/projects/{projectId}/analytics/sources
   * @secure
   */
  projectsAnalyticsSourcesList = (
    projectId: string,
    params: RequestParams = {},
  ) =>
    this.request<SourceCatalogResponse, void>({
      path: `/api/projects/${projectId}/analytics/sources`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Generic analytics query engine. Specify a source, metrics to aggregate, optional groupBy dimensions, time interval for bucketing, and filters. Use normalizeBy to enable two-phase aggregation: metrics are first summed within each unit of that dimension (e.g. conversationId), then the requested aggregation function is applied across those sums — enabling queries like "average total tokens per conversation". Returns flat rows with dimension values and computed metrics. Use GET /analytics/sources to discover available sources, dimensions, and metrics.
   *
   * @tags Analytics
   * @name ProjectsAnalyticsQueryList
   * @summary Slice-and-dice analytics query
   * @request GET:/api/projects/{projectId}/analytics/query
   * @secure
   */
  projectsAnalyticsQueryList = (
    projectId: string,
    query: {
      /** Analytics source to query */
      source:
        | "conversations"
        | "events"
        | "turns"
        | "tool_calls"
        | "classifications"
        | "transformations"
        | "moderation"
        | "stage_visits"
        | "llm_calls"
        | "actions"
        | "variables"
        | "user_profile";
      /**
       * Dimension IDs to group results by (max 5)
       * @maxItems 5
       * @default []
       */
      groupBy?: string[];
      /** Time bucket interval for time-series aggregation */
      interval?: "hour" | "day" | "week" | "month";
      /**
       * Metric specifications: "count" or "{aggFn}:{metricId}" (e.g. "avg:durationMs", "p95:totalTurnDurationMs")
       * @maxItems 10
       * @minItems 1
       */
      metrics: string[];
      /** Dimension ID to use as the inner aggregation unit for two-phase aggregation. When set, metrics are first summed within each (groupBy + normalizeBy) group, then the requested aggregation function is applied across those sums. Example: normalizeBy=conversationId with avg:promptTokens gives the average total prompt tokens per conversation. Not compatible with the bare "count" metric. */
      normalizeBy?: string;
      /** Relative time range (e.g. { amount: 7, unit: "days" }). Mutually exclusive with from/to — takes precedence if all three are provided. */
      relativeTime?: RelativeTime;
      /**
       * Start of the date range (inclusive). ISO 8601 format. Ignored when relativeTime is set.
       * @format date-time
       */
      from?: string | null;
      /**
       * End of the date range (inclusive). ISO 8601 format. Ignored when relativeTime is set.
       * @format date-time
       */
      to?: string | null;
      /** Filter to a single conversation */
      conversationId?: string;
      /** Filter analytics to conversations used by this scenario run */
      scenarioRunId?: string;
      /** Additional equality filters: key = dimension ID, value = exact match value */
      filters?: Record<string, string>;
      /**
       * Maximum number of rows to return (default 1000, max 10000)
       * @min 1
       * @max 10000
       * @default 1000
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<SliceQueryResponse, void>({
      path: `/api/projects/${projectId}/analytics/query`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the operator's own saved queries plus all shared queries within the project
   *
   * @tags Analytics
   * @name ProjectsAnalyticsSavedQueriesList
   * @summary List saved slice queries
   * @request GET:/api/projects/{projectId}/analytics/saved-queries
   * @secure
   */
  projectsAnalyticsSavedQueriesList = (
    projectId: string,
    params: RequestParams = {},
  ) =>
    this.request<SavedSliceQuery[], any>({
      path: `/api/projects/${projectId}/analytics/saved-queries`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Saves a named slice query configuration for later reuse. The name must be unique within the project.
   *
   * @tags Analytics
   * @name ProjectsAnalyticsSavedQueriesCreate
   * @summary Create a saved slice query
   * @request POST:/api/projects/{projectId}/analytics/saved-queries
   * @secure
   */
  projectsAnalyticsSavedQueriesCreate = (
    projectId: string,
    data: {
      /**
       * Unique name for this saved query within the project
       * @minLength 1
       * @maxLength 255
       */
      name: string;
      /** The full slice query configuration to save */
      query: SliceQuery;
      /**
       * Whether this query is visible to all operators in the project
       * @default false
       */
      isShared?: boolean;
      /** Arbitrary key-value metadata, e.g. chart display settings from the UI */
      metadata?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<SavedSliceQuery, void>({
      path: `/api/projects/${projectId}/analytics/saved-queries`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing saved slice query with optimistic locking. Only the owning operator or a super_admin may update.
   *
   * @tags Analytics
   * @name ProjectsAnalyticsSavedQueriesUpdate
   * @summary Update a saved slice query
   * @request PUT:/api/projects/{projectId}/analytics/saved-queries/{id}
   * @secure
   */
  projectsAnalyticsSavedQueriesUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * Updated name for this saved query
       * @minLength 1
       * @maxLength 255
       */
      name?: string;
      /** Updated slice query configuration */
      query?: SliceQuery;
      /** Updated sharing flag */
      isShared?: boolean;
      /** Arbitrary key-value metadata, e.g. chart display settings from the UI */
      metadata?: Record<string, any>;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<SavedSliceQuery, void>({
      path: `/api/projects/${projectId}/analytics/saved-queries/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a saved slice query with optimistic locking. Only the owning operator or a super_admin may delete.
   *
   * @tags Analytics
   * @name ProjectsAnalyticsSavedQueriesDelete
   * @summary Delete a saved slice query
   * @request DELETE:/api/projects/{projectId}/analytics/saved-queries/{id}
   * @secure
   */
  projectsAnalyticsSavedQueriesDelete = (
    projectId: string,
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/analytics/saved-queries/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Executes a user-centric funnel query that cascades qualifying users through ordered event steps. Returns per-step user counts and conversion rates.
   *
   * @tags Analytics
   * @name ProjectsAnalyticsFunnelsQueryCreate
   * @summary Run a funnel query
   * @request POST:/api/projects/{projectId}/analytics/funnels/query
   * @secure
   */
  projectsAnalyticsFunnelsQueryCreate = (
    projectId: string,
    query: {
      /**
       * Project identifier
       * @minLength 1
       */
      projectId: string;
      /** Filter funnels to conversations used by this scenario run */
      scenarioRunId?: string;
    },
    data: FunnelQuery,
    params: RequestParams = {},
  ) =>
    this.request<FunnelQueryResponse, void>({
      path: `/api/projects/${projectId}/analytics/funnels/query`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the operator's own saved funnel queries plus all shared queries within the project, sorted by updatedAt descending.
   *
   * @tags Analytics
   * @name ProjectsAnalyticsFunnelsSavedQueriesList
   * @summary List saved funnel queries
   * @request GET:/api/projects/{projectId}/analytics/funnels/saved-queries
   * @secure
   */
  projectsAnalyticsFunnelsSavedQueriesList = (
    projectId: string,
    params: RequestParams = {},
  ) =>
    this.request<SavedFunnelQuery[], any>({
      path: `/api/projects/${projectId}/analytics/funnels/saved-queries`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Saves a named funnel query configuration for later reuse. The name must be unique within the project.
   *
   * @tags Analytics
   * @name ProjectsAnalyticsFunnelsSavedQueriesCreate
   * @summary Create a saved funnel query
   * @request POST:/api/projects/{projectId}/analytics/funnels/saved-queries
   * @secure
   */
  projectsAnalyticsFunnelsSavedQueriesCreate = (
    projectId: string,
    data: {
      /**
       * Unique name for this saved funnel query within the project
       * @minLength 1
       * @maxLength 255
       */
      name: string;
      /** The full funnel query configuration to save */
      query: FunnelQuery;
      /**
       * Whether this query is visible to all operators in the project
       * @default false
       */
      isShared?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<SavedFunnelQuery, void>({
      path: `/api/projects/${projectId}/analytics/funnels/saved-queries`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing saved funnel query with optimistic locking. Only the owning operator or a super_admin may update.
   *
   * @tags Analytics
   * @name ProjectsAnalyticsFunnelsSavedQueriesUpdate
   * @summary Update a saved funnel query
   * @request PUT:/api/projects/{projectId}/analytics/funnels/saved-queries/{id}
   * @secure
   */
  projectsAnalyticsFunnelsSavedQueriesUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * Updated name for this saved funnel query
       * @minLength 1
       * @maxLength 255
       */
      name?: string;
      /** Updated funnel query configuration */
      query?: FunnelQuery;
      /** Updated sharing flag */
      isShared?: boolean;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<SavedFunnelQuery, void>({
      path: `/api/projects/${projectId}/analytics/funnels/saved-queries/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a saved funnel query with optimistic locking. Only the owning operator or a super_admin may delete.
   *
   * @tags Analytics
   * @name ProjectsAnalyticsFunnelsSavedQueriesDelete
   * @summary Delete a saved funnel query
   * @request DELETE:/api/projects/{projectId}/analytics/funnels/saved-queries/{id}
   * @secure
   */
  projectsAnalyticsFunnelsSavedQueriesDelete = (
    projectId: string,
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/analytics/funnels/saved-queries/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Creates a new classifier with specified name, prompt, and configuration
   *
   * @tags Classifiers
   * @name ProjectsClassifiersCreate
   * @summary Create a new classifier
   * @request POST:/api/projects/{projectId}/classifiers
   * @secure
   */
  projectsClassifiersCreate = (
    projectId: string,
    data: {
      /**
       * Unique identifier for the classifier (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Display name of the classifier
       * @minLength 1
       */
      name: string;
      /** Detailed description of the classifier's purpose and behavior */
      description?: string | null;
      /**
       * Prompt that defines the classification logic and instructions
       * @minLength 1
       */
      prompt: string;
      /**
       * ID of the LLM provider to use for this classifier
       * @minLength 1
       */
      llmProviderId: string;
      /** LLM provider-specific settings for this classifier */
      llmSettings: LlmSettings;
      /**
       * Tags for categorizing and filtering this classifier
       * @default []
       */
      tags?: string[];
      /** Additional classifier-specific metadata */
      metadata?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the classifier */
        id: string;
        /** ID of the project this classifier belongs to */
        projectId: string;
        /** Display name of the classifier */
        name: string;
        /** Detailed description of the classifier */
        description: string | null;
        /** Prompt defining the classification logic */
        prompt: string;
        /** ID of the LLM provider */
        llmProviderId: string | null;
        /** LLM provider-specific settings */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** Tags for categorizing and filtering this classifier */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the classifier was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the classifier was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/classifiers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of classifiers with optional filtering and sorting
   *
   * @tags Classifiers
   * @name ProjectsClassifiersList
   * @summary List classifiers
   * @request GET:/api/projects/{projectId}/classifiers
   * @secure
   */
  projectsClassifiersList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of classifiers in the current page */
        items: {
          /** Unique identifier for the classifier */
          id: string;
          /** ID of the project this classifier belongs to */
          projectId: string;
          /** Display name of the classifier */
          name: string;
          /** Detailed description of the classifier */
          description: string | null;
          /** Prompt defining the classification logic */
          prompt: string;
          /** ID of the LLM provider */
          llmProviderId: string | null;
          /** LLM provider-specific settings */
          llmSettings?:
            | OpenAILlmSettings
            | OpenAILegacyLlmSettings
            | AnthropicLlmSettings
            | GeminiLlmSettings
            | GroqLlmSettings
            | MistralLlmSettings
            | DeepSeekLlmSettings
            | OpenRouterLlmSettings
            | TogetherAILlmSettings
            | FireworksAILlmSettings
            | PerplexityLlmSettings
            | CohereLlmSettings
            | XAILlmSettings
            | OllamaLlmSettings;
          /** Tags for categorizing and filtering this classifier */
          tags: string[];
          /** Additional metadata */
          metadata: Record<string, any>;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the classifier was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the classifier was last updated
           * @format date-time
           */
          updatedAt: string | null;
          /** Whether this entity belongs to an archived project */
          archived?: boolean;
        }[];
        /**
         * Total number of classifiers matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/classifiers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single classifier by its unique identifier
   *
   * @tags Classifiers
   * @name ProjectsClassifiersDetail
   * @summary Get classifier by ID
   * @request GET:/api/projects/{projectId}/classifiers/{id}
   * @secure
   */
  projectsClassifiersDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the classifier */
        id: string;
        /** ID of the project this classifier belongs to */
        projectId: string;
        /** Display name of the classifier */
        name: string;
        /** Detailed description of the classifier */
        description: string | null;
        /** Prompt defining the classification logic */
        prompt: string;
        /** ID of the LLM provider */
        llmProviderId: string | null;
        /** LLM provider-specific settings */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** Tags for categorizing and filtering this classifier */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the classifier was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the classifier was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/classifiers/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing classifier with optimistic locking
   *
   * @tags Classifiers
   * @name ProjectsClassifiersUpdate
   * @summary Update classifier
   * @request PUT:/api/projects/{projectId}/classifiers/{id}
   * @secure
   */
  projectsClassifiersUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * Updated display name
       * @minLength 1
       */
      name?: string;
      /** Updated description */
      description?: string | null;
      /**
       * Updated classification prompt
       * @minLength 1
       */
      prompt?: string;
      /**
       * Updated LLM provider ID
       * @minLength 1
       */
      llmProviderId?: string;
      /** Updated LLM provider-specific settings */
      llmSettings?: LlmSettings;
      /** Updated tags */
      tags?: string[];
      /** Updated metadata */
      metadata?: Record<string, any>;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the classifier */
        id: string;
        /** ID of the project this classifier belongs to */
        projectId: string;
        /** Display name of the classifier */
        name: string;
        /** Detailed description of the classifier */
        description: string | null;
        /** Prompt defining the classification logic */
        prompt: string;
        /** ID of the LLM provider */
        llmProviderId: string | null;
        /** LLM provider-specific settings */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** Tags for categorizing and filtering this classifier */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the classifier was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the classifier was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/classifiers/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a classifier with optimistic locking
   *
   * @tags Classifiers
   * @name ProjectsClassifiersDelete
   * @summary Delete classifier
   * @request DELETE:/api/projects/{projectId}/classifiers/{id}
   * @secure
   */
  projectsClassifiersDelete = (
    projectId: string,
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/classifiers/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific classifier
   *
   * @tags Classifiers
   * @name ProjectsClassifiersAuditLogsList
   * @summary Get classifier audit logs
   * @request GET:/api/projects/{projectId}/classifiers/{id}/audit-logs
   * @secure
   */
  projectsClassifiersAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/classifiers/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a copy of an existing classifier with a new ID and optional name override
   *
   * @tags Classifiers
   * @name ProjectsClassifiersCloneCreate
   * @summary Clone classifier
   * @request POST:/api/projects/{projectId}/classifiers/{id}/clone
   * @secure
   */
  projectsClassifiersCloneCreate = (
    projectId: string,
    id: string,
    data: {
      /**
       * New ID for the cloned classifier (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Name for the cloned classifier (defaults to "{original name} (Clone)")
       * @minLength 1
       */
      name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the classifier */
        id: string;
        /** ID of the project this classifier belongs to */
        projectId: string;
        /** Display name of the classifier */
        name: string;
        /** Detailed description of the classifier */
        description: string | null;
        /** Prompt defining the classification logic */
        prompt: string;
        /** ID of the LLM provider */
        llmProviderId: string | null;
        /** LLM provider-specific settings */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** Tags for categorizing and filtering this classifier */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the classifier was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the classifier was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/classifiers/${id}/clone`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new context transformer with specified name, prompt, and configuration
   *
   * @tags Context Transformers
   * @name ProjectsContextTransformersCreate
   * @summary Create a new context transformer
   * @request POST:/api/projects/{projectId}/context-transformers
   * @secure
   */
  projectsContextTransformersCreate = (
    projectId: string,
    data: {
      /**
       * Unique identifier for the context transformer (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Display name of the context transformer
       * @minLength 1
       */
      name: string;
      /** Detailed description of the transformer's purpose and behavior */
      description?: string | null;
      /**
       * Prompt that defines the transformation logic and instructions
       * @minLength 1
       */
      prompt: string;
      /** List of context field names to be transformed */
      contextFields?: string[];
      /**
       * ID of the LLM provider to use for this transformer
       * @minLength 1
       */
      llmProviderId: string;
      /** LLM provider-specific settings for this transformer */
      llmSettings: LlmSettings;
      /**
       * Tags for categorizing and filtering this context transformer
       * @default []
       */
      tags?: string[];
      /** Additional transformer-specific metadata */
      metadata?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the context transformer */
        id: string;
        /** ID of the project this context transformer belongs to */
        projectId: string;
        /** Display name of the context transformer */
        name: string;
        /** Detailed description of the transformer */
        description: string | null;
        /** Prompt defining the transformation logic */
        prompt: string;
        /** Context field names to be transformed */
        contextFields: string[] | null;
        /** ID of the LLM provider */
        llmProviderId: string | null;
        /** LLM provider-specific settings */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** Tags for categorizing and filtering this context transformer */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the transformer was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the transformer was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/context-transformers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of context transformers with optional filtering and sorting
   *
   * @tags Context Transformers
   * @name ProjectsContextTransformersList
   * @summary List context transformers
   * @request GET:/api/projects/{projectId}/context-transformers
   * @secure
   */
  projectsContextTransformersList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of context transformers in the current page */
        items: {
          /** Unique identifier for the context transformer */
          id: string;
          /** ID of the project this context transformer belongs to */
          projectId: string;
          /** Display name of the context transformer */
          name: string;
          /** Detailed description of the transformer */
          description: string | null;
          /** Prompt defining the transformation logic */
          prompt: string;
          /** Context field names to be transformed */
          contextFields: string[] | null;
          /** ID of the LLM provider */
          llmProviderId: string | null;
          /** LLM provider-specific settings */
          llmSettings?:
            | OpenAILlmSettings
            | OpenAILegacyLlmSettings
            | AnthropicLlmSettings
            | GeminiLlmSettings
            | GroqLlmSettings
            | MistralLlmSettings
            | DeepSeekLlmSettings
            | OpenRouterLlmSettings
            | TogetherAILlmSettings
            | FireworksAILlmSettings
            | PerplexityLlmSettings
            | CohereLlmSettings
            | XAILlmSettings
            | OllamaLlmSettings;
          /** Tags for categorizing and filtering this context transformer */
          tags: string[];
          /** Additional metadata */
          metadata: Record<string, any>;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the transformer was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the transformer was last updated
           * @format date-time
           */
          updatedAt: string | null;
          /** Whether this entity belongs to an archived project */
          archived?: boolean;
        }[];
        /**
         * Total number of context transformers matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/context-transformers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single context transformer by its unique identifier
   *
   * @tags Context Transformers
   * @name ProjectsContextTransformersDetail
   * @summary Get context transformer by ID
   * @request GET:/api/projects/{projectId}/context-transformers/{id}
   * @secure
   */
  projectsContextTransformersDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the context transformer */
        id: string;
        /** ID of the project this context transformer belongs to */
        projectId: string;
        /** Display name of the context transformer */
        name: string;
        /** Detailed description of the transformer */
        description: string | null;
        /** Prompt defining the transformation logic */
        prompt: string;
        /** Context field names to be transformed */
        contextFields: string[] | null;
        /** ID of the LLM provider */
        llmProviderId: string | null;
        /** LLM provider-specific settings */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** Tags for categorizing and filtering this context transformer */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the transformer was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the transformer was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/context-transformers/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing context transformer with optimistic locking
   *
   * @tags Context Transformers
   * @name ProjectsContextTransformersUpdate
   * @summary Update context transformer
   * @request PUT:/api/projects/{projectId}/context-transformers/{id}
   * @secure
   */
  projectsContextTransformersUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * Updated display name
       * @minLength 1
       */
      name?: string;
      /** Updated description */
      description?: string | null;
      /**
       * Updated transformation prompt
       * @minLength 1
       */
      prompt?: string;
      /** Updated context field names */
      contextFields?: string[];
      /**
       * Updated LLM provider ID
       * @minLength 1
       */
      llmProviderId?: string;
      /** Updated LLM provider-specific settings */
      llmSettings?: LlmSettings;
      /** Updated tags */
      tags?: string[];
      /** Updated metadata */
      metadata?: Record<string, any>;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the context transformer */
        id: string;
        /** ID of the project this context transformer belongs to */
        projectId: string;
        /** Display name of the context transformer */
        name: string;
        /** Detailed description of the transformer */
        description: string | null;
        /** Prompt defining the transformation logic */
        prompt: string;
        /** Context field names to be transformed */
        contextFields: string[] | null;
        /** ID of the LLM provider */
        llmProviderId: string | null;
        /** LLM provider-specific settings */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** Tags for categorizing and filtering this context transformer */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the transformer was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the transformer was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/context-transformers/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a context transformer with optimistic locking
   *
   * @tags Context Transformers
   * @name ProjectsContextTransformersDelete
   * @summary Delete context transformer
   * @request DELETE:/api/projects/{projectId}/context-transformers/{id}
   * @secure
   */
  projectsContextTransformersDelete = (
    projectId: string,
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/context-transformers/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific context transformer
   *
   * @tags Context Transformers
   * @name ProjectsContextTransformersAuditLogsList
   * @summary Get context transformer audit logs
   * @request GET:/api/projects/{projectId}/context-transformers/{id}/audit-logs
   * @secure
   */
  projectsContextTransformersAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/context-transformers/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a copy of an existing context transformer with a new ID and optional name override
   *
   * @tags Context Transformers
   * @name ProjectsContextTransformersCloneCreate
   * @summary Clone context transformer
   * @request POST:/api/projects/{projectId}/context-transformers/{id}/clone
   * @secure
   */
  projectsContextTransformersCloneCreate = (
    projectId: string,
    id: string,
    data: {
      /**
       * New ID for the cloned context transformer (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Name for the cloned context transformer (defaults to "{original name} (Clone)")
       * @minLength 1
       */
      name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the context transformer */
        id: string;
        /** ID of the project this context transformer belongs to */
        projectId: string;
        /** Display name of the context transformer */
        name: string;
        /** Detailed description of the transformer */
        description: string | null;
        /** Prompt defining the transformation logic */
        prompt: string;
        /** Context field names to be transformed */
        contextFields: string[] | null;
        /** ID of the LLM provider */
        llmProviderId: string | null;
        /** LLM provider-specific settings */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** Tags for categorizing and filtering this context transformer */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the transformer was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the transformer was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/context-transformers/${id}/clone`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single conversation by its unique identifier
   *
   * @tags Conversations
   * @name ProjectsConversationsDetail
   * @summary Get conversation by ID
   * @request GET:/api/projects/{projectId}/conversations/{id}
   * @secure
   */
  projectsConversationsDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the conversation */
        id: string;
        /** Identifier of the project this conversation belongs to */
        projectId: string;
        /** Identifier of the user associated with this conversation */
        userId: string;
        /** ID of the WebSocket session that initiated this conversation */
        sessionId: string;
        /** Current stage identifier for the conversation */
        stageId: string;
        /** Stage identifier at the start of the conversation */
        startingStageId: string | null;
        /** Stage identifier when the conversation reached a terminal state (finished/failed/aborted) */
        endingStageId: string | null;
        /** Variables stored per stage in the conversation */
        stageVars: Record<string, Record<string, any>>;
        /** Current status of the conversation (e.g., initialized, active, completed, failed) */
        status: string;
        /** Optional details about the current status */
        statusDetails: string | null;
        /** Direction of the conversation – incoming (user-initiated) or outgoing (Bonsai-initiated) */
        direction: "incoming" | "outgoing";
        /** Additional metadata associated with the conversation */
        metadata: Record<string, any>;
        /**
         * Timestamp when the conversation was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the conversation was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/conversations/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a conversation and all its associated events (via cascade delete)
   *
   * @tags Conversations
   * @name ProjectsConversationsDelete
   * @summary Delete conversation
   * @request DELETE:/api/projects/{projectId}/conversations/{id}
   * @secure
   */
  projectsConversationsDelete = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/conversations/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Retrieves a paginated list of conversations with optional filtering, sorting, and search. Supports filtering by userId, sessionId, stageId, status, and timestamps.
   *
   * @tags Conversations
   * @name ProjectsConversationsList
   * @summary List conversations
   * @request GET:/api/projects/{projectId}/conversations
   * @secure
   */
  projectsConversationsList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of conversations in the current page */
        items: {
          /** Unique identifier for the conversation */
          id: string;
          /** Identifier of the project this conversation belongs to */
          projectId: string;
          /** Identifier of the user associated with this conversation */
          userId: string;
          /** ID of the WebSocket session that initiated this conversation */
          sessionId: string;
          /** Current stage identifier for the conversation */
          stageId: string;
          /** Stage identifier at the start of the conversation */
          startingStageId: string | null;
          /** Stage identifier when the conversation reached a terminal state (finished/failed/aborted) */
          endingStageId: string | null;
          /** Variables stored per stage in the conversation */
          stageVars: Record<string, Record<string, any>>;
          /** Current status of the conversation (e.g., initialized, active, completed, failed) */
          status: string;
          /** Optional details about the current status */
          statusDetails: string | null;
          /** Direction of the conversation – incoming (user-initiated) or outgoing (Bonsai-initiated) */
          direction: "incoming" | "outgoing";
          /** Additional metadata associated with the conversation */
          metadata: Record<string, any>;
          /**
           * Timestamp when the conversation was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the conversation was last updated
           * @format date-time
           */
          updatedAt: string | null;
          /** Whether this entity belongs to an archived project */
          archived?: boolean;
        }[];
        /**
         * Total number of conversations matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/conversations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of events for a specific conversation with optional filtering and sorting
   *
   * @tags Conversations
   * @name ProjectsConversationsEventsList
   * @summary List conversation events
   * @request GET:/api/projects/{projectId}/conversations/{id}/events
   * @secure
   */
  projectsConversationsEventsList = (
    projectId: string,
    id: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of conversation events in the current page */
        items: {
          /** Unique identifier for the conversation event */
          id: string;
          /** ID of the project this event belongs to */
          projectId: string;
          /** Identifier of the conversation this event belongs to */
          conversationId: string;
          /** Type of the conversation event */
          eventType:
            | "message"
            | "classification"
            | "transformation"
            | "execution_plan"
            | "action"
            | "command"
            | "tool_call"
            | "conversation_start"
            | "conversation_resume"
            | "conversation_end"
            | "conversation_aborted"
            | "conversation_failed"
            | "jump_to_stage"
            | "moderation"
            | "variables_updated"
            | "user_profile_updated"
            | "user_input_modified"
            | "user_banned"
            | "visibility_changed"
            | "sample_copy_selection"
            | "turn_aborted";
          /** Event data payload */
          eventData:
            | {
                role: "user" | "assistant";
                text: string;
                originalText: string;
                visibility?: {
                  /** Visibility setting for the message: always (always visible), stage (visible only in current stage), never (never visible), conditional (visible based on condition) */
                  visibility: "always" | "stage" | "never" | "conditional";
                  /** Condition for visibility, evaluated against conversation variables */
                  condition?: string;
                };
                metadata?: Record<string, any>;
              }
            | {
                classifierId: string;
                input: string;
                actions: {
                  classifierId: string;
                  classifierName: string;
                  actions: {
                    name: string;
                    parameters: Record<string, ParameterValue>;
                  }[];
                }[];
                metadata?: Record<string, any>;
              }
            | {
                transformerId: string;
                input: string;
                appliedFields: string[];
                metadata?: Record<string, any>;
              }
            | {
                /** ID of the stage where execution is taking place */
                stageId: string;
                /** Names of all matched actions in original order */
                actions: string[];
                /** Final ordered list of effects after filtering, sorting, and conflict resolution */
                effects: {
                  /** Name of the action this effect originates from */
                  actionName: string;
                  /** The effect to be executed */
                  effect: Effect;
                }[];
                /** Lifecycle context in which execution is taking place; null for user-input-triggered executions */
                lifecycleContext:
                  | "on_enter"
                  | "on_leave"
                  | "on_fallback"
                  | "conversation_start"
                  | "conversation_resume"
                  | "conversation_end"
                  | "conversation_abort"
                  | "conversation_failed"
                  | null;
                metadata?: Record<string, any>;
              }
            | {
                actionName: string;
                stageId: string;
                effects: Effect[];
                metadata?: Record<string, any>;
              }
            | {
                command:
                  | "go_to_stage"
                  | "set_var"
                  | "get_var"
                  | "get_all_vars"
                  | "run_action"
                  | "call_tool";
                parameters?: Record<string, ParameterValue>;
                metadata?: Record<string, any>;
              }
            | {
                toolId: string;
                toolName: string;
                toolType?: "smart_function" | "webhook" | "script";
                parameters: Record<string, ParameterValue>;
                success: boolean;
                result?: any;
                error?: string;
                /** Name of the action that triggered this tool call, if triggered by an action effect */
                sourceActionName?: string;
                metadata?: Record<string, any>;
              }
            | {
                stageId: string;
                initialVariables?: Record<string, ParameterValue>;
                metadata?: Record<string, any>;
              }
            | {
                previousStatus:
                  | "initialized"
                  | "awaiting_user_input"
                  | "receiving_user_voice"
                  | "processing_user_input"
                  | "generating_response"
                  | "finished"
                  | "aborted"
                  | "failed";
                stageId: string;
                metadata?: Record<string, any>;
              }
            | {
                reason?: string;
                stageId: string;
                /** Name of the action that triggered conversation end, if triggered by an action effect */
                sourceActionName?: string;
                metadata?: Record<string, any>;
              }
            | {
                reason: string;
                stageId: string;
                /** Name of the action that triggered conversation abort, if triggered by an action effect */
                sourceActionName?: string;
                metadata?: Record<string, any>;
              }
            | {
                reason: string;
                stageId?: string;
                metadata?: Record<string, any>;
              }
            | {
                fromStageId: string;
                toStageId: string;
                /** Name of the action that triggered this stage jump, if triggered by an action effect */
                sourceActionName?: string;
                metadata?: Record<string, any>;
              }
            | {
                input: string;
                flagged: boolean;
                blockingCategories: string[];
                detectedCategories: string[];
                durationMs: number;
                startMs: number;
                endMs: number;
                metadata?: Record<string, any>;
              }
            | {
                /** Name of the action that triggered this variable update */
                sourceActionName: string;
                /** Names of the variables that were changed by this update */
                changedVariableNames: string[];
                /** Snapshot of all conversation variables after the update */
                variables: Record<string, ParameterValue>;
                metadata?: Record<string, any>;
              }
            | {
                /** Name of the action that triggered this profile update */
                sourceActionName: string;
                /** Names of the profile fields that were changed by this update */
                changedProfileNames: string[];
                /** Updated user profile data */
                profile: Record<string, ParameterValue>;
                metadata?: Record<string, any>;
              }
            | {
                /** Name of the action that triggered this input modification */
                sourceActionName: string;
                /** The modified user input after template rendering */
                modifiedInput: string;
                metadata?: Record<string, any>;
              }
            | {
                /** Name of the action that triggered the ban */
                sourceActionName: string;
                /** Optional reason for the ban */
                reason?: string;
                metadata?: Record<string, any>;
              }
            | {
                /** Name of the action that triggered this visibility change */
                sourceActionName: string;
                /** The new visibility settings for current turn messages */
                visibility: {
                  /** Visibility setting for the message: always (always visible), stage (visible only in current stage), never (never visible), conditional (visible based on condition) */
                  visibility: "always" | "stage" | "never" | "conditional";
                  /** Condition for visibility, evaluated against conversation variables */
                  condition?: string;
                };
                metadata?: Record<string, any>;
              }
            | {
                /** ID of the classifier that performed the selection */
                classifierId: string;
                /** The user input that triggered the selection */
                input: string;
                /** Identifier of selected sample copy, or null if none was selected */
                sampleCopy: string | null;
                metadata?: Record<string, any>;
              }
            | {
                /** Identifier of the input turn that was aborted */
                inputTurnId: string;
                /** Identifier of the AI generation turn that was aborted */
                outputTurnId: string;
                /** Full text generated before the barge-in interruption */
                accumulatedText: string;
                /** Unix timestamp in milliseconds when the generation was aborted */
                abortTimestampMs: number;
                metadata?: Record<string, any>;
              };
          /** ID of the stage that was active when the event occurred */
          stageId: string | null;
          /**
           * Timestamp when the event occurred
           * @format date-time
           */
          timestamp: string | null;
          /** Additional metadata associated with the event */
          metadata: Record<string, any>;
        }[];
        /**
         * Total number of events matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/conversations/${id}/events`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a specific event for a conversation by its unique identifier
   *
   * @tags Conversations
   * @name ProjectsConversationsEventsDetail
   * @summary Get conversation event by ID
   * @request GET:/api/projects/{projectId}/conversations/{id}/events/{eventId}
   * @secure
   */
  projectsConversationsEventsDetail = (
    projectId: string,
    id: string,
    eventId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the conversation event */
        id: string;
        /** ID of the project this event belongs to */
        projectId: string;
        /** Identifier of the conversation this event belongs to */
        conversationId: string;
        /** Type of the conversation event */
        eventType:
          | "message"
          | "classification"
          | "transformation"
          | "execution_plan"
          | "action"
          | "command"
          | "tool_call"
          | "conversation_start"
          | "conversation_resume"
          | "conversation_end"
          | "conversation_aborted"
          | "conversation_failed"
          | "jump_to_stage"
          | "moderation"
          | "variables_updated"
          | "user_profile_updated"
          | "user_input_modified"
          | "user_banned"
          | "visibility_changed"
          | "sample_copy_selection"
          | "turn_aborted";
        /** Event data payload */
        eventData:
          | {
              role: "user" | "assistant";
              text: string;
              originalText: string;
              visibility?: {
                /** Visibility setting for the message: always (always visible), stage (visible only in current stage), never (never visible), conditional (visible based on condition) */
                visibility: "always" | "stage" | "never" | "conditional";
                /** Condition for visibility, evaluated against conversation variables */
                condition?: string;
              };
              metadata?: Record<string, any>;
            }
          | {
              classifierId: string;
              input: string;
              actions: {
                classifierId: string;
                classifierName: string;
                actions: {
                  name: string;
                  parameters: Record<string, ParameterValue>;
                }[];
              }[];
              metadata?: Record<string, any>;
            }
          | {
              transformerId: string;
              input: string;
              appliedFields: string[];
              metadata?: Record<string, any>;
            }
          | {
              /** ID of the stage where execution is taking place */
              stageId: string;
              /** Names of all matched actions in original order */
              actions: string[];
              /** Final ordered list of effects after filtering, sorting, and conflict resolution */
              effects: {
                /** Name of the action this effect originates from */
                actionName: string;
                /** The effect to be executed */
                effect: Effect;
              }[];
              /** Lifecycle context in which execution is taking place; null for user-input-triggered executions */
              lifecycleContext:
                | "on_enter"
                | "on_leave"
                | "on_fallback"
                | "conversation_start"
                | "conversation_resume"
                | "conversation_end"
                | "conversation_abort"
                | "conversation_failed"
                | null;
              metadata?: Record<string, any>;
            }
          | {
              actionName: string;
              stageId: string;
              effects: Effect[];
              metadata?: Record<string, any>;
            }
          | {
              command:
                | "go_to_stage"
                | "set_var"
                | "get_var"
                | "get_all_vars"
                | "run_action"
                | "call_tool";
              parameters?: Record<string, ParameterValue>;
              metadata?: Record<string, any>;
            }
          | {
              toolId: string;
              toolName: string;
              toolType?: "smart_function" | "webhook" | "script";
              parameters: Record<string, ParameterValue>;
              success: boolean;
              result?: any;
              error?: string;
              /** Name of the action that triggered this tool call, if triggered by an action effect */
              sourceActionName?: string;
              metadata?: Record<string, any>;
            }
          | {
              stageId: string;
              initialVariables?: Record<string, ParameterValue>;
              metadata?: Record<string, any>;
            }
          | {
              previousStatus:
                | "initialized"
                | "awaiting_user_input"
                | "receiving_user_voice"
                | "processing_user_input"
                | "generating_response"
                | "finished"
                | "aborted"
                | "failed";
              stageId: string;
              metadata?: Record<string, any>;
            }
          | {
              reason?: string;
              stageId: string;
              /** Name of the action that triggered conversation end, if triggered by an action effect */
              sourceActionName?: string;
              metadata?: Record<string, any>;
            }
          | {
              reason: string;
              stageId: string;
              /** Name of the action that triggered conversation abort, if triggered by an action effect */
              sourceActionName?: string;
              metadata?: Record<string, any>;
            }
          | {
              reason: string;
              stageId?: string;
              metadata?: Record<string, any>;
            }
          | {
              fromStageId: string;
              toStageId: string;
              /** Name of the action that triggered this stage jump, if triggered by an action effect */
              sourceActionName?: string;
              metadata?: Record<string, any>;
            }
          | {
              input: string;
              flagged: boolean;
              blockingCategories: string[];
              detectedCategories: string[];
              durationMs: number;
              startMs: number;
              endMs: number;
              metadata?: Record<string, any>;
            }
          | {
              /** Name of the action that triggered this variable update */
              sourceActionName: string;
              /** Names of the variables that were changed by this update */
              changedVariableNames: string[];
              /** Snapshot of all conversation variables after the update */
              variables: Record<string, ParameterValue>;
              metadata?: Record<string, any>;
            }
          | {
              /** Name of the action that triggered this profile update */
              sourceActionName: string;
              /** Names of the profile fields that were changed by this update */
              changedProfileNames: string[];
              /** Updated user profile data */
              profile: Record<string, ParameterValue>;
              metadata?: Record<string, any>;
            }
          | {
              /** Name of the action that triggered this input modification */
              sourceActionName: string;
              /** The modified user input after template rendering */
              modifiedInput: string;
              metadata?: Record<string, any>;
            }
          | {
              /** Name of the action that triggered the ban */
              sourceActionName: string;
              /** Optional reason for the ban */
              reason?: string;
              metadata?: Record<string, any>;
            }
          | {
              /** Name of the action that triggered this visibility change */
              sourceActionName: string;
              /** The new visibility settings for current turn messages */
              visibility: {
                /** Visibility setting for the message: always (always visible), stage (visible only in current stage), never (never visible), conditional (visible based on condition) */
                visibility: "always" | "stage" | "never" | "conditional";
                /** Condition for visibility, evaluated against conversation variables */
                condition?: string;
              };
              metadata?: Record<string, any>;
            }
          | {
              /** ID of the classifier that performed the selection */
              classifierId: string;
              /** The user input that triggered the selection */
              input: string;
              /** Identifier of selected sample copy, or null if none was selected */
              sampleCopy: string | null;
              metadata?: Record<string, any>;
            }
          | {
              /** Identifier of the input turn that was aborted */
              inputTurnId: string;
              /** Identifier of the AI generation turn that was aborted */
              outputTurnId: string;
              /** Full text generated before the barge-in interruption */
              accumulatedText: string;
              /** Unix timestamp in milliseconds when the generation was aborted */
              abortTimestampMs: number;
              metadata?: Record<string, any>;
            };
        /** ID of the stage that was active when the event occurred */
        stageId: string | null;
        /**
         * Timestamp when the event occurred
         * @format date-time
         */
        timestamp: string | null;
        /** Additional metadata associated with the event */
        metadata: Record<string, any>;
      },
      void
    >({
      path: `/api/projects/${projectId}/conversations/${id}/events/${eventId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific conversation
   *
   * @tags Conversations
   * @name ProjectsConversationsAuditLogsList
   * @summary Get conversation audit logs
   * @request GET:/api/projects/{projectId}/conversations/{id}/audit-logs
   * @secure
   */
  projectsConversationsAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/conversations/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a new knowledge category with trigger phrase and associated tags
   *
   * @tags Knowledge
   * @name ProjectsKnowledgeCategoriesCreate
   * @summary Create a new knowledge category
   * @request POST:/api/projects/{projectId}/knowledge/categories
   * @secure
   */
  projectsKnowledgeCategoriesCreate = (
    projectId: string,
    data: {
      /**
       * Unique identifier for the knowledge category (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Name of the knowledge category
       * @minLength 1
       */
      name: string;
      /**
       * Trigger phrase that activates this category in conversations
       * @minLength 1
       */
      promptTrigger: string;
      /** Array of knowledge tags this category belongs to */
      tags?: string[];
      /**
       * Display order for the category (default: 0)
       * @min 0
       */
      order?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the knowledge category */
        id: string;
        /** ID of the project this knowledge category belongs to */
        projectId: string;
        /** Name of the knowledge category */
        name: string;
        /** Trigger phrase that activates this category */
        promptTrigger: string;
        /** Array of knowledge tags */
        tags: string[];
        /** Display order for the category */
        order: number;
        /** Knowledge items within this category */
        items?: {
          /** Unique identifier for the knowledge item */
          id: string;
          /** ID of the project this item belongs to */
          projectId: string;
          /** ID of the category this item belongs to */
          categoryId: string;
          /** Question text for this knowledge item */
          question: string;
          /** Answer text for this knowledge item */
          answer: string;
          /** Display order within the category */
          order: number;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the item was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the item was last updated
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the category was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the category was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/knowledge/categories`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of knowledge categories with their items. Supports filtering, sorting, and text search
   *
   * @tags Knowledge
   * @name ProjectsKnowledgeCategoriesList
   * @summary List knowledge categories
   * @request GET:/api/projects/{projectId}/knowledge/categories
   * @secure
   */
  projectsKnowledgeCategoriesList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of knowledge categories in the current page */
        items: {
          /** Unique identifier for the knowledge category */
          id: string;
          /** ID of the project this knowledge category belongs to */
          projectId: string;
          /** Name of the knowledge category */
          name: string;
          /** Trigger phrase that activates this category */
          promptTrigger: string;
          /** Array of knowledge tags */
          tags: string[];
          /** Display order for the category */
          order: number;
          /** Knowledge items within this category */
          items?: {
            /** Unique identifier for the knowledge item */
            id: string;
            /** ID of the project this item belongs to */
            projectId: string;
            /** ID of the category this item belongs to */
            categoryId: string;
            /** Question text for this knowledge item */
            question: string;
            /** Answer text for this knowledge item */
            answer: string;
            /** Display order within the category */
            order: number;
            /** Version number for optimistic locking */
            version: number;
            /**
             * Timestamp when the item was created
             * @format date-time
             */
            createdAt: string | null;
            /**
             * Timestamp when the item was last updated
             * @format date-time
             */
            updatedAt: string | null;
          }[];
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the category was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the category was last updated
           * @format date-time
           */
          updatedAt: string | null;
          /** Whether this entity belongs to an archived project */
          archived?: boolean;
        }[];
        /**
         * Total number of categories matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/knowledge/categories`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single knowledge category with all its items by unique identifier
   *
   * @tags Knowledge
   * @name ProjectsKnowledgeCategoriesDetail
   * @summary Get knowledge category by ID
   * @request GET:/api/projects/{projectId}/knowledge/categories/{id}
   * @secure
   */
  projectsKnowledgeCategoriesDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the knowledge category */
        id: string;
        /** ID of the project this knowledge category belongs to */
        projectId: string;
        /** Name of the knowledge category */
        name: string;
        /** Trigger phrase that activates this category */
        promptTrigger: string;
        /** Array of knowledge tags */
        tags: string[];
        /** Display order for the category */
        order: number;
        /** Knowledge items within this category */
        items?: {
          /** Unique identifier for the knowledge item */
          id: string;
          /** ID of the project this item belongs to */
          projectId: string;
          /** ID of the category this item belongs to */
          categoryId: string;
          /** Question text for this knowledge item */
          question: string;
          /** Answer text for this knowledge item */
          answer: string;
          /** Display order within the category */
          order: number;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the item was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the item was last updated
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the category was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the category was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/knowledge/categories/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing knowledge category with optimistic locking
   *
   * @tags Knowledge
   * @name ProjectsKnowledgeCategoriesUpdate
   * @summary Update knowledge category
   * @request PUT:/api/projects/{projectId}/knowledge/categories/{id}
   * @secure
   */
  projectsKnowledgeCategoriesUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * Updated name of the category
       * @minLength 1
       */
      name?: string;
      /**
       * Updated trigger phrase
       * @minLength 1
       */
      promptTrigger?: string;
      /** Updated array of knowledge tags */
      tags?: string[];
      /**
       * Updated display order
       * @min 0
       */
      order?: number;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the knowledge category */
        id: string;
        /** ID of the project this knowledge category belongs to */
        projectId: string;
        /** Name of the knowledge category */
        name: string;
        /** Trigger phrase that activates this category */
        promptTrigger: string;
        /** Array of knowledge tags */
        tags: string[];
        /** Display order for the category */
        order: number;
        /** Knowledge items within this category */
        items?: {
          /** Unique identifier for the knowledge item */
          id: string;
          /** ID of the project this item belongs to */
          projectId: string;
          /** ID of the category this item belongs to */
          categoryId: string;
          /** Question text for this knowledge item */
          question: string;
          /** Answer text for this knowledge item */
          answer: string;
          /** Display order within the category */
          order: number;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the item was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the item was last updated
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the category was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the category was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/knowledge/categories/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a knowledge category with optimistic locking. This will also delete all items in the category
   *
   * @tags Knowledge
   * @name ProjectsKnowledgeCategoriesDelete
   * @summary Delete knowledge category
   * @request DELETE:/api/projects/{projectId}/knowledge/categories/{id}
   * @secure
   */
  projectsKnowledgeCategoriesDelete = (
    projectId: string,
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/knowledge/categories/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Creates a new knowledge item (Q&A pair) within a specific category
   *
   * @tags Knowledge
   * @name ProjectsKnowledgeItemsCreate
   * @summary Create a new knowledge item
   * @request POST:/api/projects/{projectId}/knowledge/items
   * @secure
   */
  projectsKnowledgeItemsCreate = (
    projectId: string,
    data: {
      /**
       * Unique identifier for the knowledge item (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * ID of the category this item belongs to
       * @minLength 1
       */
      categoryId: string;
      /**
       * Question text for this knowledge item
       * @minLength 1
       */
      question: string;
      /**
       * Answer text for this knowledge item
       * @minLength 1
       */
      answer: string;
      /**
       * Display order within the category (default: 0)
       * @min 0
       */
      order?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the knowledge item */
        id: string;
        /** ID of the project this item belongs to */
        projectId: string;
        /** ID of the category this item belongs to */
        categoryId: string;
        /** Question text for this knowledge item */
        question: string;
        /** Answer text for this knowledge item */
        answer: string;
        /** Display order within the category */
        order: number;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the item was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the item was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/knowledge/items`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of knowledge items. Supports filtering by categoryId, text search, sorting, and pagination
   *
   * @tags Knowledge
   * @name ProjectsKnowledgeItemsList
   * @summary List knowledge items
   * @request GET:/api/projects/{projectId}/knowledge/items
   * @secure
   */
  projectsKnowledgeItemsList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of knowledge items in the current page */
        items: {
          /** Unique identifier for the knowledge item */
          id: string;
          /** ID of the project this item belongs to */
          projectId: string;
          /** ID of the category this item belongs to */
          categoryId: string;
          /** Question text for this knowledge item */
          question: string;
          /** Answer text for this knowledge item */
          answer: string;
          /** Display order within the category */
          order: number;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the item was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the item was last updated
           * @format date-time
           */
          updatedAt: string | null;
          /** Whether this entity belongs to an archived project */
          archived?: boolean;
        }[];
        /**
         * Total number of items matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/knowledge/items`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single knowledge item by its unique identifier
   *
   * @tags Knowledge
   * @name ProjectsKnowledgeItemsDetail
   * @summary Get knowledge item by ID
   * @request GET:/api/projects/{projectId}/knowledge/items/{id}
   * @secure
   */
  projectsKnowledgeItemsDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the knowledge item */
        id: string;
        /** ID of the project this item belongs to */
        projectId: string;
        /** ID of the category this item belongs to */
        categoryId: string;
        /** Question text for this knowledge item */
        question: string;
        /** Answer text for this knowledge item */
        answer: string;
        /** Display order within the category */
        order: number;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the item was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the item was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/knowledge/items/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing knowledge item with optimistic locking
   *
   * @tags Knowledge
   * @name ProjectsKnowledgeItemsUpdate
   * @summary Update knowledge item
   * @request PUT:/api/projects/{projectId}/knowledge/items/{id}
   * @secure
   */
  projectsKnowledgeItemsUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * Updated category ID
       * @minLength 1
       */
      categoryId?: string;
      /**
       * Updated question text
       * @minLength 1
       */
      question?: string;
      /**
       * Updated answer text
       * @minLength 1
       */
      answer?: string;
      /**
       * Updated display order
       * @min 0
       */
      order?: number;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the knowledge item */
        id: string;
        /** ID of the project this item belongs to */
        projectId: string;
        /** ID of the category this item belongs to */
        categoryId: string;
        /** Question text for this knowledge item */
        question: string;
        /** Answer text for this knowledge item */
        answer: string;
        /** Display order within the category */
        order: number;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the item was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the item was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/knowledge/items/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a knowledge item with optimistic locking
   *
   * @tags Knowledge
   * @name ProjectsKnowledgeItemsDelete
   * @summary Delete knowledge item
   * @request DELETE:/api/projects/{projectId}/knowledge/items/{id}
   * @secure
   */
  projectsKnowledgeItemsDelete = (
    projectId: string,
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/knowledge/items/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves all knowledge items belonging to a specific category, ordered by their display order
   *
   * @tags Knowledge
   * @name ProjectsKnowledgeCategoriesItemsList
   * @summary Get items by category
   * @request GET:/api/projects/{projectId}/knowledge/categories/{categoryId}/items
   * @secure
   */
  projectsKnowledgeCategoriesItemsList = (
    projectId: string,
    categoryId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the knowledge item */
        id: string;
        /** ID of the project this item belongs to */
        projectId: string;
        /** ID of the category this item belongs to */
        categoryId: string;
        /** Question text for this knowledge item */
        question: string;
        /** Answer text for this knowledge item */
        answer: string;
        /** Display order within the category */
        order: number;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the item was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the item was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      }[],
      void
    >({
      path: `/api/projects/${projectId}/knowledge/categories/${categoryId}/items`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific knowledge category
   *
   * @tags Knowledge
   * @name ProjectsKnowledgeCategoriesAuditLogsList
   * @summary Get knowledge category audit logs
   * @request GET:/api/projects/{projectId}/knowledge/categories/{id}/audit-logs
   * @secure
   */
  projectsKnowledgeCategoriesAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/knowledge/categories/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific knowledge item
   *
   * @tags Knowledge
   * @name ProjectsKnowledgeItemsAuditLogsList
   * @summary Get knowledge item audit logs
   * @request GET:/api/projects/{projectId}/knowledge/items/{id}/audit-logs
   * @secure
   */
  projectsKnowledgeItemsAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/knowledge/items/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a new AI agent with specified characteristics and voice configuration
   *
   * @tags Agents
   * @name ProjectsAgentsCreate
   * @summary Create a new agent
   * @request POST:/api/projects/{projectId}/agents
   * @secure
   */
  projectsAgentsCreate = (
    projectId: string,
    data: {
      /**
       * Unique identifier for the agent (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Display name of the agent
       * @minLength 1
       */
      name: string;
      /** Detailed description of the agent purpose */
      description?: string;
      /**
       * Detailed prompt defining the agent's characteristics and behavior
       * @minLength 1
       */
      prompt: string;
      /** ID of the TTS provider (e.g., "eleven-labs") */
      ttsProviderId?: string;
      /** TTS provider-specific settings */
      ttsSettings?:
        | ElevenLabsTtsSettings
        | OpenAiTtsSettings
        | DeepgramTtsSettings
        | CartesiaTtsSettings
        | AzureTtsSettings
        | AmazonPollyTtsSettings;
      /**
       * Tags for categorizing and filtering this agent
       * @default []
       */
      tags?: string[];
      /** Additional agent-specific metadata */
      metadata?: Record<string, any>;
      /** Filler response settings: a short sentence spoken through TTS at the very start of each turn while classification runs in parallel */
      fillerSettings?: FillerSettings;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the agent */
        id: string;
        /** ID of the project this agent belongs to */
        projectId: string;
        /** Display name of the agent */
        name: string;
        /** Detailed description of the agent purpose */
        description: string | null;
        /** Prompt defining the agent's characteristics and behavior */
        prompt: string;
        /** ID of the TTS provider */
        ttsProviderId: string | null;
        /** TTS provider-specific settings */
        ttsSettings?:
          | ElevenLabsTtsSettings
          | OpenAiTtsSettings
          | DeepgramTtsSettings
          | CartesiaTtsSettings
          | AzureTtsSettings
          | AmazonPollyTtsSettings;
        /** Tags for categorizing and filtering this agent */
        tags: string[];
        /** Additional agent-specific metadata */
        metadata: Record<string, any>;
        /** Filler response settings */
        fillerSettings: FillerSettings;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the agent was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the agent was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/agents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of agents with optional filtering
   *
   * @tags Agents
   * @name ProjectsAgentsList
   * @summary List agents
   * @request GET:/api/projects/{projectId}/agents
   * @secure
   */
  projectsAgentsList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of agents in the current page */
        items: {
          /** Unique identifier for the agent */
          id: string;
          /** ID of the project this agent belongs to */
          projectId: string;
          /** Display name of the agent */
          name: string;
          /** Detailed description of the agent purpose */
          description: string | null;
          /** Prompt defining the agent's characteristics and behavior */
          prompt: string;
          /** ID of the TTS provider */
          ttsProviderId: string | null;
          /** TTS provider-specific settings */
          ttsSettings?:
            | ElevenLabsTtsSettings
            | OpenAiTtsSettings
            | DeepgramTtsSettings
            | CartesiaTtsSettings
            | AzureTtsSettings
            | AmazonPollyTtsSettings;
          /** Tags for categorizing and filtering this agent */
          tags: string[];
          /** Additional agent-specific metadata */
          metadata: Record<string, any>;
          /** Filler response settings */
          fillerSettings: FillerSettings;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the agent was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the agent was last updated
           * @format date-time
           */
          updatedAt: string | null;
          /** Whether this entity belongs to an archived project */
          archived?: boolean;
        }[];
        /**
         * Total number of agents matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/agents`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single agent by their unique identifier
   *
   * @tags Agents
   * @name ProjectsAgentsDetail
   * @summary Get agent by ID
   * @request GET:/api/projects/{projectId}/agents/{id}
   * @secure
   */
  projectsAgentsDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the agent */
        id: string;
        /** ID of the project this agent belongs to */
        projectId: string;
        /** Display name of the agent */
        name: string;
        /** Detailed description of the agent purpose */
        description: string | null;
        /** Prompt defining the agent's characteristics and behavior */
        prompt: string;
        /** ID of the TTS provider */
        ttsProviderId: string | null;
        /** TTS provider-specific settings */
        ttsSettings?:
          | ElevenLabsTtsSettings
          | OpenAiTtsSettings
          | DeepgramTtsSettings
          | CartesiaTtsSettings
          | AzureTtsSettings
          | AmazonPollyTtsSettings;
        /** Tags for categorizing and filtering this agent */
        tags: string[];
        /** Additional agent-specific metadata */
        metadata: Record<string, any>;
        /** Filler response settings */
        fillerSettings: FillerSettings;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the agent was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the agent was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/agents/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing agent with optimistic locking
   *
   * @tags Agents
   * @name ProjectsAgentsUpdate
   * @summary Update agent
   * @request PUT:/api/projects/{projectId}/agents/{id}
   * @secure
   */
  projectsAgentsUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * Updated display name
       * @minLength 1
       */
      name?: string;
      /** Updated detailed description of the agent */
      description?: string | null;
      /**
       * Updated prompt defining behavior
       * @minLength 1
       */
      prompt?: string;
      /** Updated TTS provider ID */
      ttsProviderId?: string | null;
      /** Updated TTS provider-specific settings */
      ttsSettings?:
        | ElevenLabsTtsSettings
        | OpenAiTtsSettings
        | DeepgramTtsSettings
        | CartesiaTtsSettings
        | AzureTtsSettings
        | AmazonPollyTtsSettings;
      /** Updated tags */
      tags?: string[];
      /** Updated metadata */
      metadata?: Record<string, any>;
      /** Updated filler response settings */
      fillerSettings?: {
        /** ID of the LLM provider used to generate the filler sentence */
        llmProviderId: string;
        /** LLM provider-specific settings for filler generation */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /**
         * Prompt instructing the LLM to produce a short neutral filler sentence (e.g. "Generate a single short neutral sentence to fill silence while processing, like "Hmm, let me think about that."")
         * @minLength 1
         */
        prompt: string;
        /**
         * Number of recent conversation messages to include in the filler LLM call context (0 = no history)
         * @min 0
         * @default 0
         */
        historyMessageCount?: number;
      } | null;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the agent */
        id: string;
        /** ID of the project this agent belongs to */
        projectId: string;
        /** Display name of the agent */
        name: string;
        /** Detailed description of the agent purpose */
        description: string | null;
        /** Prompt defining the agent's characteristics and behavior */
        prompt: string;
        /** ID of the TTS provider */
        ttsProviderId: string | null;
        /** TTS provider-specific settings */
        ttsSettings?:
          | ElevenLabsTtsSettings
          | OpenAiTtsSettings
          | DeepgramTtsSettings
          | CartesiaTtsSettings
          | AzureTtsSettings
          | AmazonPollyTtsSettings;
        /** Tags for categorizing and filtering this agent */
        tags: string[];
        /** Additional agent-specific metadata */
        metadata: Record<string, any>;
        /** Filler response settings */
        fillerSettings: FillerSettings;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the agent was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the agent was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/agents/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes an agent with optimistic locking
   *
   * @tags Agents
   * @name ProjectsAgentsDelete
   * @summary Delete agent
   * @request DELETE:/api/projects/{projectId}/agents/{id}
   * @secure
   */
  projectsAgentsDelete = (
    projectId: string,
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/agents/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific agent
   *
   * @tags Agents
   * @name ProjectsAgentsAuditLogsList
   * @summary Get agent audit logs
   * @request GET:/api/projects/{projectId}/agents/{id}/audit-logs
   * @secure
   */
  projectsAgentsAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/agents/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a copy of an existing agent with a new ID and optional name override
   *
   * @tags Agents
   * @name ProjectsAgentsCloneCreate
   * @summary Clone agent
   * @request POST:/api/projects/{projectId}/agents/{id}/clone
   * @secure
   */
  projectsAgentsCloneCreate = (
    projectId: string,
    id: string,
    data: {
      /**
       * New ID for the cloned agent (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Name for the cloned agent (defaults to "{original name} (Clone)")
       * @minLength 1
       */
      name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the agent */
        id: string;
        /** ID of the project this agent belongs to */
        projectId: string;
        /** Display name of the agent */
        name: string;
        /** Detailed description of the agent purpose */
        description: string | null;
        /** Prompt defining the agent's characteristics and behavior */
        prompt: string;
        /** ID of the TTS provider */
        ttsProviderId: string | null;
        /** TTS provider-specific settings */
        ttsSettings?:
          | ElevenLabsTtsSettings
          | OpenAiTtsSettings
          | DeepgramTtsSettings
          | CartesiaTtsSettings
          | AzureTtsSettings
          | AmazonPollyTtsSettings;
        /** Tags for categorizing and filtering this agent */
        tags: string[];
        /** Additional agent-specific metadata */
        metadata: Record<string, any>;
        /** Filler response settings */
        fillerSettings: FillerSettings;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the agent was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the agent was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/agents/${id}/clone`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new provider configuration for AI services (ASR, TTS, LLM, Embeddings)
   *
   * @tags Providers
   * @name ProvidersCreate
   * @summary Create a new provider
   * @request POST:/api/providers
   * @secure
   */
  providersCreate = (
    data: {
      /**
       * Unique identifier for the provider (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Human-readable name for the provider
       * @minLength 1
       */
      name: string;
      /** Detailed description of provider purpose and use case */
      description?: string;
      /** Provider category: asr, tts, llm, or embeddings */
      providerType:
        | "asr"
        | "tts"
        | "llm"
        | "embeddings"
        | "storage"
        | "channel";
      /** Specific provider implementation (e.g., openai, anthropic, azure, elevenlabs) */
      apiType: string;
      /** Provider-specific configuration object (varies by providerType and apiType) */
      config:
        | {
            /** OpenAI API key */
            apiKey: string;
            /** Optional organization ID */
            organizationId?: string;
            /** Optional base URL for OpenAI-compatible APIs */
            baseUrl?: string;
          }
        | {
            /** Anthropic API key */
            apiKey: string;
            /** Optional base URL for custom endpoints */
            baseUrl?: string;
          }
        | {
            /** Google API key */
            apiKey: string;
          }
        | {
            /** Base URL of the Ollama server (defaults to http://localhost:11434 for local, or https://ollama.com for cloud) */
            baseUrl?: string;
            /** API key — required for Ollama Cloud (ollama.com); ignored by local Ollama instances */
            apiKey?: string;
          }
        | {
            /** API key for authenticating with ElevenLabs */
            apiKey: string;
          }
        | {
            /** API key for authenticating with OpenAI */
            apiKey: string;
          }
        | {
            /** API key for authenticating with Deepgram */
            apiKey: string;
          }
        | {
            /** API key for authenticating with Cartesia */
            apiKey: string;
          }
        | {
            /** The Azure region to use for the speech service (e.g., "eastus", "westeurope") */
            region: string;
            /** The subscription key to use for the speech service */
            subscriptionKey: string;
          }
        | {
            /** The Azure region to use for the speech recognition service */
            region: string;
            /** The subscription key to use for the speech recognition service */
            subscriptionKey: string;
          }
        | {
            /** API key for authenticating with AssemblyAI */
            apiKey: string;
            /**
             * AssemblyAI region endpoint: "us" for streaming.assemblyai.com or "eu" for streaming.eu.assemblyai.com
             * @default "us"
             */
            region?: "us" | "eu";
          }
        | {
            /** API key for authenticating with Speechmatics */
            apiKey: string;
            /**
             * Speechmatics region endpoint: "us" for neu.rt.speechmatics.com, "eu" for eu2.rt.speechmatics.com, or "apac" for au.rt.speechmatics.com
             * @default "us"
             */
            region?: "us" | "eu" | "apac";
          }
        | S3StorageConfig
        | AzureBlobStorageConfig
        | GcsStorageConfig
        | LocalStorageConfig
        | TelegramChannelConfig
        | TwilioMessagingChannelConfig
        | TwilioVoiceChannelConfig
        | WhatsAppChannelConfig;
      /** Operator user ID who created the provider */
      createdBy?: string;
      /** Searchable tags for organization (e.g., ["production", "low-latency"]) */
      tags?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the provider */
        id: string;
        /** Human-readable name of the provider */
        name: string;
        /** Description of provider purpose and use case */
        description: string | null;
        /** Provider category (asr, tts, llm, embeddings) */
        providerType:
          | "asr"
          | "tts"
          | "llm"
          | "embeddings"
          | "storage"
          | "channel";
        /** Specific provider implementation */
        apiType: string;
        /** Provider-specific configuration object */
        config:
          | {
              /** OpenAI API key */
              apiKey: string;
              /** Optional organization ID */
              organizationId?: string;
              /** Optional base URL for OpenAI-compatible APIs */
              baseUrl?: string;
            }
          | {
              /** Anthropic API key */
              apiKey: string;
              /** Optional base URL for custom endpoints */
              baseUrl?: string;
            }
          | {
              /** Google API key */
              apiKey: string;
            }
          | {
              /** Base URL of the Ollama server (defaults to http://localhost:11434 for local, or https://ollama.com for cloud) */
              baseUrl?: string;
              /** API key — required for Ollama Cloud (ollama.com); ignored by local Ollama instances */
              apiKey?: string;
            }
          | {
              /** API key for authenticating with ElevenLabs */
              apiKey: string;
            }
          | {
              /** API key for authenticating with OpenAI */
              apiKey: string;
            }
          | {
              /** API key for authenticating with Deepgram */
              apiKey: string;
            }
          | {
              /** API key for authenticating with Cartesia */
              apiKey: string;
            }
          | {
              /** The Azure region to use for the speech service (e.g., "eastus", "westeurope") */
              region: string;
              /** The subscription key to use for the speech service */
              subscriptionKey: string;
            }
          | {
              /** The Azure region to use for the speech recognition service */
              region: string;
              /** The subscription key to use for the speech recognition service */
              subscriptionKey: string;
            }
          | {
              /** API key for authenticating with AssemblyAI */
              apiKey: string;
              /**
               * AssemblyAI region endpoint: "us" for streaming.assemblyai.com or "eu" for streaming.eu.assemblyai.com
               * @default "us"
               */
              region?: "us" | "eu";
            }
          | {
              /** API key for authenticating with Speechmatics */
              apiKey: string;
              /**
               * Speechmatics region endpoint: "us" for neu.rt.speechmatics.com, "eu" for eu2.rt.speechmatics.com, or "apac" for au.rt.speechmatics.com
               * @default "us"
               */
              region?: "us" | "eu" | "apac";
            }
          | S3StorageConfig
          | AzureBlobStorageConfig
          | GcsStorageConfig
          | LocalStorageConfig
          | TelegramChannelConfig
          | TwilioMessagingChannelConfig
          | TwilioVoiceChannelConfig
          | WhatsAppChannelConfig;
        /** Operator user ID who created the provider */
        createdBy: string | null;
        /** Tags for organization and search */
        tags: string[] | null;
        /** Current version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the provider was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the provider was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/providers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of provider configurations with optional filtering by providerType, apiType, tags, etc.
   *
   * @tags Providers
   * @name ProvidersList
   * @summary List providers
   * @request GET:/api/providers
   * @secure
   */
  providersList = (
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of providers in the current page */
        items: {
          /** Unique identifier for the provider */
          id: string;
          /** Human-readable name of the provider */
          name: string;
          /** Description of provider purpose and use case */
          description: string | null;
          /** Provider category (asr, tts, llm, embeddings) */
          providerType:
            | "asr"
            | "tts"
            | "llm"
            | "embeddings"
            | "storage"
            | "channel";
          /** Specific provider implementation */
          apiType: string;
          /** Provider-specific configuration object */
          config:
            | {
                /** OpenAI API key */
                apiKey: string;
                /** Optional organization ID */
                organizationId?: string;
                /** Optional base URL for OpenAI-compatible APIs */
                baseUrl?: string;
              }
            | {
                /** Anthropic API key */
                apiKey: string;
                /** Optional base URL for custom endpoints */
                baseUrl?: string;
              }
            | {
                /** Google API key */
                apiKey: string;
              }
            | {
                /** Base URL of the Ollama server (defaults to http://localhost:11434 for local, or https://ollama.com for cloud) */
                baseUrl?: string;
                /** API key — required for Ollama Cloud (ollama.com); ignored by local Ollama instances */
                apiKey?: string;
              }
            | {
                /** API key for authenticating with ElevenLabs */
                apiKey: string;
              }
            | {
                /** API key for authenticating with OpenAI */
                apiKey: string;
              }
            | {
                /** API key for authenticating with Deepgram */
                apiKey: string;
              }
            | {
                /** API key for authenticating with Cartesia */
                apiKey: string;
              }
            | {
                /** The Azure region to use for the speech service (e.g., "eastus", "westeurope") */
                region: string;
                /** The subscription key to use for the speech service */
                subscriptionKey: string;
              }
            | {
                /** The Azure region to use for the speech recognition service */
                region: string;
                /** The subscription key to use for the speech recognition service */
                subscriptionKey: string;
              }
            | {
                /** API key for authenticating with AssemblyAI */
                apiKey: string;
                /**
                 * AssemblyAI region endpoint: "us" for streaming.assemblyai.com or "eu" for streaming.eu.assemblyai.com
                 * @default "us"
                 */
                region?: "us" | "eu";
              }
            | {
                /** API key for authenticating with Speechmatics */
                apiKey: string;
                /**
                 * Speechmatics region endpoint: "us" for neu.rt.speechmatics.com, "eu" for eu2.rt.speechmatics.com, or "apac" for au.rt.speechmatics.com
                 * @default "us"
                 */
                region?: "us" | "eu" | "apac";
              }
            | S3StorageConfig
            | AzureBlobStorageConfig
            | GcsStorageConfig
            | LocalStorageConfig
            | TelegramChannelConfig
            | TwilioMessagingChannelConfig
            | TwilioVoiceChannelConfig
            | WhatsAppChannelConfig;
          /** Operator user ID who created the provider */
          createdBy: string | null;
          /** Tags for organization and search */
          tags: string[] | null;
          /** Current version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the provider was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the provider was last updated
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /**
         * Total number of providers matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/providers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single provider configuration by its unique identifier
   *
   * @tags Providers
   * @name ProvidersDetail
   * @summary Get provider by ID
   * @request GET:/api/providers/{id}
   * @secure
   */
  providersDetail = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        /** Unique identifier for the provider */
        id: string;
        /** Human-readable name of the provider */
        name: string;
        /** Description of provider purpose and use case */
        description: string | null;
        /** Provider category (asr, tts, llm, embeddings) */
        providerType:
          | "asr"
          | "tts"
          | "llm"
          | "embeddings"
          | "storage"
          | "channel";
        /** Specific provider implementation */
        apiType: string;
        /** Provider-specific configuration object */
        config:
          | {
              /** OpenAI API key */
              apiKey: string;
              /** Optional organization ID */
              organizationId?: string;
              /** Optional base URL for OpenAI-compatible APIs */
              baseUrl?: string;
            }
          | {
              /** Anthropic API key */
              apiKey: string;
              /** Optional base URL for custom endpoints */
              baseUrl?: string;
            }
          | {
              /** Google API key */
              apiKey: string;
            }
          | {
              /** Base URL of the Ollama server (defaults to http://localhost:11434 for local, or https://ollama.com for cloud) */
              baseUrl?: string;
              /** API key — required for Ollama Cloud (ollama.com); ignored by local Ollama instances */
              apiKey?: string;
            }
          | {
              /** API key for authenticating with ElevenLabs */
              apiKey: string;
            }
          | {
              /** API key for authenticating with OpenAI */
              apiKey: string;
            }
          | {
              /** API key for authenticating with Deepgram */
              apiKey: string;
            }
          | {
              /** API key for authenticating with Cartesia */
              apiKey: string;
            }
          | {
              /** The Azure region to use for the speech service (e.g., "eastus", "westeurope") */
              region: string;
              /** The subscription key to use for the speech service */
              subscriptionKey: string;
            }
          | {
              /** The Azure region to use for the speech recognition service */
              region: string;
              /** The subscription key to use for the speech recognition service */
              subscriptionKey: string;
            }
          | {
              /** API key for authenticating with AssemblyAI */
              apiKey: string;
              /**
               * AssemblyAI region endpoint: "us" for streaming.assemblyai.com or "eu" for streaming.eu.assemblyai.com
               * @default "us"
               */
              region?: "us" | "eu";
            }
          | {
              /** API key for authenticating with Speechmatics */
              apiKey: string;
              /**
               * Speechmatics region endpoint: "us" for neu.rt.speechmatics.com, "eu" for eu2.rt.speechmatics.com, or "apac" for au.rt.speechmatics.com
               * @default "us"
               */
              region?: "us" | "eu" | "apac";
            }
          | S3StorageConfig
          | AzureBlobStorageConfig
          | GcsStorageConfig
          | LocalStorageConfig
          | TelegramChannelConfig
          | TwilioMessagingChannelConfig
          | TwilioVoiceChannelConfig
          | WhatsAppChannelConfig;
        /** Operator user ID who created the provider */
        createdBy: string | null;
        /** Tags for organization and search */
        tags: string[] | null;
        /** Current version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the provider was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the provider was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/providers/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing provider configuration with optimistic locking
   *
   * @tags Providers
   * @name ProvidersUpdate
   * @summary Update provider
   * @request PUT:/api/providers/{id}
   * @secure
   */
  providersUpdate = (
    id: string,
    data: {
      /**
       * Current version number for optimistic locking (prevents concurrent updates)
       * @min 0
       * @exclusiveMin true
       */
      version: number;
      /**
       * Updated human-readable name for the provider
       * @minLength 1
       */
      name?: string;
      /** Updated description of provider purpose */
      description?: string | null;
      /** Updated provider category */
      providerType?:
        | "asr"
        | "tts"
        | "llm"
        | "embeddings"
        | "storage"
        | "channel";
      /** Updated specific provider implementation */
      apiType?: string;
      /** Updated provider-specific configuration */
      config?:
        | {
            /** OpenAI API key */
            apiKey: string;
            /** Optional organization ID */
            organizationId?: string;
            /** Optional base URL for OpenAI-compatible APIs */
            baseUrl?: string;
          }
        | {
            /** Anthropic API key */
            apiKey: string;
            /** Optional base URL for custom endpoints */
            baseUrl?: string;
          }
        | {
            /** Google API key */
            apiKey: string;
          }
        | {
            /** Base URL of the Ollama server (defaults to http://localhost:11434 for local, or https://ollama.com for cloud) */
            baseUrl?: string;
            /** API key — required for Ollama Cloud (ollama.com); ignored by local Ollama instances */
            apiKey?: string;
          }
        | {
            /** API key for authenticating with ElevenLabs */
            apiKey: string;
          }
        | {
            /** API key for authenticating with OpenAI */
            apiKey: string;
          }
        | {
            /** API key for authenticating with Deepgram */
            apiKey: string;
          }
        | {
            /** API key for authenticating with Cartesia */
            apiKey: string;
          }
        | {
            /** The Azure region to use for the speech service (e.g., "eastus", "westeurope") */
            region: string;
            /** The subscription key to use for the speech service */
            subscriptionKey: string;
          }
        | {
            /** The Azure region to use for the speech recognition service */
            region: string;
            /** The subscription key to use for the speech recognition service */
            subscriptionKey: string;
          }
        | {
            /** API key for authenticating with AssemblyAI */
            apiKey: string;
            /**
             * AssemblyAI region endpoint: "us" for streaming.assemblyai.com or "eu" for streaming.eu.assemblyai.com
             * @default "us"
             */
            region?: "us" | "eu";
          }
        | {
            /** API key for authenticating with Speechmatics */
            apiKey: string;
            /**
             * Speechmatics region endpoint: "us" for neu.rt.speechmatics.com, "eu" for eu2.rt.speechmatics.com, or "apac" for au.rt.speechmatics.com
             * @default "us"
             */
            region?: "us" | "eu" | "apac";
          }
        | S3StorageConfig
        | AzureBlobStorageConfig
        | GcsStorageConfig
        | LocalStorageConfig
        | TelegramChannelConfig
        | TwilioMessagingChannelConfig
        | TwilioVoiceChannelConfig
        | WhatsAppChannelConfig;
      /** Updated searchable tags */
      tags?: string[] | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the provider */
        id: string;
        /** Human-readable name of the provider */
        name: string;
        /** Description of provider purpose and use case */
        description: string | null;
        /** Provider category (asr, tts, llm, embeddings) */
        providerType:
          | "asr"
          | "tts"
          | "llm"
          | "embeddings"
          | "storage"
          | "channel";
        /** Specific provider implementation */
        apiType: string;
        /** Provider-specific configuration object */
        config:
          | {
              /** OpenAI API key */
              apiKey: string;
              /** Optional organization ID */
              organizationId?: string;
              /** Optional base URL for OpenAI-compatible APIs */
              baseUrl?: string;
            }
          | {
              /** Anthropic API key */
              apiKey: string;
              /** Optional base URL for custom endpoints */
              baseUrl?: string;
            }
          | {
              /** Google API key */
              apiKey: string;
            }
          | {
              /** Base URL of the Ollama server (defaults to http://localhost:11434 for local, or https://ollama.com for cloud) */
              baseUrl?: string;
              /** API key — required for Ollama Cloud (ollama.com); ignored by local Ollama instances */
              apiKey?: string;
            }
          | {
              /** API key for authenticating with ElevenLabs */
              apiKey: string;
            }
          | {
              /** API key for authenticating with OpenAI */
              apiKey: string;
            }
          | {
              /** API key for authenticating with Deepgram */
              apiKey: string;
            }
          | {
              /** API key for authenticating with Cartesia */
              apiKey: string;
            }
          | {
              /** The Azure region to use for the speech service (e.g., "eastus", "westeurope") */
              region: string;
              /** The subscription key to use for the speech service */
              subscriptionKey: string;
            }
          | {
              /** The Azure region to use for the speech recognition service */
              region: string;
              /** The subscription key to use for the speech recognition service */
              subscriptionKey: string;
            }
          | {
              /** API key for authenticating with AssemblyAI */
              apiKey: string;
              /**
               * AssemblyAI region endpoint: "us" for streaming.assemblyai.com or "eu" for streaming.eu.assemblyai.com
               * @default "us"
               */
              region?: "us" | "eu";
            }
          | {
              /** API key for authenticating with Speechmatics */
              apiKey: string;
              /**
               * Speechmatics region endpoint: "us" for neu.rt.speechmatics.com, "eu" for eu2.rt.speechmatics.com, or "apac" for au.rt.speechmatics.com
               * @default "us"
               */
              region?: "us" | "eu" | "apac";
            }
          | S3StorageConfig
          | AzureBlobStorageConfig
          | GcsStorageConfig
          | LocalStorageConfig
          | TelegramChannelConfig
          | TwilioMessagingChannelConfig
          | TwilioVoiceChannelConfig
          | WhatsAppChannelConfig;
        /** Operator user ID who created the provider */
        createdBy: string | null;
        /** Tags for organization and search */
        tags: string[] | null;
        /** Current version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the provider was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the provider was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/providers/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a provider configuration with optimistic locking
   *
   * @tags Providers
   * @name ProvidersDelete
   * @summary Delete provider
   * @request DELETE:/api/providers/{id}
   * @secure
   */
  providersDelete = (
    id: string,
    data: {
      /**
       * Current version number for optimistic locking (prevents concurrent deletions)
       * @min 0
       * @exclusiveMin true
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/providers/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific provider configuration
   *
   * @tags Providers
   * @name ProvidersAuditLogsList
   * @summary Get provider audit logs
   * @request GET:/api/providers/{id}/audit-logs
   * @secure
   */
  providersAuditLogsList = (id: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/providers/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Enumerates available models for a configured LLM provider by querying the provider API. Falls back to a static model list when the API is unavailable.
   *
   * @tags Providers
   * @name ProvidersModelsList
   * @summary Enumerate LLM models
   * @request GET:/api/providers/{id}/models
   * @secure
   */
  providersModelsList = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        /** Available models for the provider */
        models: LlmModelInfo[];
      },
      void
    >({
      path: `/api/providers/${id}/models`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns information about all available ASR, TTS, and LLM providers including their models, capabilities, and supported features
   *
   * @tags Provider Catalog
   * @name ProviderCatalogList
   * @summary Get complete provider catalog
   * @request GET:/api/provider-catalog
   * @secure
   */
  providerCatalogList = (params: RequestParams = {}) =>
    this.request<
      {
        /** ASR providers */
        asr: {
          /** Provider API type */
          apiType: string;
          /** Human-readable provider name */
          displayName: string;
          /** Models available for this provider */
          models: AsrModelInfo[];
          /** Languages commonly supported across models (for reference) */
          languages: LanguageInfo[];
          /** Additional information */
          description?: string;
        }[];
        /** TTS providers */
        tts: {
          /** Provider API type */
          apiType: string;
          /** Human-readable provider name */
          displayName: string;
          /** Models available for this provider */
          models: TtsModelInfo[];
          /** Voices available (can be provider-specific or model-specific) */
          voices: VoiceInfo[];
          /** Languages commonly supported across models (for reference) */
          languages: LanguageInfo[];
          /** Additional information */
          description?: string;
        }[];
        /** LLM providers */
        llm: {
          /** Provider API type */
          apiType: string;
          /** Human-readable provider name */
          displayName: string;
          /** Models available for this provider */
          models: LlmModelInfo[];
          /** Additional information */
          description?: string;
        }[];
        /** Storage providers */
        storage: {
          /** Provider API type */
          apiType: string;
          /** Human-readable provider name */
          displayName: string;
          /** Additional information */
          description?: string;
          /** List of supported features */
          features?: string[];
        }[];
        /** Moderation providers */
        moderation: ModerationProviderInfo[];
        /** Communication channel providers */
        channel: {
          /** Provider API type */
          apiType: string;
          /** Human-readable provider name */
          displayName: string;
          /** Additional information */
          description?: string;
          /** List of supported features */
          features?: string[];
        }[];
      },
      any
    >({
      path: `/api/provider-catalog`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns information about all available ASR (Automatic Speech Recognition) providers including supported languages and capabilities
   *
   * @tags Provider Catalog
   * @name ProviderCatalogAsrList
   * @summary Get ASR providers
   * @request GET:/api/provider-catalog/asr
   * @secure
   */
  providerCatalogAsrList = (params: RequestParams = {}) =>
    this.request<
      {
        /** List of ASR providers */
        providers: {
          /** Provider API type */
          apiType: string;
          /** Human-readable provider name */
          displayName: string;
          /** Models available for this provider */
          models: AsrModelInfo[];
          /** Languages commonly supported across models (for reference) */
          languages: LanguageInfo[];
          /** Additional information */
          description?: string;
        }[];
      },
      any
    >({
      path: `/api/provider-catalog/asr`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns information about all available TTS (Text-to-Speech) providers including models, voices, and supported languages
   *
   * @tags Provider Catalog
   * @name ProviderCatalogTtsList
   * @summary Get TTS providers
   * @request GET:/api/provider-catalog/tts
   * @secure
   */
  providerCatalogTtsList = (params: RequestParams = {}) =>
    this.request<
      {
        /** List of TTS providers */
        providers: {
          /** Provider API type */
          apiType: string;
          /** Human-readable provider name */
          displayName: string;
          /** Models available for this provider */
          models: TtsModelInfo[];
          /** Voices available (can be provider-specific or model-specific) */
          voices: VoiceInfo[];
          /** Languages commonly supported across models (for reference) */
          languages: LanguageInfo[];
          /** Additional information */
          description?: string;
        }[];
      },
      any
    >({
      path: `/api/provider-catalog/tts`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns information about all available LLM (Large Language Model) providers including models, capabilities like tool calling, JSON output, and context windows
   *
   * @tags Provider Catalog
   * @name ProviderCatalogLlmList
   * @summary Get LLM providers
   * @request GET:/api/provider-catalog/llm
   * @secure
   */
  providerCatalogLlmList = (params: RequestParams = {}) =>
    this.request<
      {
        /** List of LLM providers */
        providers: {
          /** Provider API type */
          apiType: string;
          /** Human-readable provider name */
          displayName: string;
          /** Models available for this provider */
          models: LlmModelInfo[];
          /** Additional information */
          description?: string;
        }[];
      },
      any
    >({
      path: `/api/provider-catalog/llm`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns information about all available storage providers including S3, Azure Blob, Google Cloud Storage, and local filesystem
   *
   * @tags Provider Catalog
   * @name ProviderCatalogStorageList
   * @summary Get storage providers
   * @request GET:/api/provider-catalog/storage
   * @secure
   */
  providerCatalogStorageList = (params: RequestParams = {}) =>
    this.request<
      {
        /** List of storage providers */
        providers: {
          /** Provider API type */
          apiType: string;
          /** Human-readable provider name */
          displayName: string;
          /** Additional information */
          description?: string;
          /** List of supported features */
          features?: string[];
        }[];
      },
      any
    >({
      path: `/api/provider-catalog/storage`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns information about all available content moderation providers including supported models and detectable categories. Category names listed here are the exact strings to use in moderationConfig.blockedCategories.
   *
   * @tags Provider Catalog
   * @name ProviderCatalogModerationList
   * @summary Get moderation providers
   * @request GET:/api/provider-catalog/moderation
   * @secure
   */
  providerCatalogModerationList = (params: RequestParams = {}) =>
    this.request<
      {
        /** List of moderation providers */
        providers: ModerationProviderInfo[];
      },
      any
    >({
      path: `/api/provider-catalog/moderation`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns detailed information about a specific provider by type and API type
   *
   * @tags Provider Catalog
   * @name ProviderCatalogDetail
   * @summary Get specific provider information
   * @request GET:/api/provider-catalog/{type}/{apiType}
   * @secure
   */
  providerCatalogDetail = (
    type: "asr" | "tts" | "llm" | "storage" | "moderation",
    apiType: string,
    params: RequestParams = {},
  ) =>
    this.request<
      | {
          /** Provider API type */
          apiType: string;
          /** Human-readable provider name */
          displayName: string;
          /** Models available for this provider */
          models: AsrModelInfo[];
          /** Languages commonly supported across models (for reference) */
          languages: LanguageInfo[];
          /** Additional information */
          description?: string;
        }
      | {
          /** Provider API type */
          apiType: string;
          /** Human-readable provider name */
          displayName: string;
          /** Models available for this provider */
          models: TtsModelInfo[];
          /** Voices available (can be provider-specific or model-specific) */
          voices: VoiceInfo[];
          /** Languages commonly supported across models (for reference) */
          languages: LanguageInfo[];
          /** Additional information */
          description?: string;
        }
      | {
          /** Provider API type */
          apiType: string;
          /** Human-readable provider name */
          displayName: string;
          /** Models available for this provider */
          models: LlmModelInfo[];
          /** Additional information */
          description?: string;
        }
      | {
          /** Provider API type */
          apiType: string;
          /** Human-readable provider name */
          displayName: string;
          /** Additional information */
          description?: string;
          /** List of supported features */
          features?: string[];
        },
      void
    >({
      path: `/api/provider-catalog/${type}/${apiType}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns all communication channel types supported by this backend instance, including their capabilities and supported audio formats.
   *
   * @tags Channel Catalog
   * @name ChannelCatalogList
   * @summary List all supported channels
   * @request GET:/api/channel-catalog
   * @secure
   */
  channelCatalogList = (params: RequestParams = {}) =>
    this.request<ChannelCatalogResponse, any>({
      path: `/api/channel-catalog`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns details and capabilities for a single channel type.
   *
   * @tags Channel Catalog
   * @name ChannelCatalogDetail
   * @summary Get a channel by type
   * @request GET:/api/channel-catalog/{type}
   * @secure
   */
  channelCatalogDetail = (type: string, params: RequestParams = {}) =>
    this.request<ChannelInfo, void>({
      path: `/api/channel-catalog/${type}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new environment configuration for data migration between server instances
   *
   * @tags Environments
   * @name EnvironmentsCreate
   * @summary Create a new environment
   * @request POST:/api/environments
   * @secure
   */
  environmentsCreate = (
    data: {
      /**
       * Unique identifier for the environment (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Human-readable description of the environment
       * @minLength 1
       */
      description: string;
      /**
       * Base URL of the target server instance
       * @format uri
       */
      url: string;
      /**
       * Authentication login/username for the environment
       * @minLength 1
       */
      login: string;
      /**
       * Authentication password for the environment
       * @minLength 1
       */
      password: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the environment */
        id: string;
        /** Human-readable description of the environment */
        description: string;
        /** Base URL of the target server instance */
        url: string;
        /** Authentication login/username */
        login: string;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the environment was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the environment was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/environments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of environments with optional filtering and sorting (passwords excluded)
   *
   * @tags Environments
   * @name EnvironmentsList
   * @summary List environments
   * @request GET:/api/environments
   * @secure
   */
  environmentsList = (
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of environments in the current page */
        items: {
          /** Unique identifier for the environment */
          id: string;
          /** Human-readable description of the environment */
          description: string;
          /** Base URL of the target server instance */
          url: string;
          /** Authentication login/username */
          login: string;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the environment was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the environment was last updated
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /**
         * Total number of environments matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/environments`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single environment by its unique identifier (password excluded)
   *
   * @tags Environments
   * @name EnvironmentsDetail
   * @summary Get environment by ID
   * @request GET:/api/environments/{id}
   * @secure
   */
  environmentsDetail = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        /** Unique identifier for the environment */
        id: string;
        /** Human-readable description of the environment */
        description: string;
        /** Base URL of the target server instance */
        url: string;
        /** Authentication login/username */
        login: string;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the environment was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the environment was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/environments/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing environment with optimistic locking
   *
   * @tags Environments
   * @name EnvironmentsUpdate
   * @summary Update environment
   * @request PUT:/api/environments/{id}
   * @secure
   */
  environmentsUpdate = (
    id: string,
    data: {
      /**
       * Updated environment description
       * @minLength 1
       */
      description?: string;
      /**
       * Updated base URL
       * @format uri
       */
      url?: string;
      /**
       * Updated authentication login
       * @minLength 1
       */
      login?: string;
      /**
       * Updated authentication password
       * @minLength 1
       */
      password?: string;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the environment */
        id: string;
        /** Human-readable description of the environment */
        description: string;
        /** Base URL of the target server instance */
        url: string;
        /** Authentication login/username */
        login: string;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the environment was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the environment was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/environments/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes an environment with optimistic locking
   *
   * @tags Environments
   * @name EnvironmentsDelete
   * @summary Delete environment
   * @request DELETE:/api/environments/{id}
   * @secure
   */
  environmentsDelete = (
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/environments/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific environment
   *
   * @tags Environments
   * @name EnvironmentsAuditLogsList
   * @summary Get environment audit logs
   * @request GET:/api/environments/{id}/audit-logs
   * @secure
   */
  environmentsAuditLogsList = (id: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/environments/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Authenticates against the stored environment and returns lightweight stubs (id + name) of all entities that would be pulled with the given selection — without writing any data. Same query params as GET /api/migration/preview on the source instance.
   *
   * @tags Environments
   * @name EnvironmentsMigrationScopeList
   * @summary Preview remote migration scope
   * @request GET:/api/environments/{id}/migration/scope
   * @secure
   */
  environmentsMigrationScopeList = (
    id: string,
    query?: {
      /** Specific project IDs to export (comma-separated or repeated). Omit for all projects. */
      projectIds?: string | string[];
      /** Specific stage IDs to export. */
      stageIds?: string | string[];
      /** Specific agent IDs to export. */
      agentIds?: string | string[];
      /** Specific classifier IDs to export. */
      classifierIds?: string | string[];
      /** Specific context transformer IDs to export. */
      contextTransformerIds?: string | string[];
      /** Specific tool IDs to export. */
      toolIds?: string | string[];
      /** Specific global action IDs to export. */
      globalActionIds?: string | string[];
      /** Specific knowledge category IDs to export. All child items are included. */
      knowledgeCategoryIds?: string | string[];
      /** Specific provider IDs to export (added on top of transitively required ones). */
      providerIds?: string | string[];
      /** Specific API key IDs to export. */
      apiKeyIds?: string | string[];
      /** Specific document IDs to export. */
      documentIds?: string | string[];
      /** Specific tester IDs to export. */
      testerIds?: string | string[];
      /** Specific scenario IDs to export. */
      scenarioIds?: string | string[];
      /** Specific guardrail IDs to export. */
      guardrailIds?: string | string[];
      /** Specific copy decorator IDs to export. */
      copyDecoratorIds?: string | string[];
      /** Specific sample copy IDs to export. */
      sampleCopyIds?: string | string[];
      /** Specific saved slice query IDs to export. */
      savedSliceQueryIds?: string | string[];
      /** Specific saved funnel query IDs to export. */
      savedFunnelQueryIds?: string | string[];
      /** Specific builder skill IDs to export. */
      builderSkillIds?: string | string[];
      /** Specific builder operation mode IDs to export. */
      builderOperationModeIds?: string | string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<MigrationPreview, void>({
      path: `/api/environments/${id}/migration/scope`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Authenticates against the stored environment, checks schema compatibility, fetches the remote export bundle, and imports it locally — all server-side. Returns a job immediately with status "pending"; poll GET /api/environments/{id}/migration/jobs/{jobId} for progress.
   *
   * @tags Environments
   * @name EnvironmentsMigrationPullCreate
   * @summary Pull data from environment
   * @request POST:/api/environments/{id}/migration/pull
   * @secure
   */
  environmentsMigrationPullCreate = (
    id: string,
    data: {
      /**
       * Granular entity selection. Omit or pass {} to pull everything.
       * @default {}
       */
      selection?: {
        /** Specific project IDs to include. Pulls all child entities (stages, agents, classifiers, etc.) for these projects. */
        projectIds?: string[];
        /** Specific stage IDs to include. Transitively pulls in the stage's agent, classifiers, context transformers, global actions, and all referenced providers. */
        stageIds?: string[];
        /** Specific agent IDs to include. Pulls in referenced TTS provider. */
        agentIds?: string[];
        /** Specific classifier IDs to include. Pulls in referenced LLM provider. */
        classifierIds?: string[];
        /** Specific context transformer IDs to include. Pulls in referenced LLM provider. */
        contextTransformerIds?: string[];
        /** Specific tool IDs to include. Pulls in referenced LLM provider. */
        toolIds?: string[];
        /** Specific global action IDs to include. */
        globalActionIds?: string[];
        /** Specific knowledge category IDs to include. All child knowledge items are always included. */
        knowledgeCategoryIds?: string[];
        /** Specific provider IDs to include (in addition to any transitively required ones). */
        providerIds?: string[];
        /** Specific API key IDs to include. */
        apiKeyIds?: string[];
        /** Specific document IDs to include. All document categories (global) are always included when any documents are exported. */
        documentIds?: string[];
        /** Specific tester IDs to include. */
        testerIds?: string[];
        /** Specific scenario IDs to include. */
        scenarioIds?: string[];
        /** Specific guardrail IDs to include. */
        guardrailIds?: string[];
        /** Specific copy decorator IDs to include. */
        copyDecoratorIds?: string[];
        /** Specific sample copy IDs to include. Transitively pulls in referenced copyDecorators and classifiers. */
        sampleCopyIds?: string[];
        /** Specific saved slice query IDs to include. */
        savedSliceQueryIds?: string[];
        /** Specific saved funnel query IDs to include. */
        savedFunnelQueryIds?: string[];
        /** Specific builder skill IDs to include. */
        builderSkillIds?: string[];
        /** Specific builder operation mode IDs to include. */
        builderOperationModeIds?: string[];
      };
      /**
       * If true, bypass schema hash mismatch check
       * @default false
       */
      force?: boolean;
      /**
       * If true, simulate the pull without writing to the database
       * @default false
       */
      dryRun?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<MigrationJob, void>({
      path: `/api/environments/${id}/migration/pull`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the current state of an async pull job scoped to this environment. Jobs are held in process memory — a server restart clears all job history.
   *
   * @tags Environments
   * @name EnvironmentsMigrationJobsDetail
   * @summary Get migration job status
   * @request GET:/api/environments/{id}/migration/jobs/{jobId}
   * @secure
   */
  environmentsMigrationJobsDetail = (
    id: string,
    jobId: string,
    params: RequestParams = {},
  ) =>
    this.request<MigrationJob, void>({
      path: `/api/environments/${id}/migration/jobs/${jobId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new global action with specified name, prompt trigger, operations, and configuration
   *
   * @tags Global Actions
   * @name ProjectsGlobalActionsCreate
   * @summary Create a new global action
   * @request POST:/api/projects/{projectId}/global-actions
   * @secure
   */
  projectsGlobalActionsCreate = (
    projectId: string,
    data: {
      /**
       * Unique identifier for the global action (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Display name of the global action
       * @minLength 1
       */
      name: string;
      /** Optional condition expression for action activation */
      condition?: string | null;
      /**
       * Whether this action should be triggered on user input
       * @default true
       */
      triggerOnUserInput?: boolean;
      /**
       * Whether this action should be triggered on client commands
       * @default false
       */
      triggerOnClientCommand?: boolean;
      /** Optional natural-language user intent description that triggers this action (for example: "User wants to exit") */
      classificationTrigger?: string | null;
      /** Optional classifier ID - if set, this action is only enumerated for that specific classifier */
      overrideClassifierId?: string | null;
      /** Optional array of parameters to extract from user input */
      parameters?: StageActionParameter[];
      /** Array of effects to execute when action is triggered */
      effects?: Effect[];
      /** Example phrases that trigger this action */
      examples?: string[];
      /**
       * Tags for categorizing and filtering this global action
       * @default []
       */
      tags?: string[];
      /** Additional action-specific metadata */
      metadata?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the global action */
        id: string;
        /** ID of the project this global action belongs to */
        projectId: string;
        /** Display name of the global action */
        name: string;
        /** Condition expression for action activation */
        condition: string | null;
        /** Whether this action should be triggered on user input */
        triggerOnUserInput: boolean;
        /** Whether this action should be triggered on client commands */
        triggerOnClientCommand: boolean;
        /** Optional natural-language user intent description that triggers this action */
        classificationTrigger: string | null;
        /** Optional classifier ID - if set, this action is only enumerated for that specific classifier */
        overrideClassifierId: string | null;
        /** Array of parameters to extract from user input */
        parameters: StageActionParameter[];
        /** Array of effects to execute */
        effects: Effect[];
        /** Example phrases that trigger this action */
        examples: string[] | null;
        /** Tags for categorizing and filtering this global action */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the global action was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the global action was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/global-actions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of global actions with optional filtering and sorting
   *
   * @tags Global Actions
   * @name ProjectsGlobalActionsList
   * @summary List global actions
   * @request GET:/api/projects/{projectId}/global-actions
   * @secure
   */
  projectsGlobalActionsList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of global actions in the current page */
        items: {
          /** Unique identifier for the global action */
          id: string;
          /** ID of the project this global action belongs to */
          projectId: string;
          /** Display name of the global action */
          name: string;
          /** Condition expression for action activation */
          condition: string | null;
          /** Whether this action should be triggered on user input */
          triggerOnUserInput: boolean;
          /** Whether this action should be triggered on client commands */
          triggerOnClientCommand: boolean;
          /** Optional natural-language user intent description that triggers this action */
          classificationTrigger: string | null;
          /** Optional classifier ID - if set, this action is only enumerated for that specific classifier */
          overrideClassifierId: string | null;
          /** Array of parameters to extract from user input */
          parameters: StageActionParameter[];
          /** Array of effects to execute */
          effects: Effect[];
          /** Example phrases that trigger this action */
          examples: string[] | null;
          /** Tags for categorizing and filtering this global action */
          tags: string[];
          /** Additional metadata */
          metadata: Record<string, any>;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the global action was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the global action was last updated
           * @format date-time
           */
          updatedAt: string | null;
          /** Whether this entity belongs to an archived project */
          archived?: boolean;
        }[];
        /**
         * Total number of global actions matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/global-actions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single global action by its unique identifier
   *
   * @tags Global Actions
   * @name ProjectsGlobalActionsDetail
   * @summary Get global action by ID
   * @request GET:/api/projects/{projectId}/global-actions/{id}
   * @secure
   */
  projectsGlobalActionsDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the global action */
        id: string;
        /** ID of the project this global action belongs to */
        projectId: string;
        /** Display name of the global action */
        name: string;
        /** Condition expression for action activation */
        condition: string | null;
        /** Whether this action should be triggered on user input */
        triggerOnUserInput: boolean;
        /** Whether this action should be triggered on client commands */
        triggerOnClientCommand: boolean;
        /** Optional natural-language user intent description that triggers this action */
        classificationTrigger: string | null;
        /** Optional classifier ID - if set, this action is only enumerated for that specific classifier */
        overrideClassifierId: string | null;
        /** Array of parameters to extract from user input */
        parameters: StageActionParameter[];
        /** Array of effects to execute */
        effects: Effect[];
        /** Example phrases that trigger this action */
        examples: string[] | null;
        /** Tags for categorizing and filtering this global action */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the global action was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the global action was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/global-actions/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing global action with optimistic locking
   *
   * @tags Global Actions
   * @name ProjectsGlobalActionsUpdate
   * @summary Update global action
   * @request PUT:/api/projects/{projectId}/global-actions/{id}
   * @secure
   */
  projectsGlobalActionsUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * Updated display name
       * @minLength 1
       */
      name?: string;
      /** Updated condition expression */
      condition?: string | null;
      /** Updated trigger on user input flag */
      triggerOnUserInput?: boolean;
      /** Updated trigger on client command flag */
      triggerOnClientCommand?: boolean;
      /** Updated natural-language user intent description used to trigger this action */
      classificationTrigger?: string | null;
      /** Updated override classifier ID */
      overrideClassifierId?: string | null;
      /** Updated parameters array */
      parameters?: StageActionParameter[];
      /** Updated effects array */
      effects?: Effect[];
      /** Updated example phrases */
      examples?: string[];
      /** Updated tags */
      tags?: string[];
      /** Updated metadata */
      metadata?: Record<string, any>;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the global action */
        id: string;
        /** ID of the project this global action belongs to */
        projectId: string;
        /** Display name of the global action */
        name: string;
        /** Condition expression for action activation */
        condition: string | null;
        /** Whether this action should be triggered on user input */
        triggerOnUserInput: boolean;
        /** Whether this action should be triggered on client commands */
        triggerOnClientCommand: boolean;
        /** Optional natural-language user intent description that triggers this action */
        classificationTrigger: string | null;
        /** Optional classifier ID - if set, this action is only enumerated for that specific classifier */
        overrideClassifierId: string | null;
        /** Array of parameters to extract from user input */
        parameters: StageActionParameter[];
        /** Array of effects to execute */
        effects: Effect[];
        /** Example phrases that trigger this action */
        examples: string[] | null;
        /** Tags for categorizing and filtering this global action */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the global action was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the global action was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/global-actions/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a global action with optimistic locking
   *
   * @tags Global Actions
   * @name ProjectsGlobalActionsDelete
   * @summary Delete global action
   * @request DELETE:/api/projects/{projectId}/global-actions/{id}
   * @secure
   */
  projectsGlobalActionsDelete = (
    projectId: string,
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/global-actions/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific global action
   *
   * @tags Global Actions
   * @name ProjectsGlobalActionsAuditLogsList
   * @summary Get global action audit logs
   * @request GET:/api/projects/{projectId}/global-actions/{id}/audit-logs
   * @secure
   */
  projectsGlobalActionsAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/global-actions/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a copy of an existing global action with a new ID and optional name override
   *
   * @tags Global Actions
   * @name ProjectsGlobalActionsCloneCreate
   * @summary Clone global action
   * @request POST:/api/projects/{projectId}/global-actions/{id}/clone
   * @secure
   */
  projectsGlobalActionsCloneCreate = (
    projectId: string,
    id: string,
    data: {
      /**
       * New ID for the cloned global action (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Name for the cloned global action (defaults to "{original name} (Clone)")
       * @minLength 1
       */
      name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the global action */
        id: string;
        /** ID of the project this global action belongs to */
        projectId: string;
        /** Display name of the global action */
        name: string;
        /** Condition expression for action activation */
        condition: string | null;
        /** Whether this action should be triggered on user input */
        triggerOnUserInput: boolean;
        /** Whether this action should be triggered on client commands */
        triggerOnClientCommand: boolean;
        /** Optional natural-language user intent description that triggers this action */
        classificationTrigger: string | null;
        /** Optional classifier ID - if set, this action is only enumerated for that specific classifier */
        overrideClassifierId: string | null;
        /** Array of parameters to extract from user input */
        parameters: StageActionParameter[];
        /** Array of effects to execute */
        effects: Effect[];
        /** Example phrases that trigger this action */
        examples: string[] | null;
        /** Tags for categorizing and filtering this global action */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the global action was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the global action was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/global-actions/${id}/clone`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new sample copy with a set of variant answers and classifier trigger configuration
   *
   * @tags Sample Copies
   * @name ProjectsSampleCopiesCreate
   * @summary Create a new sample copy
   * @request POST:/api/projects/{projectId}/sample-copies
   * @secure
   */
  projectsSampleCopiesCreate = (
    projectId: string,
    data: {
      /**
       * Unique identifier for the sample copy (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Display name of the sample copy, used as identifier throughout the system
       * @minLength 1
       */
      name: string;
      /** Optional array of stage IDs this sample copy applies to */
      stages?: string[];
      /** Optional array of agent IDs this sample copy applies to */
      agents?: string[];
      /**
       * Trigger string used by the classifier to activate this sample copy
       * @minLength 1
       */
      promptTrigger: string;
      /** ID of the classifier to use; if not set the default classifier will be used */
      classifierOverrideId?: string | null;
      /**
       * Array of variant answers to select from
       * @minItems 1
       */
      content: string[];
      /**
       * Number of samples to select from the content array
       * @min 1
       * @default 1
       */
      amount?: number;
      /**
       * Method used to select samples: random selection or sequential round-robin
       * @default "random"
       */
      samplingMethod?: "random" | "round_robin";
      /**
       * Mode of the sample copy: regular works as normal, forced enforces the prescripted response and ignores other response-related effects
       * @default "regular"
       */
      mode?: "regular" | "forced";
      /** ID of the copy decorator to apply to selected content; if not set no decoration is applied */
      decoratorId?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the sample copy */
        id: string;
        /** ID of the project this sample copy belongs to */
        projectId: string;
        /** Display name of the sample copy */
        name: string;
        /** Array of stage IDs this sample copy applies to */
        stages: string[] | null;
        /** Array of agent IDs this sample copy applies to */
        agents: string[] | null;
        /** Trigger string used by the classifier */
        promptTrigger: string;
        /** ID of the classifier override, or null if using the default */
        classifierOverrideId: string | null;
        /** Array of variant answers */
        content: string[];
        /** Number of samples to select */
        amount: number;
        /** Method used to select samples */
        samplingMethod: "random" | "round_robin";
        /** Mode of the sample copy: regular works as normal, forced enforces the prescripted response and ignores other response-related effects */
        mode: "regular" | "forced";
        /** ID of the copy decorator applied to selected content, or null if none */
        decoratorId: string | null;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the sample copy was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the sample copy was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/sample-copies`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of sample copies with optional filtering and sorting
   *
   * @tags Sample Copies
   * @name ProjectsSampleCopiesList
   * @summary List sample copies
   * @request GET:/api/projects/{projectId}/sample-copies
   * @secure
   */
  projectsSampleCopiesList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of sample copies in the current page */
        items: {
          /** Unique identifier for the sample copy */
          id: string;
          /** ID of the project this sample copy belongs to */
          projectId: string;
          /** Display name of the sample copy */
          name: string;
          /** Array of stage IDs this sample copy applies to */
          stages: string[] | null;
          /** Array of agent IDs this sample copy applies to */
          agents: string[] | null;
          /** Trigger string used by the classifier */
          promptTrigger: string;
          /** ID of the classifier override, or null if using the default */
          classifierOverrideId: string | null;
          /** Array of variant answers */
          content: string[];
          /** Number of samples to select */
          amount: number;
          /** Method used to select samples */
          samplingMethod: "random" | "round_robin";
          /** Mode of the sample copy: regular works as normal, forced enforces the prescripted response and ignores other response-related effects */
          mode: "regular" | "forced";
          /** ID of the copy decorator applied to selected content, or null if none */
          decoratorId: string | null;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the sample copy was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the sample copy was last updated
           * @format date-time
           */
          updatedAt: string | null;
          /** Whether this entity belongs to an archived project */
          archived?: boolean;
        }[];
        /**
         * Total number of sample copies matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/sample-copies`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single sample copy by its unique identifier
   *
   * @tags Sample Copies
   * @name ProjectsSampleCopiesDetail
   * @summary Get sample copy by ID
   * @request GET:/api/projects/{projectId}/sample-copies/{id}
   * @secure
   */
  projectsSampleCopiesDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the sample copy */
        id: string;
        /** ID of the project this sample copy belongs to */
        projectId: string;
        /** Display name of the sample copy */
        name: string;
        /** Array of stage IDs this sample copy applies to */
        stages: string[] | null;
        /** Array of agent IDs this sample copy applies to */
        agents: string[] | null;
        /** Trigger string used by the classifier */
        promptTrigger: string;
        /** ID of the classifier override, or null if using the default */
        classifierOverrideId: string | null;
        /** Array of variant answers */
        content: string[];
        /** Number of samples to select */
        amount: number;
        /** Method used to select samples */
        samplingMethod: "random" | "round_robin";
        /** Mode of the sample copy: regular works as normal, forced enforces the prescripted response and ignores other response-related effects */
        mode: "regular" | "forced";
        /** ID of the copy decorator applied to selected content, or null if none */
        decoratorId: string | null;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the sample copy was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the sample copy was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/sample-copies/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing sample copy with optimistic locking
   *
   * @tags Sample Copies
   * @name ProjectsSampleCopiesUpdate
   * @summary Update sample copy
   * @request PUT:/api/projects/{projectId}/sample-copies/{id}
   * @secure
   */
  projectsSampleCopiesUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * Updated display name
       * @minLength 1
       */
      name?: string;
      /** Updated array of stage IDs */
      stages?: string[] | null;
      /** Updated array of agent IDs */
      agents?: string[] | null;
      /**
       * Updated classifier trigger string
       * @minLength 1
       */
      promptTrigger?: string;
      /** Updated classifier override ID */
      classifierOverrideId?: string | null;
      /**
       * Updated array of variant answers
       * @minItems 1
       */
      content?: string[];
      /**
       * Updated number of samples to select
       * @min 1
       */
      amount?: number;
      /** Updated sampling method */
      samplingMethod?: "random" | "round_robin";
      /** Updated mode: regular works as normal, forced enforces the prescripted response and ignores other response-related effects */
      mode?: "regular" | "forced";
      /** Updated copy decorator ID; set to null to remove the decorator */
      decoratorId?: string | null;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the sample copy */
        id: string;
        /** ID of the project this sample copy belongs to */
        projectId: string;
        /** Display name of the sample copy */
        name: string;
        /** Array of stage IDs this sample copy applies to */
        stages: string[] | null;
        /** Array of agent IDs this sample copy applies to */
        agents: string[] | null;
        /** Trigger string used by the classifier */
        promptTrigger: string;
        /** ID of the classifier override, or null if using the default */
        classifierOverrideId: string | null;
        /** Array of variant answers */
        content: string[];
        /** Number of samples to select */
        amount: number;
        /** Method used to select samples */
        samplingMethod: "random" | "round_robin";
        /** Mode of the sample copy: regular works as normal, forced enforces the prescripted response and ignores other response-related effects */
        mode: "regular" | "forced";
        /** ID of the copy decorator applied to selected content, or null if none */
        decoratorId: string | null;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the sample copy was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the sample copy was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/sample-copies/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a sample copy with optimistic locking
   *
   * @tags Sample Copies
   * @name ProjectsSampleCopiesDelete
   * @summary Delete sample copy
   * @request DELETE:/api/projects/{projectId}/sample-copies/{id}
   * @secure
   */
  projectsSampleCopiesDelete = (
    projectId: string,
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/sample-copies/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific sample copy
   *
   * @tags Sample Copies
   * @name ProjectsSampleCopiesAuditLogsList
   * @summary Get sample copy audit logs
   * @request GET:/api/projects/{projectId}/sample-copies/{id}/audit-logs
   * @secure
   */
  projectsSampleCopiesAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/sample-copies/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a copy of an existing sample copy with a new ID and optional name override
   *
   * @tags Sample Copies
   * @name ProjectsSampleCopiesCloneCreate
   * @summary Clone sample copy
   * @request POST:/api/projects/{projectId}/sample-copies/{id}/clone
   * @secure
   */
  projectsSampleCopiesCloneCreate = (
    projectId: string,
    id: string,
    data: {
      /**
       * New ID for the cloned sample copy (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Name for the cloned sample copy (defaults to "{original name} (Clone)")
       * @minLength 1
       */
      name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the sample copy */
        id: string;
        /** ID of the project this sample copy belongs to */
        projectId: string;
        /** Display name of the sample copy */
        name: string;
        /** Array of stage IDs this sample copy applies to */
        stages: string[] | null;
        /** Array of agent IDs this sample copy applies to */
        agents: string[] | null;
        /** Trigger string used by the classifier */
        promptTrigger: string;
        /** ID of the classifier override, or null if using the default */
        classifierOverrideId: string | null;
        /** Array of variant answers */
        content: string[];
        /** Number of samples to select */
        amount: number;
        /** Method used to select samples */
        samplingMethod: "random" | "round_robin";
        /** Mode of the sample copy: regular works as normal, forced enforces the prescripted response and ignores other response-related effects */
        mode: "regular" | "forced";
        /** ID of the copy decorator applied to selected content, or null if none */
        decoratorId: string | null;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the sample copy was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the sample copy was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/sample-copies/${id}/clone`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new copy decorator with a name and template string
   *
   * @tags Copy Decorators
   * @name ProjectsCopyDecoratorsCreate
   * @summary Create a new copy decorator
   * @request POST:/api/projects/{projectId}/copy-decorators
   * @secure
   */
  projectsCopyDecoratorsCreate = (
    projectId: string,
    data: {
      /**
       * Unique identifier for the copy decorator (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Human-readable display name of the copy decorator
       * @minLength 1
       */
      name: string;
      /**
       * Template string used to decorate selected sample copy content
       * @minLength 1
       */
      template: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the copy decorator */
        id: string;
        /** ID of the project this copy decorator belongs to */
        projectId: string;
        /** Human-readable display name of the copy decorator */
        name: string;
        /** Template string used to decorate sample copy content */
        template: string;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the copy decorator was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the copy decorator was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/copy-decorators`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of copy decorators with optional filtering and sorting
   *
   * @tags Copy Decorators
   * @name ProjectsCopyDecoratorsList
   * @summary List copy decorators
   * @request GET:/api/projects/{projectId}/copy-decorators
   * @secure
   */
  projectsCopyDecoratorsList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of copy decorators in the current page */
        items: {
          /** Unique identifier for the copy decorator */
          id: string;
          /** ID of the project this copy decorator belongs to */
          projectId: string;
          /** Human-readable display name of the copy decorator */
          name: string;
          /** Template string used to decorate sample copy content */
          template: string;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the copy decorator was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the copy decorator was last updated
           * @format date-time
           */
          updatedAt: string | null;
          /** Whether this entity belongs to an archived project */
          archived?: boolean;
        }[];
        /**
         * Total number of copy decorators matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/copy-decorators`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single copy decorator by its unique identifier
   *
   * @tags Copy Decorators
   * @name ProjectsCopyDecoratorsDetail
   * @summary Get copy decorator by ID
   * @request GET:/api/projects/{projectId}/copy-decorators/{id}
   * @secure
   */
  projectsCopyDecoratorsDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the copy decorator */
        id: string;
        /** ID of the project this copy decorator belongs to */
        projectId: string;
        /** Human-readable display name of the copy decorator */
        name: string;
        /** Template string used to decorate sample copy content */
        template: string;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the copy decorator was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the copy decorator was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/copy-decorators/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing copy decorator with optimistic locking
   *
   * @tags Copy Decorators
   * @name ProjectsCopyDecoratorsUpdate
   * @summary Update copy decorator
   * @request PUT:/api/projects/{projectId}/copy-decorators/{id}
   * @secure
   */
  projectsCopyDecoratorsUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * Updated display name
       * @minLength 1
       */
      name?: string;
      /**
       * Updated template string
       * @minLength 1
       */
      template?: string;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the copy decorator */
        id: string;
        /** ID of the project this copy decorator belongs to */
        projectId: string;
        /** Human-readable display name of the copy decorator */
        name: string;
        /** Template string used to decorate sample copy content */
        template: string;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the copy decorator was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the copy decorator was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/copy-decorators/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a copy decorator with optimistic locking
   *
   * @tags Copy Decorators
   * @name ProjectsCopyDecoratorsDelete
   * @summary Delete copy decorator
   * @request DELETE:/api/projects/{projectId}/copy-decorators/{id}
   * @secure
   */
  projectsCopyDecoratorsDelete = (
    projectId: string,
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/copy-decorators/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific copy decorator
   *
   * @tags Copy Decorators
   * @name ProjectsCopyDecoratorsAuditLogsList
   * @summary Get copy decorator audit logs
   * @request GET:/api/projects/{projectId}/copy-decorators/{id}/audit-logs
   * @secure
   */
  projectsCopyDecoratorsAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/copy-decorators/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a new guardrail with specified name, classification trigger, and effects. Guardrails fire on every stage using the project-level classifier.
   *
   * @tags Guardrails
   * @name ProjectsGuardrailsCreate
   * @summary Create a new guardrail
   * @request POST:/api/projects/{projectId}/guardrails
   * @secure
   */
  projectsGuardrailsCreate = (
    projectId: string,
    data: {
      /**
       * Unique identifier for the guardrail (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Display name of the guardrail
       * @minLength 1
       */
      name: string;
      /** Optional JavaScript condition expression — when provided, the guardrail is only active when it evaluates to truthy */
      condition?: string | null;
      /** Natural-language unsafe user intent description that should trigger this guardrail (for example: "User requests self-harm instructions") */
      classificationTrigger?: string | null;
      /** Array of effects to execute when the guardrail is triggered */
      effects?: Effect[];
      /** Example phrases that trigger this guardrail, used to help the classifier */
      examples?: string[];
      /**
       * Tags for categorizing and filtering this guardrail
       * @default []
       */
      tags?: string[];
      /** Additional guardrail-specific metadata */
      metadata?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the guardrail */
        id: string;
        /** ID of the project this guardrail belongs to */
        projectId: string;
        /** Display name of the guardrail */
        name: string;
        /** Condition expression for guardrail activation */
        condition: string | null;
        /** Natural-language unsafe user intent description that triggers this guardrail */
        classificationTrigger: string | null;
        /** Array of effects to execute */
        effects: Effect[];
        /** Example phrases that trigger this guardrail */
        examples: string[] | null;
        /** Tags for categorizing and filtering this guardrail */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the guardrail was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the guardrail was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/guardrails`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of guardrails with optional filtering and sorting
   *
   * @tags Guardrails
   * @name ProjectsGuardrailsList
   * @summary List guardrails
   * @request GET:/api/projects/{projectId}/guardrails
   * @secure
   */
  projectsGuardrailsList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of guardrails in the current page */
        items: {
          /** Unique identifier for the guardrail */
          id: string;
          /** ID of the project this guardrail belongs to */
          projectId: string;
          /** Display name of the guardrail */
          name: string;
          /** Condition expression for guardrail activation */
          condition: string | null;
          /** Natural-language unsafe user intent description that triggers this guardrail */
          classificationTrigger: string | null;
          /** Array of effects to execute */
          effects: Effect[];
          /** Example phrases that trigger this guardrail */
          examples: string[] | null;
          /** Tags for categorizing and filtering this guardrail */
          tags: string[];
          /** Additional metadata */
          metadata: Record<string, any>;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the guardrail was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the guardrail was last updated
           * @format date-time
           */
          updatedAt: string | null;
          /** Whether this entity belongs to an archived project */
          archived?: boolean;
        }[];
        /**
         * Total number of guardrails matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/guardrails`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single guardrail by its unique identifier
   *
   * @tags Guardrails
   * @name ProjectsGuardrailsDetail
   * @summary Get guardrail by ID
   * @request GET:/api/projects/{projectId}/guardrails/{id}
   * @secure
   */
  projectsGuardrailsDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the guardrail */
        id: string;
        /** ID of the project this guardrail belongs to */
        projectId: string;
        /** Display name of the guardrail */
        name: string;
        /** Condition expression for guardrail activation */
        condition: string | null;
        /** Natural-language unsafe user intent description that triggers this guardrail */
        classificationTrigger: string | null;
        /** Array of effects to execute */
        effects: Effect[];
        /** Example phrases that trigger this guardrail */
        examples: string[] | null;
        /** Tags for categorizing and filtering this guardrail */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the guardrail was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the guardrail was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/guardrails/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing guardrail with optimistic locking
   *
   * @tags Guardrails
   * @name ProjectsGuardrailsUpdate
   * @summary Update guardrail
   * @request PUT:/api/projects/{projectId}/guardrails/{id}
   * @secure
   */
  projectsGuardrailsUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * Updated display name
       * @minLength 1
       */
      name?: string;
      /** Updated condition expression */
      condition?: string | null;
      /** Updated natural-language unsafe user intent description for this guardrail */
      classificationTrigger?: string | null;
      /** Updated effects array */
      effects?: Effect[];
      /** Updated example phrases */
      examples?: string[];
      /** Updated tags */
      tags?: string[];
      /** Updated metadata */
      metadata?: Record<string, any>;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the guardrail */
        id: string;
        /** ID of the project this guardrail belongs to */
        projectId: string;
        /** Display name of the guardrail */
        name: string;
        /** Condition expression for guardrail activation */
        condition: string | null;
        /** Natural-language unsafe user intent description that triggers this guardrail */
        classificationTrigger: string | null;
        /** Array of effects to execute */
        effects: Effect[];
        /** Example phrases that trigger this guardrail */
        examples: string[] | null;
        /** Tags for categorizing and filtering this guardrail */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the guardrail was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the guardrail was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/guardrails/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a guardrail with optimistic locking
   *
   * @tags Guardrails
   * @name ProjectsGuardrailsDelete
   * @summary Delete guardrail
   * @request DELETE:/api/projects/{projectId}/guardrails/{id}
   * @secure
   */
  projectsGuardrailsDelete = (
    projectId: string,
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/guardrails/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific guardrail
   *
   * @tags Guardrails
   * @name ProjectsGuardrailsAuditLogsList
   * @summary Get guardrail audit logs
   * @request GET:/api/projects/{projectId}/guardrails/{id}/audit-logs
   * @secure
   */
  projectsGuardrailsAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/guardrails/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a copy of an existing guardrail with a new ID and optional name override
   *
   * @tags Guardrails
   * @name ProjectsGuardrailsCloneCreate
   * @summary Clone guardrail
   * @request POST:/api/projects/{projectId}/guardrails/{id}/clone
   * @secure
   */
  projectsGuardrailsCloneCreate = (
    projectId: string,
    id: string,
    data: {
      /**
       * New ID for the cloned guardrail (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Name for the cloned guardrail (defaults to "{original name} (Clone)")
       * @minLength 1
       */
      name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the guardrail */
        id: string;
        /** ID of the project this guardrail belongs to */
        projectId: string;
        /** Display name of the guardrail */
        name: string;
        /** Condition expression for guardrail activation */
        condition: string | null;
        /** Natural-language unsafe user intent description that triggers this guardrail */
        classificationTrigger: string | null;
        /** Array of effects to execute */
        effects: Effect[];
        /** Example phrases that trigger this guardrail */
        examples: string[] | null;
        /** Tags for categorizing and filtering this guardrail */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the guardrail was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the guardrail was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/guardrails/${id}/clone`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single document category by its unique identifier
   *
   * @tags Document Categories
   * @name DocumentCategoriesDetail
   * @summary Get document category by ID
   * @request GET:/api/document-categories/{id}
   * @secure
   */
  documentCategoriesDetail = (id: string, params: RequestParams = {}) =>
    this.request<DocumentCategoryResponse, void>({
      path: `/api/document-categories/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of document categories with optional filtering and sorting. To manage categories use the methodology category sub-routes.
   *
   * @tags Document Categories
   * @name DocumentCategoriesList
   * @summary List document categories
   * @request GET:/api/document-categories
   * @secure
   */
  documentCategoriesList = (
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of document categories in the current page */
        items: DocumentCategoryResponse[];
        /**
         * Total number of categories matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/document-categories`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific document category
   *
   * @tags Document Categories
   * @name DocumentCategoriesAuditLogsList
   * @summary Get document category audit logs
   * @request GET:/api/document-categories/{id}/audit-logs
   * @secure
   */
  documentCategoriesAuditLogsList = (id: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/document-categories/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a new methodology with an optional list of document categories. System methodologies are seeded automatically and cannot be created via this endpoint.
   *
   * @tags Methodologies
   * @name MethodologiesCreate
   * @summary Create a new methodology
   * @request POST:/api/methodologies
   * @secure
   */
  methodologiesCreate = (
    data: {
      /**
       * Display name of the methodology
       * @minLength 1
       */
      name: string;
      /** Human-readable description of the methodology */
      description?: string | null;
      /**
       * Ordered list of document categories to create within this methodology
       * @default []
       */
      categories?: {
        /**
         * Display name of the document category
         * @minLength 1
         */
        name: string;
        /** Human-readable description of the category */
        description?: string | null;
        /**
         * Entity types this category of documents is relevant to
         * @default []
         */
        relatedEntityTypes?: string[];
        /**
         * When true, documents of this category are injected into the Builder system prompt at session start
         * @default false
         */
        preloadInBuilder?: boolean;
        /**
         * Display order within the methodology (ascending)
         * @min 0
         */
        order: number;
      }[];
    },
    params: RequestParams = {},
  ) =>
    this.request<Methodology, void>({
      path: `/api/methodologies`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns all methodologies including their ordered document categories
   *
   * @tags Methodologies
   * @name MethodologiesList
   * @summary List methodologies
   * @request GET:/api/methodologies
   * @secure
   */
  methodologiesList = (params: RequestParams = {}) =>
    this.request<
      {
        /** Array of methodologies */
        items: Methodology[];
        /**
         * Total number of methodologies
         * @min 0
         */
        total: number;
      },
      any
    >({
      path: `/api/methodologies`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single methodology with its ordered document categories
   *
   * @tags Methodologies
   * @name MethodologiesDetail
   * @summary Get methodology by ID
   * @request GET:/api/methodologies/{id}
   * @secure
   */
  methodologiesDetail = (id: string, params: RequestParams = {}) =>
    this.request<Methodology, void>({
      path: `/api/methodologies/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates name and/or description of an existing methodology with optimistic locking. System methodologies cannot be updated.
   *
   * @tags Methodologies
   * @name MethodologiesUpdate
   * @summary Update methodology
   * @request PUT:/api/methodologies/{id}
   * @secure
   */
  methodologiesUpdate = (
    id: string,
    data: {
      /**
       * Updated display name
       * @minLength 1
       */
      name?: string;
      /** Updated description */
      description?: string | null;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Methodology, void>({
      path: `/api/methodologies/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a methodology. Blocked if any projects reference it or if it is a system methodology.
   *
   * @tags Methodologies
   * @name MethodologiesDelete
   * @summary Delete methodology
   * @request DELETE:/api/methodologies/{id}
   * @secure
   */
  methodologiesDelete = (id: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/methodologies/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Adds a new document category to the specified methodology
   *
   * @tags Methodologies
   * @name MethodologiesCategoriesCreate
   * @summary Add category to methodology
   * @request POST:/api/methodologies/{id}/categories
   * @secure
   */
  methodologiesCategoriesCreate = (
    id: string,
    data: {
      /**
       * Display name of the document category
       * @minLength 1
       */
      name: string;
      /** Human-readable description of the category */
      description?: string | null;
      /**
       * Entity types this category of documents is relevant to
       * @default []
       */
      relatedEntityTypes?: string[];
      /**
       * When true, documents of this category are injected into the Builder system prompt at session start
       * @default false
       */
      preloadInBuilder?: boolean;
      /**
       * Display order within the methodology (ascending)
       * @min 0
       */
      order: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Methodology, void>({
      path: `/api/methodologies/${id}/categories`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing document category within a methodology with optimistic locking
   *
   * @tags Methodologies
   * @name MethodologiesCategoriesUpdate
   * @summary Update methodology category
   * @request PUT:/api/methodologies/{id}/categories/{categoryId}
   * @secure
   */
  methodologiesCategoriesUpdate = (
    id: string,
    categoryId: string,
    data: {
      /**
       * Updated display name
       * @minLength 1
       */
      name?: string;
      /** Updated description */
      description?: string | null;
      /** Updated list of related entity types */
      relatedEntityTypes?: string[];
      /** Updated Builder pre-loading flag */
      preloadInBuilder?: boolean;
      /**
       * Updated display order within the methodology
       * @min 0
       */
      order?: number;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Methodology, void>({
      path: `/api/methodologies/${id}/categories/${categoryId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Removes a document category from a methodology. Blocked if any documents reference this category.
   *
   * @tags Methodologies
   * @name MethodologiesCategoriesDelete
   * @summary Delete methodology category
   * @request DELETE:/api/methodologies/{id}/categories/{categoryId}
   * @secure
   */
  methodologiesCategoriesDelete = (
    id: string,
    categoryId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/methodologies/${id}/categories/${categoryId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a full copy of a methodology including all its categories. The clone is always a non-system methodology.
   *
   * @tags Methodologies
   * @name MethodologiesCloneCreate
   * @summary Clone methodology
   * @request POST:/api/methodologies/{id}/clone
   * @secure
   */
  methodologiesCloneCreate = (
    id: string,
    data: {
      /**
       * Name for the cloned methodology. Defaults to "Copy of <original name>"
       * @minLength 1
       */
      name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Methodology, void>({
      path: `/api/methodologies/${id}/clone`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new free-form markdown document attached to a project and categorized by a document category.
   *
   * @tags Documents
   * @name ProjectsDocumentsCreate
   * @summary Create a new document
   * @request POST:/api/projects/{projectId}/documents
   * @secure
   */
  projectsDocumentsCreate = (
    projectId: string,
    data: {
      /**
       * Unique identifier for the document (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * ID of the document category this document belongs to
       * @minLength 1
       */
      categoryId: string;
      /**
       * Title of the document
       * @minLength 1
       */
      title: string;
      /** Full document content in markdown format */
      content: string;
      /**
       * Tags for filtering and loose labeling of this document
       * @default []
       */
      tags?: string[];
      /** Additional document-specific metadata */
      metadata?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the document */
        id: string;
        /** ID of the project this document belongs to */
        projectId: string;
        /** ID of the document category */
        categoryId: string;
        /** Full document category object */
        category: DocumentCategoryResponse;
        /** Title of the document */
        title: string;
        /** Document content in markdown format */
        content: string;
        /** Tags for filtering and labeling */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the document was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the document was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this document belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/documents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of documents for a project. Supports filtering by categoryId and tags via the filters query parameter.
   *
   * @tags Documents
   * @name ProjectsDocumentsList
   * @summary List documents
   * @request GET:/api/projects/{projectId}/documents
   * @secure
   */
  projectsDocumentsList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of documents in the current page */
        items: {
          /** Unique identifier for the document */
          id: string;
          /** ID of the project this document belongs to */
          projectId: string;
          /** ID of the document category */
          categoryId: string;
          /** Full document category object */
          category: DocumentCategoryResponse;
          /** Title of the document */
          title: string;
          /** Document content in markdown format */
          content: string;
          /** Tags for filtering and labeling */
          tags: string[];
          /** Additional metadata */
          metadata: Record<string, any>;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the document was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the document was last updated
           * @format date-time
           */
          updatedAt: string | null;
          /** Whether this document belongs to an archived project */
          archived?: boolean;
        }[];
        /**
         * Total number of documents matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/documents`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single document by its unique identifier, including its full category object
   *
   * @tags Documents
   * @name ProjectsDocumentsDetail
   * @summary Get document by ID
   * @request GET:/api/projects/{projectId}/documents/{id}
   * @secure
   */
  projectsDocumentsDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the document */
        id: string;
        /** ID of the project this document belongs to */
        projectId: string;
        /** ID of the document category */
        categoryId: string;
        /** Full document category object */
        category: DocumentCategoryResponse;
        /** Title of the document */
        title: string;
        /** Document content in markdown format */
        content: string;
        /** Tags for filtering and labeling */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the document was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the document was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this document belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/documents/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing document with optimistic locking
   *
   * @tags Documents
   * @name ProjectsDocumentsUpdate
   * @summary Update document
   * @request PUT:/api/projects/{projectId}/documents/{id}
   * @secure
   */
  projectsDocumentsUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * Updated category ID
       * @minLength 1
       */
      categoryId?: string;
      /**
       * Updated title
       * @minLength 1
       */
      title?: string;
      /** Updated markdown content */
      content?: string;
      /** Updated tags */
      tags?: string[];
      /** Updated metadata */
      metadata?: Record<string, any>;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the document */
        id: string;
        /** ID of the project this document belongs to */
        projectId: string;
        /** ID of the document category */
        categoryId: string;
        /** Full document category object */
        category: DocumentCategoryResponse;
        /** Title of the document */
        title: string;
        /** Document content in markdown format */
        content: string;
        /** Tags for filtering and labeling */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the document was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the document was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this document belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/documents/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a document with optimistic locking
   *
   * @tags Documents
   * @name ProjectsDocumentsDelete
   * @summary Delete document
   * @request DELETE:/api/projects/{projectId}/documents/{id}
   * @secure
   */
  projectsDocumentsDelete = (
    projectId: string,
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/documents/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific document
   *
   * @tags Documents
   * @name ProjectsDocumentsAuditLogsList
   * @summary Get document audit logs
   * @request GET:/api/projects/{projectId}/documents/{id}/audit-logs
   * @secure
   */
  projectsDocumentsAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/documents/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Exports one or more documents as Markdown. A single document is returned as a .md file; multiple documents are returned as a .zip archive (or a single merged .md file when merge is true).
   *
   * @tags Documents
   * @name ProjectsDocumentsExportCreate
   * @summary Export documents
   * @request POST:/api/projects/{projectId}/documents/export
   * @secure
   */
  projectsDocumentsExportCreate = (
    projectId: string,
    data: {
      /**
       * One or more document IDs to export
       * @minItems 1
       */
      ids: string[];
      /** Export format: "markdown", "docx" (Microsoft Word), or "odt" (OpenDocument Text). docx and odt require Pandoc to be installed on the server. */
      format: ExportFormat;
      /**
       * When true, all documents are merged into a single combined file instead of a ZIP archive (only applicable when exporting multiple documents)
       * @default false
       */
      merge?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<File, void>({
      path: `/api/projects/${projectId}/documents/export`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Creates a new issue report with bug details, environment, and severity information
   *
   * @tags Issues
   * @name IssuesCreate
   * @summary Create a new issue
   * @request POST:/api/issues
   * @secure
   */
  issuesCreate = (
    data: {
      /**
       * ID of the project this issue belongs to
       * @minLength 1
       */
      projectId: string;
      /** Environment where issue occurred (e.g., production, staging, development) */
      environment?: string;
      /**
       * Application build version where the issue was encountered
       * @minLength 1
       */
      buildVersion: string;
      /** Stage identifier for tracking purposes */
      stage?: string;
      /** Reference to related conversation ID */
      conversationId?: string;
      /** Index of event in session where issue occurred */
      eventIndex?: number;
      /** User ID who reported or encountered the issue */
      userId?: string;
      /** Issue severity level */
      severity: "critical" | "major" | "minor" | "trivial";
      /** Issue category or type */
      category: "intent" | "ai answer" | "entity" | "tool";
      /**
       * Detailed description of the bug or issue
       * @minLength 1
       */
      bugDescription: string;
      /**
       * Description of the expected behavior
       * @minLength 1
       */
      expectedBehaviour: string;
      /**
       * Additional comments or notes about the issue
       * @default ""
       */
      comments?: string;
      /** Current issue status */
      status:
        | "awaiting"
        | "in-progress"
        | "ready-to-test"
        | "still-occurs"
        | "done"
        | "cannot-reproduce"
        | "wont-fix";
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique auto-incrementing identifier for the issue */
        id: number;
        /** ID of the project this issue belongs to */
        projectId: string;
        /** Environment where issue occurred */
        environment: string;
        /** Application build version */
        buildVersion: string;
        /** Stage identifier */
        stage: string | null;
        /** Related conversation ID */
        conversationId: string | null;
        /** Event index in session */
        eventIndex: number | null;
        /** User ID who reported the issue */
        userId: string | null;
        /** Issue severity level */
        severity: "critical" | "major" | "minor" | "trivial";
        /** Issue category or type */
        category: "intent" | "ai answer" | "entity" | "tool";
        /** Detailed bug description */
        bugDescription: string;
        /** Expected behavior description */
        expectedBehaviour: string;
        /** Additional comments or notes */
        comments: string;
        /** Current issue status */
        status:
          | "awaiting"
          | "in-progress"
          | "ready-to-test"
          | "still-occurs"
          | "done"
          | "cannot-reproduce"
          | "wont-fix";
        /**
         * Timestamp when the issue was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the issue was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/issues`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of issues with optional filtering by projectId, status, severity, environment, and text search in bug descriptions. Use filters[projectId]=value to filter by project.
   *
   * @tags Issues
   * @name IssuesList
   * @summary List issues
   * @request GET:/api/issues
   * @secure
   */
  issuesList = (
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of issues in the current page */
        items: {
          /** Unique auto-incrementing identifier for the issue */
          id: number;
          /** ID of the project this issue belongs to */
          projectId: string;
          /** Environment where issue occurred */
          environment: string;
          /** Application build version */
          buildVersion: string;
          /** Stage identifier */
          stage: string | null;
          /** Related conversation ID */
          conversationId: string | null;
          /** Event index in session */
          eventIndex: number | null;
          /** User ID who reported the issue */
          userId: string | null;
          /** Issue severity level */
          severity: "critical" | "major" | "minor" | "trivial";
          /** Issue category or type */
          category: "intent" | "ai answer" | "entity" | "tool";
          /** Detailed bug description */
          bugDescription: string;
          /** Expected behavior description */
          expectedBehaviour: string;
          /** Additional comments or notes */
          comments: string;
          /** Current issue status */
          status:
            | "awaiting"
            | "in-progress"
            | "ready-to-test"
            | "still-occurs"
            | "done"
            | "cannot-reproduce"
            | "wont-fix";
          /**
           * Timestamp when the issue was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the issue was last updated
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /**
         * Total number of issues matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/issues`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single issue by its unique identifier
   *
   * @tags Issues
   * @name IssuesDetail
   * @summary Get issue by ID
   * @request GET:/api/issues/{id}
   * @secure
   */
  issuesDetail = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        /** Unique auto-incrementing identifier for the issue */
        id: number;
        /** ID of the project this issue belongs to */
        projectId: string;
        /** Environment where issue occurred */
        environment: string;
        /** Application build version */
        buildVersion: string;
        /** Stage identifier */
        stage: string | null;
        /** Related conversation ID */
        conversationId: string | null;
        /** Event index in session */
        eventIndex: number | null;
        /** User ID who reported the issue */
        userId: string | null;
        /** Issue severity level */
        severity: "critical" | "major" | "minor" | "trivial";
        /** Issue category or type */
        category: "intent" | "ai answer" | "entity" | "tool";
        /** Detailed bug description */
        bugDescription: string;
        /** Expected behavior description */
        expectedBehaviour: string;
        /** Additional comments or notes */
        comments: string;
        /** Current issue status */
        status:
          | "awaiting"
          | "in-progress"
          | "ready-to-test"
          | "still-occurs"
          | "done"
          | "cannot-reproduce"
          | "wont-fix";
        /**
         * Timestamp when the issue was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the issue was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/issues/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing issue with new information, typically used to change status, add comments, or update severity
   *
   * @tags Issues
   * @name IssuesUpdate
   * @summary Update issue
   * @request PUT:/api/issues/{id}
   * @secure
   */
  issuesUpdate = (
    id: string,
    data: {
      /** Environment where issue occurred */
      environment?: string;
      /**
       * Application build version
       * @minLength 1
       */
      buildVersion?: string;
      /** Stage identifier */
      stage?: string;
      /** Related conversation ID */
      conversationId?: string;
      /** Event index in session */
      eventIndex?: number;
      /** User ID who reported the issue */
      userId?: string | null;
      /** Issue severity level */
      severity?: "critical" | "major" | "minor" | "trivial";
      /** Issue category or type */
      category?: "intent" | "ai answer" | "entity" | "tool";
      /**
       * Detailed bug description
       * @minLength 1
       */
      bugDescription?: string;
      /**
       * Expected behavior description
       * @minLength 1
       */
      expectedBehaviour?: string;
      /** Additional comments or notes */
      comments?: string;
      /** Current issue status */
      status?:
        | "awaiting"
        | "in-progress"
        | "ready-to-test"
        | "still-occurs"
        | "done"
        | "cannot-reproduce"
        | "wont-fix";
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique auto-incrementing identifier for the issue */
        id: number;
        /** ID of the project this issue belongs to */
        projectId: string;
        /** Environment where issue occurred */
        environment: string;
        /** Application build version */
        buildVersion: string;
        /** Stage identifier */
        stage: string | null;
        /** Related conversation ID */
        conversationId: string | null;
        /** Event index in session */
        eventIndex: number | null;
        /** User ID who reported the issue */
        userId: string | null;
        /** Issue severity level */
        severity: "critical" | "major" | "minor" | "trivial";
        /** Issue category or type */
        category: "intent" | "ai answer" | "entity" | "tool";
        /** Detailed bug description */
        bugDescription: string;
        /** Expected behavior description */
        expectedBehaviour: string;
        /** Additional comments or notes */
        comments: string;
        /** Current issue status */
        status:
          | "awaiting"
          | "in-progress"
          | "ready-to-test"
          | "still-occurs"
          | "done"
          | "cannot-reproduce"
          | "wont-fix";
        /**
         * Timestamp when the issue was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the issue was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/issues/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes an issue from the system
   *
   * @tags Issues
   * @name IssuesDelete
   * @summary Delete issue
   * @request DELETE:/api/issues/{id}
   * @secure
   */
  issuesDelete = (id: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/issues/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific issue showing its change history
   *
   * @tags Issues
   * @name IssuesAuditLogsList
   * @summary Get issue audit logs
   * @request GET:/api/issues/{id}/audit-logs
   * @secure
   */
  issuesAuditLogsList = (id: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/issues/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a new stage with specified behavior, prompts, and configuration
   *
   * @tags Stages
   * @name ProjectsStagesCreate
   * @summary Create a new stage
   * @request POST:/api/projects/{projectId}/stages
   * @secure
   */
  projectsStagesCreate = (
    projectId: string,
    data: {
      /**
       * Unique identifier for the stage (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Display name for the stage
       * @minLength 1
       */
      name: string;
      /** Detailed description of the stage purpose */
      description?: string;
      /**
       * System prompt that defines the stage behavior and instructions
       * @minLength 1
       */
      prompt: string;
      /**
       * ID of the LLM provider to use for this stage
       * @minLength 1
       */
      llmProviderId: string;
      /** LLM provider-specific settings for this stage */
      llmSettings: LlmSettings;
      /**
       * ID of the agent associated with this stage
       * @minLength 1
       */
      agentId: string;
      /**
       * What should happen when entering the stage
       * @default "generate_response"
       */
      enterBehavior?: "generate_response" | "await_user_input";
      /**
       * Whether to use knowledge base in this stage
       * @default false
       */
      useKnowledge?: boolean;
      /**
       * List of knowledge tags to include
       * @default []
       */
      knowledgeTags?: string[];
      /**
       * Whether to enable global actions in this stage
       * @default true
       */
      useGlobalActions?: boolean;
      /**
       * List of global action IDs available in this stage
       * @default []
       */
      globalActions?: string[];
      /**
       * Variable descriptor definitions for this stage
       * @default []
       */
      variableDescriptors?: FieldDescriptor[];
      /** Action definitions for this stage */
      actions?: Record<string, StageAction>;
      /** ID of the default classifier to use for this stage (can be overridden per action) */
      defaultClassifierId?: string | null;
      /**
       * List of context transformer IDs to use in this stage
       * @default []
       */
      transformerIds?: string[];
      /**
       * Tags for categorizing and filtering this stage
       * @default []
       */
      tags?: string[];
      /** Additional stage-specific metadata */
      metadata?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the stage */
        id: string;
        /** ID of the project this stage belongs to */
        projectId: string;
        /** Display name for the stage */
        name: string;
        /** Detailed description of the stage purpose */
        description: string | null;
        /** System prompt defining the stage behavior */
        prompt: string;
        /** ID of the LLM provider */
        llmProviderId: string | null;
        /** LLM provider-specific settings */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** ID of the associated agent */
        agentId: string;
        /** What happens when entering the stage */
        enterBehavior: "generate_response" | "await_user_input";
        /** Whether knowledge base is enabled */
        useKnowledge: boolean;
        /** Knowledge tags included in this stage */
        knowledgeTags: string[];
        /** Whether global actions are enabled */
        useGlobalActions: boolean;
        /** Global action IDs available in this stage */
        globalActions: string[];
        /** Variable descriptor definitions */
        variableDescriptors: FieldDescriptor[];
        /** Action definitions */
        actions: Record<string, StageAction>;
        /** Default classifier ID used in this stage (actions can override with overrideClassifierId) */
        defaultClassifierId: string | null;
        /** Context transformer IDs used in this stage */
        transformerIds: string[];
        /** Tags for categorizing and filtering this stage */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the stage was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the stage was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/stages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of stages with optional filtering and sorting
   *
   * @tags Stages
   * @name ProjectsStagesList
   * @summary List stages
   * @request GET:/api/projects/{projectId}/stages
   * @secure
   */
  projectsStagesList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of stages in the current page */
        items: {
          /** Unique identifier for the stage */
          id: string;
          /** ID of the project this stage belongs to */
          projectId: string;
          /** Display name for the stage */
          name: string;
          /** Detailed description of the stage purpose */
          description: string | null;
          /** System prompt defining the stage behavior */
          prompt: string;
          /** ID of the LLM provider */
          llmProviderId: string | null;
          /** LLM provider-specific settings */
          llmSettings?:
            | OpenAILlmSettings
            | OpenAILegacyLlmSettings
            | AnthropicLlmSettings
            | GeminiLlmSettings
            | GroqLlmSettings
            | MistralLlmSettings
            | DeepSeekLlmSettings
            | OpenRouterLlmSettings
            | TogetherAILlmSettings
            | FireworksAILlmSettings
            | PerplexityLlmSettings
            | CohereLlmSettings
            | XAILlmSettings
            | OllamaLlmSettings;
          /** ID of the associated agent */
          agentId: string;
          /** What happens when entering the stage */
          enterBehavior: "generate_response" | "await_user_input";
          /** Whether knowledge base is enabled */
          useKnowledge: boolean;
          /** Knowledge tags included in this stage */
          knowledgeTags: string[];
          /** Whether global actions are enabled */
          useGlobalActions: boolean;
          /** Global action IDs available in this stage */
          globalActions: string[];
          /** Variable descriptor definitions */
          variableDescriptors: FieldDescriptor[];
          /** Action definitions */
          actions: Record<string, StageAction>;
          /** Default classifier ID used in this stage (actions can override with overrideClassifierId) */
          defaultClassifierId: string | null;
          /** Context transformer IDs used in this stage */
          transformerIds: string[];
          /** Tags for categorizing and filtering this stage */
          tags: string[];
          /** Additional metadata */
          metadata: Record<string, any>;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the stage was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the stage was last updated
           * @format date-time
           */
          updatedAt: string | null;
          /** Whether this entity belongs to an archived project */
          archived?: boolean;
        }[];
        /**
         * Total number of stages matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/stages`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single stage by its unique identifier
   *
   * @tags Stages
   * @name ProjectsStagesDetail
   * @summary Get stage by ID
   * @request GET:/api/projects/{projectId}/stages/{id}
   * @secure
   */
  projectsStagesDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the stage */
        id: string;
        /** ID of the project this stage belongs to */
        projectId: string;
        /** Display name for the stage */
        name: string;
        /** Detailed description of the stage purpose */
        description: string | null;
        /** System prompt defining the stage behavior */
        prompt: string;
        /** ID of the LLM provider */
        llmProviderId: string | null;
        /** LLM provider-specific settings */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** ID of the associated agent */
        agentId: string;
        /** What happens when entering the stage */
        enterBehavior: "generate_response" | "await_user_input";
        /** Whether knowledge base is enabled */
        useKnowledge: boolean;
        /** Knowledge tags included in this stage */
        knowledgeTags: string[];
        /** Whether global actions are enabled */
        useGlobalActions: boolean;
        /** Global action IDs available in this stage */
        globalActions: string[];
        /** Variable descriptor definitions */
        variableDescriptors: FieldDescriptor[];
        /** Action definitions */
        actions: Record<string, StageAction>;
        /** Default classifier ID used in this stage (actions can override with overrideClassifierId) */
        defaultClassifierId: string | null;
        /** Context transformer IDs used in this stage */
        transformerIds: string[];
        /** Tags for categorizing and filtering this stage */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the stage was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the stage was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/stages/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing stage with optimistic locking
   *
   * @tags Stages
   * @name ProjectsStagesUpdate
   * @summary Update stage
   * @request PUT:/api/projects/{projectId}/stages/{id}
   * @secure
   */
  projectsStagesUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * Updated display name for the stage
       * @minLength 1
       */
      name?: string;
      /** Updated detailed description of the stage */
      description?: string | null;
      /**
       * Updated system prompt
       * @minLength 1
       */
      prompt?: string;
      /**
       * Updated LLM provider ID
       * @minLength 1
       */
      llmProviderId?: string;
      /** Updated LLM provider-specific settings */
      llmSettings?: LlmSettings;
      /**
       * Updated agent ID
       * @minLength 1
       */
      agentId?: string;
      /** Updated behavior when entering this stage */
      enterBehavior?: "generate_response" | "await_user_input";
      /** Updated knowledge usage flag */
      useKnowledge?: boolean;
      /** Updated knowledge tags */
      knowledgeTags?: string[];
      /** Updated global actions flag */
      useGlobalActions?: boolean;
      /** Updated global action IDs */
      globalActions?: string[];
      /** Updated variable descriptor definitions */
      variableDescriptors?: FieldDescriptor[];
      /** Updated action definitions */
      actions?: Record<string, StageAction>;
      /** Updated default classifier ID */
      defaultClassifierId?: string | null;
      /** Updated transformer IDs */
      transformerIds?: string[];
      /** Updated tags */
      tags?: string[];
      /** Updated metadata */
      metadata?: Record<string, any>;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the stage */
        id: string;
        /** ID of the project this stage belongs to */
        projectId: string;
        /** Display name for the stage */
        name: string;
        /** Detailed description of the stage purpose */
        description: string | null;
        /** System prompt defining the stage behavior */
        prompt: string;
        /** ID of the LLM provider */
        llmProviderId: string | null;
        /** LLM provider-specific settings */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** ID of the associated agent */
        agentId: string;
        /** What happens when entering the stage */
        enterBehavior: "generate_response" | "await_user_input";
        /** Whether knowledge base is enabled */
        useKnowledge: boolean;
        /** Knowledge tags included in this stage */
        knowledgeTags: string[];
        /** Whether global actions are enabled */
        useGlobalActions: boolean;
        /** Global action IDs available in this stage */
        globalActions: string[];
        /** Variable descriptor definitions */
        variableDescriptors: FieldDescriptor[];
        /** Action definitions */
        actions: Record<string, StageAction>;
        /** Default classifier ID used in this stage (actions can override with overrideClassifierId) */
        defaultClassifierId: string | null;
        /** Context transformer IDs used in this stage */
        transformerIds: string[];
        /** Tags for categorizing and filtering this stage */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the stage was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the stage was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/stages/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a stage with optimistic locking
   *
   * @tags Stages
   * @name ProjectsStagesDelete
   * @summary Delete stage
   * @request DELETE:/api/projects/{projectId}/stages/{id}
   * @secure
   */
  projectsStagesDelete = (
    projectId: string,
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/stages/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific stage
   *
   * @tags Stages
   * @name ProjectsStagesAuditLogsList
   * @summary Get stage audit logs
   * @request GET:/api/projects/{projectId}/stages/{id}/audit-logs
   * @secure
   */
  projectsStagesAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/stages/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a copy of an existing stage with a new ID and optional name override
   *
   * @tags Stages
   * @name ProjectsStagesCloneCreate
   * @summary Clone stage
   * @request POST:/api/projects/{projectId}/stages/{id}/clone
   * @secure
   */
  projectsStagesCloneCreate = (
    projectId: string,
    id: string,
    data: {
      /**
       * New ID for the cloned stage (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Name for the cloned stage (defaults to "{original name} (Clone)")
       * @minLength 1
       */
      name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the stage */
        id: string;
        /** ID of the project this stage belongs to */
        projectId: string;
        /** Display name for the stage */
        name: string;
        /** Detailed description of the stage purpose */
        description: string | null;
        /** System prompt defining the stage behavior */
        prompt: string;
        /** ID of the LLM provider */
        llmProviderId: string | null;
        /** LLM provider-specific settings */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** ID of the associated agent */
        agentId: string;
        /** What happens when entering the stage */
        enterBehavior: "generate_response" | "await_user_input";
        /** Whether knowledge base is enabled */
        useKnowledge: boolean;
        /** Knowledge tags included in this stage */
        knowledgeTags: string[];
        /** Whether global actions are enabled */
        useGlobalActions: boolean;
        /** Global action IDs available in this stage */
        globalActions: string[];
        /** Variable descriptor definitions */
        variableDescriptors: FieldDescriptor[];
        /** Action definitions */
        actions: Record<string, StageAction>;
        /** Default classifier ID used in this stage (actions can override with overrideClassifierId) */
        defaultClassifierId: string | null;
        /** Context transformer IDs used in this stage */
        transformerIds: string[];
        /** Tags for categorizing and filtering this stage */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the stage was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the stage was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/stages/${id}/clone`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns a paginated list of project builder sessions for the given project. Sessions are summarised (no messages payload). Supports filtering by createdBy and ordering by createdAt, updatedAt.
   *
   * @tags Project Builder
   * @name ProjectsBuilderSessionsList
   * @summary List builder sessions
   * @request GET:/api/projects/{projectId}/builder-sessions
   * @secure
   */
  projectsBuilderSessionsList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<ProjectBuilderSessionList, void>({
      path: `/api/projects/${projectId}/builder-sessions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new AI project builder session and optionally sends an initial user message. The builder uses tool-calling to inspect project entities and return targeted configuration proposals.
   *
   * @tags Project Builder
   * @name ProjectsBuilderSessionsCreate
   * @summary Create a builder session
   * @request POST:/api/projects/{projectId}/builder-sessions
   * @secure
   */
  projectsBuilderSessionsCreate = (
    projectId: string,
    data: {
      /**
       * Initial user message describing what to build or change in the project
       * @minLength 1
       */
      initialMessage?: string;
      /**
       * Optional operation mode ID to use for the initial turn when initialMessage is provided
       * @minLength 1
       */
      modeId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ProjectBuilderReply, void>({
      path: `/api/projects/${projectId}/builder-sessions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves an existing project builder session including the full conversation history.
   *
   * @tags Project Builder
   * @name ProjectsBuilderSessionsDetail
   * @summary Get a builder session
   * @request GET:/api/projects/{projectId}/builder-sessions/{sessionId}
   * @secure
   */
  projectsBuilderSessionsDetail = (
    projectId: string,
    sessionId: string,
    params: RequestParams = {},
  ) =>
    this.request<ProjectBuilderSession, void>({
      path: `/api/projects/${projectId}/builder-sessions/${sessionId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Permanently deletes a project builder session and all its conversation history.
   *
   * @tags Project Builder
   * @name ProjectsBuilderSessionsDelete
   * @summary Delete a builder session
   * @request DELETE:/api/projects/{projectId}/builder-sessions/{sessionId}
   * @secure
   */
  projectsBuilderSessionsDelete = (
    projectId: string,
    sessionId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/builder-sessions/${sessionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Sends a follow-up message within an existing session and returns the updated session with the assistant reply appended.
   *
   * @tags Project Builder
   * @name ProjectsBuilderSessionsMessagesCreate
   * @summary Send a message
   * @request POST:/api/projects/{projectId}/builder-sessions/{sessionId}/messages
   * @secure
   */
  projectsBuilderSessionsMessagesCreate = (
    projectId: string,
    sessionId: string,
    data: {
      /**
       * User message to send to the project builder agent
       * @minLength 1
       */
      message: string;
      /**
       * Optional operation mode ID to use for this message turn
       * @minLength 1
       */
      modeId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ProjectBuilderReply, void>({
      path: `/api/projects/${projectId}/builder-sessions/${sessionId}/messages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Sends a follow-up message and streams the response as Server-Sent Events (`text/event-stream`). Events arrive as newline-delimited JSON lines prefixed with `data: `. Possible event types: `tool_calls` (emitted after each tool-calling LLM iteration with the tool names and iteration number), `text_chunk` (the assistant reply text, emitted once after generation completes), `done` (emitted after session persistence with the full session and new proposals), `error` (on failure).
   *
   * @tags Project Builder
   * @name ProjectsBuilderSessionsMessagesStreamCreate
   * @summary Send a message (streaming)
   * @request POST:/api/projects/{projectId}/builder-sessions/{sessionId}/messages/stream
   * @secure
   */
  projectsBuilderSessionsMessagesStreamCreate = (
    projectId: string,
    sessionId: string,
    data: {
      /**
       * User message to send to the project builder agent
       * @minLength 1
       */
      message: string;
      /**
       * Optional operation mode ID to use for this message turn
       * @minLength 1
       */
      modeId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<BuilderStreamEvent, void>({
      path: `/api/projects/${projectId}/builder-sessions/${sessionId}/messages/stream`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Executes all pending entity proposals in the session inside a single database transaction, creating, updating, or deleting entities as specified. Successfully applied proposals are marked as applied; if the transaction fails all writes are rolled back and proposals are marked as failed.
   *
   * @tags Project Builder
   * @name ProjectsBuilderSessionsApplyCreate
   * @summary Apply pending proposals
   * @request POST:/api/projects/{projectId}/builder-sessions/{sessionId}/apply
   * @secure
   */
  projectsBuilderSessionsApplyCreate = (
    projectId: string,
    sessionId: string,
    data: {
      /**
       * Optional operation mode ID used to authorize this apply action
       * @minLength 1
       */
      modeId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ApplyProposalsResponse, void>({
      path: `/api/projects/${projectId}/builder-sessions/${sessionId}/apply`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Enqueues a steering message that is injected as a user message at the start of the next iteration of the active streaming agentic loop. The loop emits a `steering_acknowledged` SSE event when the message is consumed. If no streaming loop is currently active, the message waits in the queue until the next streaming call begins.
   *
   * @tags Project Builder
   * @name ProjectsBuilderSessionsSteerCreate
   * @summary Steer the running agent
   * @request POST:/api/projects/{projectId}/builder-sessions/{sessionId}/steer
   * @secure
   */
  projectsBuilderSessionsSteerCreate = (
    projectId: string,
    sessionId: string,
    data: {
      /**
       * Steering message to inject as a user message at the start of the next agentic loop iteration
       * @minLength 1
       */
      message: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/builder-sessions/${sessionId}/steer`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Submits user answers to the pending `ask_questions` suspension in the active streaming loop. The loop emits a `questions_pending` SSE event when suspended; call this endpoint to provide answers and resume execution. Returns 404 if no ask_questions call is currently pending for the session.
   *
   * @tags Project Builder
   * @name ProjectsBuilderSessionsAnswerQuestionsCreate
   * @summary Answer pending builder questions
   * @request POST:/api/projects/{projectId}/builder-sessions/{sessionId}/answer-questions
   * @secure
   */
  projectsBuilderSessionsAnswerQuestionsCreate = (
    projectId: string,
    sessionId: string,
    data: {
      /**
       * Answers to the pending questions. Must include at least one answer.
       * @minItems 1
       */
      answers: QuestionAnswer[];
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/builder-sessions/${sessionId}/answer-questions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Creates a global builder skill with prompt instructions and optional examples.
   *
   * @tags Builder Skills
   * @name BuilderSkillsCreate
   * @summary Create builder skill
   * @request POST:/api/builder/skills
   * @secure
   */
  builderSkillsCreate = (
    data: CreateBuilderSkillRequest,
    params: RequestParams = {},
  ) =>
    this.request<BuilderSkill, void>({
      path: `/api/builder/skills`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of global builder skills.
   *
   * @tags Builder Skills
   * @name BuilderSkillsList
   * @summary List builder skills
   * @request GET:/api/builder/skills
   * @secure
   */
  builderSkillsList = (
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<BuilderSkillListResponse, void>({
      path: `/api/builder/skills`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single global builder skill by ID.
   *
   * @tags Builder Skills
   * @name BuilderSkillsDetail
   * @summary Get builder skill by ID
   * @request GET:/api/builder/skills/{id}
   * @secure
   */
  builderSkillsDetail = (id: string, params: RequestParams = {}) =>
    this.request<BuilderSkill, void>({
      path: `/api/builder/skills/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates a global builder skill with optimistic locking.
   *
   * @tags Builder Skills
   * @name BuilderSkillsUpdate
   * @summary Update builder skill
   * @request PUT:/api/builder/skills/{id}
   * @secure
   */
  builderSkillsUpdate = (
    id: string,
    data: UpdateBuilderSkillRequest,
    params: RequestParams = {},
  ) =>
    this.request<BuilderSkill, void>({
      path: `/api/builder/skills/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a non-system global builder skill with optimistic locking.
   *
   * @tags Builder Skills
   * @name BuilderSkillsDelete
   * @summary Delete builder skill
   * @request DELETE:/api/builder/skills/{id}
   * @secure
   */
  builderSkillsDelete = (
    id: string,
    data: DeleteBuilderSkillRequest,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/builder/skills/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Creates a global operation mode with skill bindings and allowed function calls.
   *
   * @tags Builder Operation Modes
   * @name BuilderOperationModesCreate
   * @summary Create builder operation mode
   * @request POST:/api/builder/operation-modes
   * @secure
   */
  builderOperationModesCreate = (
    data: CreateBuilderOperationModeRequest,
    params: RequestParams = {},
  ) =>
    this.request<BuilderOperationMode, void>({
      path: `/api/builder/operation-modes`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of global builder operation modes.
   *
   * @tags Builder Operation Modes
   * @name BuilderOperationModesList
   * @summary List builder operation modes
   * @request GET:/api/builder/operation-modes
   * @secure
   */
  builderOperationModesList = (
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<BuilderOperationModeListResponse, void>({
      path: `/api/builder/operation-modes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single global operation mode by ID.
   *
   * @tags Builder Operation Modes
   * @name BuilderOperationModesDetail
   * @summary Get builder operation mode by ID
   * @request GET:/api/builder/operation-modes/{id}
   * @secure
   */
  builderOperationModesDetail = (id: string, params: RequestParams = {}) =>
    this.request<BuilderOperationMode, void>({
      path: `/api/builder/operation-modes/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates a global builder operation mode with optimistic locking.
   *
   * @tags Builder Operation Modes
   * @name BuilderOperationModesUpdate
   * @summary Update builder operation mode
   * @request PUT:/api/builder/operation-modes/{id}
   * @secure
   */
  builderOperationModesUpdate = (
    id: string,
    data: UpdateBuilderOperationModeRequest,
    params: RequestParams = {},
  ) =>
    this.request<BuilderOperationMode, void>({
      path: `/api/builder/operation-modes/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a non-system global operation mode with optimistic locking.
   *
   * @tags Builder Operation Modes
   * @name BuilderOperationModesDelete
   * @summary Delete builder operation mode
   * @request DELETE:/api/builder/operation-modes/{id}
   * @secure
   */
  builderOperationModesDelete = (
    id: string,
    data: DeleteBuilderOperationModeRequest,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/builder/operation-modes/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Creates a new tool with specified name, prompt, input/output types, and configuration
   *
   * @tags Tools
   * @name ProjectsToolsCreate
   * @summary Create a new tool
   * @request POST:/api/projects/{projectId}/tools
   * @secure
   */
  projectsToolsCreate = (
    projectId: string,
    data: CreateToolRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the tool */
        id: string;
        /** ID of the project this tool belongs to */
        projectId: string;
        /** Display name of the tool */
        name: string;
        /** Detailed description of the tool */
        description: string | null;
        /** Tool execution type */
        type: "smart_function" | "webhook" | "script";
        /** Handlebars prompt template (smart_function only) */
        prompt: string | null;
        /** ID of the LLM provider (smart_function only) */
        llmProviderId: string | null;
        /** LLM provider-specific settings (smart_function only) */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** Expected input format (smart_function only) */
        inputType: "text" | "image" | "multi-modal" | null;
        /** Expected output format (smart_function only) */
        outputType: "text" | "image" | "multi-modal" | null;
        /** Target URL (webhook only) */
        url: string | null;
        /** HTTP method (webhook only) */
        webhookMethod: string | null;
        /** HTTP headers (webhook only) */
        webhookHeaders: Record<string, string>;
        /** Request body template (webhook only) */
        webhookBody: string | null;
        /** JavaScript code (script only) */
        code: string | null;
        /** Parameters that this tool expects to receive */
        parameters: ToolParameter[];
        /** Tags for categorizing and filtering this tool */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the tool was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the tool was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/tools`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of tools with optional filtering and sorting
   *
   * @tags Tools
   * @name ProjectsToolsList
   * @summary List tools
   * @request GET:/api/projects/{projectId}/tools
   * @secure
   */
  projectsToolsList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of tools in the current page */
        items: {
          /** Unique identifier for the tool */
          id: string;
          /** ID of the project this tool belongs to */
          projectId: string;
          /** Display name of the tool */
          name: string;
          /** Detailed description of the tool */
          description: string | null;
          /** Tool execution type */
          type: "smart_function" | "webhook" | "script";
          /** Handlebars prompt template (smart_function only) */
          prompt: string | null;
          /** ID of the LLM provider (smart_function only) */
          llmProviderId: string | null;
          /** LLM provider-specific settings (smart_function only) */
          llmSettings?:
            | OpenAILlmSettings
            | OpenAILegacyLlmSettings
            | AnthropicLlmSettings
            | GeminiLlmSettings
            | GroqLlmSettings
            | MistralLlmSettings
            | DeepSeekLlmSettings
            | OpenRouterLlmSettings
            | TogetherAILlmSettings
            | FireworksAILlmSettings
            | PerplexityLlmSettings
            | CohereLlmSettings
            | XAILlmSettings
            | OllamaLlmSettings;
          /** Expected input format (smart_function only) */
          inputType: "text" | "image" | "multi-modal" | null;
          /** Expected output format (smart_function only) */
          outputType: "text" | "image" | "multi-modal" | null;
          /** Target URL (webhook only) */
          url: string | null;
          /** HTTP method (webhook only) */
          webhookMethod: string | null;
          /** HTTP headers (webhook only) */
          webhookHeaders: Record<string, string>;
          /** Request body template (webhook only) */
          webhookBody: string | null;
          /** JavaScript code (script only) */
          code: string | null;
          /** Parameters that this tool expects to receive */
          parameters: ToolParameter[];
          /** Tags for categorizing and filtering this tool */
          tags: string[];
          /** Additional metadata */
          metadata: Record<string, any>;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the tool was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the tool was last updated
           * @format date-time
           */
          updatedAt: string | null;
          /** Whether this entity belongs to an archived project */
          archived?: boolean;
        }[];
        /**
         * Total number of tools matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/tools`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single tool by its unique identifier
   *
   * @tags Tools
   * @name ProjectsToolsDetail
   * @summary Get tool by ID
   * @request GET:/api/projects/{projectId}/tools/{id}
   * @secure
   */
  projectsToolsDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the tool */
        id: string;
        /** ID of the project this tool belongs to */
        projectId: string;
        /** Display name of the tool */
        name: string;
        /** Detailed description of the tool */
        description: string | null;
        /** Tool execution type */
        type: "smart_function" | "webhook" | "script";
        /** Handlebars prompt template (smart_function only) */
        prompt: string | null;
        /** ID of the LLM provider (smart_function only) */
        llmProviderId: string | null;
        /** LLM provider-specific settings (smart_function only) */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** Expected input format (smart_function only) */
        inputType: "text" | "image" | "multi-modal" | null;
        /** Expected output format (smart_function only) */
        outputType: "text" | "image" | "multi-modal" | null;
        /** Target URL (webhook only) */
        url: string | null;
        /** HTTP method (webhook only) */
        webhookMethod: string | null;
        /** HTTP headers (webhook only) */
        webhookHeaders: Record<string, string>;
        /** Request body template (webhook only) */
        webhookBody: string | null;
        /** JavaScript code (script only) */
        code: string | null;
        /** Parameters that this tool expects to receive */
        parameters: ToolParameter[];
        /** Tags for categorizing and filtering this tool */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the tool was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the tool was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/tools/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing tool with optimistic locking
   *
   * @tags Tools
   * @name ProjectsToolsUpdate
   * @summary Update tool
   * @request PUT:/api/projects/{projectId}/tools/{id}
   * @secure
   */
  projectsToolsUpdate = (
    projectId: string,
    id: string,
    data: UpdateToolRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the tool */
        id: string;
        /** ID of the project this tool belongs to */
        projectId: string;
        /** Display name of the tool */
        name: string;
        /** Detailed description of the tool */
        description: string | null;
        /** Tool execution type */
        type: "smart_function" | "webhook" | "script";
        /** Handlebars prompt template (smart_function only) */
        prompt: string | null;
        /** ID of the LLM provider (smart_function only) */
        llmProviderId: string | null;
        /** LLM provider-specific settings (smart_function only) */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** Expected input format (smart_function only) */
        inputType: "text" | "image" | "multi-modal" | null;
        /** Expected output format (smart_function only) */
        outputType: "text" | "image" | "multi-modal" | null;
        /** Target URL (webhook only) */
        url: string | null;
        /** HTTP method (webhook only) */
        webhookMethod: string | null;
        /** HTTP headers (webhook only) */
        webhookHeaders: Record<string, string>;
        /** Request body template (webhook only) */
        webhookBody: string | null;
        /** JavaScript code (script only) */
        code: string | null;
        /** Parameters that this tool expects to receive */
        parameters: ToolParameter[];
        /** Tags for categorizing and filtering this tool */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the tool was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the tool was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/tools/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a tool with optimistic locking
   *
   * @tags Tools
   * @name ProjectsToolsDelete
   * @summary Delete tool
   * @request DELETE:/api/projects/{projectId}/tools/{id}
   * @secure
   */
  projectsToolsDelete = (
    projectId: string,
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/tools/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific tool
   *
   * @tags Tools
   * @name ProjectsToolsAuditLogsList
   * @summary Get tool audit logs
   * @request GET:/api/projects/{projectId}/tools/{id}/audit-logs
   * @secure
   */
  projectsToolsAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/tools/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a copy of an existing tool with a new ID and optional name override
   *
   * @tags Tools
   * @name ProjectsToolsCloneCreate
   * @summary Clone tool
   * @request POST:/api/projects/{projectId}/tools/{id}/clone
   * @secure
   */
  projectsToolsCloneCreate = (
    projectId: string,
    id: string,
    data: {
      /**
       * New ID for the cloned tool (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Name for the cloned tool (defaults to "{original name} (Clone)")
       * @minLength 1
       */
      name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the tool */
        id: string;
        /** ID of the project this tool belongs to */
        projectId: string;
        /** Display name of the tool */
        name: string;
        /** Detailed description of the tool */
        description: string | null;
        /** Tool execution type */
        type: "smart_function" | "webhook" | "script";
        /** Handlebars prompt template (smart_function only) */
        prompt: string | null;
        /** ID of the LLM provider (smart_function only) */
        llmProviderId: string | null;
        /** LLM provider-specific settings (smart_function only) */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** Expected input format (smart_function only) */
        inputType: "text" | "image" | "multi-modal" | null;
        /** Expected output format (smart_function only) */
        outputType: "text" | "image" | "multi-modal" | null;
        /** Target URL (webhook only) */
        url: string | null;
        /** HTTP method (webhook only) */
        webhookMethod: string | null;
        /** HTTP headers (webhook only) */
        webhookHeaders: Record<string, string>;
        /** Request body template (webhook only) */
        webhookBody: string | null;
        /** JavaScript code (script only) */
        code: string | null;
        /** Parameters that this tool expects to receive */
        parameters: ToolParameter[];
        /** Tags for categorizing and filtering this tool */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the tool was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the tool was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/tools/${id}/clone`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new user within the specified project
   *
   * @tags Users
   * @name ProjectsUsersCreate
   * @summary Create a new user
   * @request POST:/api/projects/{projectId}/users
   * @secure
   */
  projectsUsersCreate = (
    projectId: string,
    data: {
      /**
       * Unique identifier for the user (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /** User profile data as flexible key-value pairs */
      profile: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the user */
        id: string;
        /** Project this user belongs to */
        projectId: string;
        /** User profile data as key-value pairs */
        profile: Record<string, any>;
        /** Whether the user is banned from starting conversations */
        banned: boolean;
        /** Reason the user was banned */
        banReason?: string | null;
        /**
         * Timestamp when the user was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the user was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of users within a project with optional filtering
   *
   * @tags Users
   * @name ProjectsUsersList
   * @summary List users
   * @request GET:/api/projects/{projectId}/users
   * @secure
   */
  projectsUsersList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of users in the current page */
        items: {
          /** Unique identifier for the user */
          id: string;
          /** Project this user belongs to */
          projectId: string;
          /** User profile data as key-value pairs */
          profile: Record<string, any>;
          /** Whether the user is banned from starting conversations */
          banned: boolean;
          /** Reason the user was banned */
          banReason?: string | null;
          /**
           * Timestamp when the user was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the user was last updated
           * @format date-time
           */
          updatedAt: string | null;
          /** Whether this entity belongs to an archived project */
          archived?: boolean;
        }[];
        /**
         * Total number of users matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single user by their unique identifier within a project
   *
   * @tags Users
   * @name ProjectsUsersDetail
   * @summary Get user by ID
   * @request GET:/api/projects/{projectId}/users/{id}
   * @secure
   */
  projectsUsersDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the user */
        id: string;
        /** Project this user belongs to */
        projectId: string;
        /** User profile data as key-value pairs */
        profile: Record<string, any>;
        /** Whether the user is banned from starting conversations */
        banned: boolean;
        /** Reason the user was banned */
        banReason?: string | null;
        /**
         * Timestamp when the user was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the user was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/users/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing user within a project
   *
   * @tags Users
   * @name ProjectsUsersUpdate
   * @summary Update user
   * @request PUT:/api/projects/{projectId}/users/{id}
   * @secure
   */
  projectsUsersUpdate = (
    projectId: string,
    id: string,
    data: {
      /** Updated profile data (merges with existing profile) */
      profile?: Record<string, any>;
      /** Whether the user is banned from starting conversations */
      banned?: boolean;
      /** Reason for banning the user (null to clear) */
      banReason?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the user */
        id: string;
        /** Project this user belongs to */
        projectId: string;
        /** User profile data as key-value pairs */
        profile: Record<string, any>;
        /** Whether the user is banned from starting conversations */
        banned: boolean;
        /** Reason the user was banned */
        banReason?: string | null;
        /**
         * Timestamp when the user was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the user was last updated
         * @format date-time
         */
        updatedAt: string | null;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/users/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a user from a project
   *
   * @tags Users
   * @name ProjectsUsersDelete
   * @summary Delete user
   * @request DELETE:/api/projects/{projectId}/users/{id}
   * @secure
   */
  projectsUsersDelete = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/users/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific user within a project
   *
   * @tags Users
   * @name ProjectsUsersAuditLogsList
   * @summary Get user audit logs
   * @request GET:/api/projects/{projectId}/users/{id}/audit-logs
   * @secure
   */
  projectsUsersAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/users/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a new API key for WebSocket authentication. The secret key is only returned in the response to this creation request.
   *
   * @tags API Keys
   * @name ProjectsApiKeysCreate
   * @summary Create a new API key
   * @request POST:/api/projects/{projectId}/api-keys
   * @secure
   */
  projectsApiKeysCreate = (
    projectId: string,
    data: {
      /**
       * A descriptive name for the API key
       * @minLength 1
       * @maxLength 255
       */
      name: string;
      /** Additional metadata for the API key */
      metadata?: Record<string, any>;
      /** Security settings controlling which channels and features this key permits. If absent, all channels and features are allowed. */
      keySettings?: ApiKeySettings;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the API key */
        id: string;
        /** The ID of the project this API key belongs to */
        projectId: string;
        /** Descriptive name for the API key */
        name: string;
        /** The secret API key string (only included when creating a new key) */
        key?: string;
        /** First few characters of the key for identification */
        keyPreview?: string;
        /** ISO timestamp of when the key was last used */
        lastUsedAt: string | null;
        /** Whether the API key is active */
        isActive: boolean;
        /** Additional metadata */
        metadata?: Record<string, any>;
        /** Security settings controlling which channels and features this key permits */
        keySettings?: {
          /** Permitted transport channels. If absent, all channels (websocket, webrtc) are allowed. */
          allowedChannels?: (
            | "websocket"
            | "webrtc"
            | "twilio_voice"
            | "twilio_messaging"
            | "whatsapp"
            | "telegram"
            | "testing"
          )[];
          /** Permitted feature capabilities. If absent, all features are allowed. */
          allowedFeatures?: (
            | "conversation_control"
            | "voice_input"
            | "text_input"
            | "voice_output"
            | "text_output"
            | "vars_access"
            | "stage_control"
            | "run_action"
            | "call_tool"
            | "abort_generation"
            | "events"
          )[];
        } | null;
        /** Version number for optimistic locking */
        version: number;
        /** ISO timestamp of creation */
        createdAt: string;
        /** ISO timestamp of last update */
        updatedAt: string;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/api-keys`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a list of API keys with optional filtering, sorting, and pagination. Filter by projectId to get keys for a specific project.
   *
   * @tags API Keys
   * @name ProjectsApiKeysList
   * @summary List API keys
   * @request GET:/api/projects/{projectId}/api-keys
   * @secure
   */
  projectsApiKeysList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of API keys */
        items: {
          /** Unique identifier for the API key */
          id: string;
          /** The ID of the project this API key belongs to */
          projectId: string;
          /** Descriptive name for the API key */
          name: string;
          /** The secret API key string (only included when creating a new key) */
          key?: string;
          /** First few characters of the key for identification */
          keyPreview?: string;
          /** ISO timestamp of when the key was last used */
          lastUsedAt: string | null;
          /** Whether the API key is active */
          isActive: boolean;
          /** Additional metadata */
          metadata?: Record<string, any>;
          /** Security settings controlling which channels and features this key permits */
          keySettings?: {
            /** Permitted transport channels. If absent, all channels (websocket, webrtc) are allowed. */
            allowedChannels?: (
              | "websocket"
              | "webrtc"
              | "twilio_voice"
              | "twilio_messaging"
              | "whatsapp"
              | "telegram"
              | "testing"
            )[];
            /** Permitted feature capabilities. If absent, all features are allowed. */
            allowedFeatures?: (
              | "conversation_control"
              | "voice_input"
              | "text_input"
              | "voice_output"
              | "text_output"
              | "vars_access"
              | "stage_control"
              | "run_action"
              | "call_tool"
              | "abort_generation"
              | "events"
            )[];
          } | null;
          /** Version number for optimistic locking */
          version: number;
          /** ISO timestamp of creation */
          createdAt: string;
          /** ISO timestamp of last update */
          updatedAt: string;
          /** Whether this entity belongs to an archived project */
          archived?: boolean;
        }[];
        /** Total number of API keys matching the query */
        total: number;
      },
      any
    >({
      path: `/api/projects/${projectId}/api-keys`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single API key by its unique identifier. The full secret key is never returned, only a preview.
   *
   * @tags API Keys
   * @name ProjectsApiKeysDetail
   * @summary Get API key by ID
   * @request GET:/api/projects/{projectId}/api-keys/{id}
   * @secure
   */
  projectsApiKeysDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the API key */
        id: string;
        /** The ID of the project this API key belongs to */
        projectId: string;
        /** Descriptive name for the API key */
        name: string;
        /** The secret API key string (only included when creating a new key) */
        key?: string;
        /** First few characters of the key for identification */
        keyPreview?: string;
        /** ISO timestamp of when the key was last used */
        lastUsedAt: string | null;
        /** Whether the API key is active */
        isActive: boolean;
        /** Additional metadata */
        metadata?: Record<string, any>;
        /** Security settings controlling which channels and features this key permits */
        keySettings?: {
          /** Permitted transport channels. If absent, all channels (websocket, webrtc) are allowed. */
          allowedChannels?: (
            | "websocket"
            | "webrtc"
            | "twilio_voice"
            | "twilio_messaging"
            | "whatsapp"
            | "telegram"
            | "testing"
          )[];
          /** Permitted feature capabilities. If absent, all features are allowed. */
          allowedFeatures?: (
            | "conversation_control"
            | "voice_input"
            | "text_input"
            | "voice_output"
            | "text_output"
            | "vars_access"
            | "stage_control"
            | "run_action"
            | "call_tool"
            | "abort_generation"
            | "events"
          )[];
        } | null;
        /** Version number for optimistic locking */
        version: number;
        /** ISO timestamp of creation */
        createdAt: string;
        /** ISO timestamp of last update */
        updatedAt: string;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/api-keys/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing API key with optimistic locking support. Can update name, active status, and metadata.
   *
   * @tags API Keys
   * @name ProjectsApiKeysUpdate
   * @summary Update API key
   * @request PUT:/api/projects/{projectId}/api-keys/{id}
   * @secure
   */
  projectsApiKeysUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * The updated name for the API key
       * @minLength 1
       * @maxLength 255
       */
      name?: string;
      /** Whether the API key is active and can be used for authentication */
      isActive?: boolean;
      /** Updated metadata for the API key */
      metadata?: Record<string, any>;
      /** Updated security settings. If absent, existing settings are preserved. */
      keySettings?: ApiKeySettings;
      /** The current version number for optimistic locking */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the API key */
        id: string;
        /** The ID of the project this API key belongs to */
        projectId: string;
        /** Descriptive name for the API key */
        name: string;
        /** The secret API key string (only included when creating a new key) */
        key?: string;
        /** First few characters of the key for identification */
        keyPreview?: string;
        /** ISO timestamp of when the key was last used */
        lastUsedAt: string | null;
        /** Whether the API key is active */
        isActive: boolean;
        /** Additional metadata */
        metadata?: Record<string, any>;
        /** Security settings controlling which channels and features this key permits */
        keySettings?: {
          /** Permitted transport channels. If absent, all channels (websocket, webrtc) are allowed. */
          allowedChannels?: (
            | "websocket"
            | "webrtc"
            | "twilio_voice"
            | "twilio_messaging"
            | "whatsapp"
            | "telegram"
            | "testing"
          )[];
          /** Permitted feature capabilities. If absent, all features are allowed. */
          allowedFeatures?: (
            | "conversation_control"
            | "voice_input"
            | "text_input"
            | "voice_output"
            | "text_output"
            | "vars_access"
            | "stage_control"
            | "run_action"
            | "call_tool"
            | "abort_generation"
            | "events"
          )[];
        } | null;
        /** Version number for optimistic locking */
        version: number;
        /** ISO timestamp of creation */
        createdAt: string;
        /** ISO timestamp of last update */
        updatedAt: string;
        /** Whether this entity belongs to an archived project */
        archived?: boolean;
      },
      void
    >({
      path: `/api/projects/${projectId}/api-keys/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Permanently deletes an API key. This action cannot be undone and will immediately invalidate the key.
   *
   * @tags API Keys
   * @name ProjectsApiKeysDelete
   * @summary Delete API key
   * @request DELETE:/api/projects/{projectId}/api-keys/{id}
   * @secure
   */
  projectsApiKeysDelete = (
    projectId: string,
    id: string,
    data: {
      /** The current version number for optimistic locking */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/api-keys/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves a list of all API keys across all projects with optional filtering, sorting, and pagination.
   *
   * @tags API Keys
   * @name ApiKeysList
   * @summary List all API keys
   * @request GET:/api/api-keys
   * @secure
   */
  apiKeysList = (
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of API keys */
        items: {
          /** Unique identifier for the API key */
          id: string;
          /** The ID of the project this API key belongs to */
          projectId: string;
          /** Descriptive name for the API key */
          name: string;
          /** The secret API key string (only included when creating a new key) */
          key?: string;
          /** First few characters of the key for identification */
          keyPreview?: string;
          /** ISO timestamp of when the key was last used */
          lastUsedAt: string | null;
          /** Whether the API key is active */
          isActive: boolean;
          /** Additional metadata */
          metadata?: Record<string, any>;
          /** Security settings controlling which channels and features this key permits */
          keySettings?: {
            /** Permitted transport channels. If absent, all channels (websocket, webrtc) are allowed. */
            allowedChannels?: (
              | "websocket"
              | "webrtc"
              | "twilio_voice"
              | "twilio_messaging"
              | "whatsapp"
              | "telegram"
              | "testing"
            )[];
            /** Permitted feature capabilities. If absent, all features are allowed. */
            allowedFeatures?: (
              | "conversation_control"
              | "voice_input"
              | "text_input"
              | "voice_output"
              | "text_output"
              | "vars_access"
              | "stage_control"
              | "run_action"
              | "call_tool"
              | "abort_generation"
              | "events"
            )[];
          } | null;
          /** Version number for optimistic locking */
          version: number;
          /** ISO timestamp of creation */
          createdAt: string;
          /** ISO timestamp of last update */
          updatedAt: string;
          /** Whether this entity belongs to an archived project */
          archived?: boolean;
        }[];
        /** Total number of API keys matching the query */
        total: number;
      },
      any
    >({
      path: `/api/api-keys`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific API key
   *
   * @tags API Keys
   * @name ProjectsApiKeysAuditLogsList
   * @summary Get API key audit logs
   * @request GET:/api/projects/{projectId}/api-keys/{id}/audit-logs
   * @secure
   */
  projectsApiKeysAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/api-keys/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Returns lightweight stubs (id + name) for every entity that would be included in an export with the given selection — same query params as GET /api/migration/export. Use this to review what will be migrated before committing to an actual pull. No data is written and the full entity records are never serialised.
   *
   * @tags Migration
   * @name MigrationPreviewList
   * @summary Preview migration scope
   * @request GET:/api/migration/preview
   * @secure
   */
  migrationPreviewList = (
    query?: {
      /** Specific project IDs to export (comma-separated or repeated). Omit for all projects. */
      projectIds?: string | string[];
      /** Specific stage IDs to export. */
      stageIds?: string | string[];
      /** Specific agent IDs to export. */
      agentIds?: string | string[];
      /** Specific classifier IDs to export. */
      classifierIds?: string | string[];
      /** Specific context transformer IDs to export. */
      contextTransformerIds?: string | string[];
      /** Specific tool IDs to export. */
      toolIds?: string | string[];
      /** Specific global action IDs to export. */
      globalActionIds?: string | string[];
      /** Specific knowledge category IDs to export. All child items are included. */
      knowledgeCategoryIds?: string | string[];
      /** Specific provider IDs to export (added on top of transitively required ones). */
      providerIds?: string | string[];
      /** Specific API key IDs to export. */
      apiKeyIds?: string | string[];
      /** Specific document IDs to export. */
      documentIds?: string | string[];
      /** Specific tester IDs to export. */
      testerIds?: string | string[];
      /** Specific scenario IDs to export. */
      scenarioIds?: string | string[];
      /** Specific guardrail IDs to export. */
      guardrailIds?: string | string[];
      /** Specific copy decorator IDs to export. */
      copyDecoratorIds?: string | string[];
      /** Specific sample copy IDs to export. */
      sampleCopyIds?: string | string[];
      /** Specific saved slice query IDs to export. */
      savedSliceQueryIds?: string | string[];
      /** Specific saved funnel query IDs to export. */
      savedFunnelQueryIds?: string | string[];
      /** Specific builder skill IDs to export. */
      builderSkillIds?: string | string[];
      /** Specific builder operation mode IDs to export. */
      builderOperationModeIds?: string | string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<MigrationPreview, void>({
      path: `/api/migration/preview`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Produces a self-contained JSON bundle of all migratable config entities. Intended to be called by a remote instance during a server-side pull. Pass one or more ID arrays (projectIds, stageIds, agentIds, …) to select specific entities — all transitive FK dependencies are resolved automatically so the bundle is always self-consistent. An empty query (no params) exports everything. Provider config (API credentials) is stripped from exported records.
   *
   * @tags Migration
   * @name MigrationExportList
   * @summary Export config bundle
   * @request GET:/api/migration/export
   * @secure
   */
  migrationExportList = (
    query?: {
      /** Specific project IDs to export (comma-separated or repeated). Omit for all projects. */
      projectIds?: string | string[];
      /** Specific stage IDs to export. */
      stageIds?: string | string[];
      /** Specific agent IDs to export. */
      agentIds?: string | string[];
      /** Specific classifier IDs to export. */
      classifierIds?: string | string[];
      /** Specific context transformer IDs to export. */
      contextTransformerIds?: string | string[];
      /** Specific tool IDs to export. */
      toolIds?: string | string[];
      /** Specific global action IDs to export. */
      globalActionIds?: string | string[];
      /** Specific knowledge category IDs to export. All child items are included. */
      knowledgeCategoryIds?: string | string[];
      /** Specific provider IDs to export (added on top of transitively required ones). */
      providerIds?: string | string[];
      /** Specific API key IDs to export. */
      apiKeyIds?: string | string[];
      /** Specific document IDs to export. */
      documentIds?: string | string[];
      /** Specific tester IDs to export. */
      testerIds?: string | string[];
      /** Specific scenario IDs to export. */
      scenarioIds?: string | string[];
      /** Specific guardrail IDs to export. */
      guardrailIds?: string | string[];
      /** Specific copy decorator IDs to export. */
      copyDecoratorIds?: string | string[];
      /** Specific sample copy IDs to export. */
      sampleCopyIds?: string | string[];
      /** Specific saved slice query IDs to export. */
      savedSliceQueryIds?: string | string[];
      /** Specific saved funnel query IDs to export. */
      savedFunnelQueryIds?: string | string[];
      /** Specific builder skill IDs to export. */
      builderSkillIds?: string | string[];
      /** Specific builder operation mode IDs to export. */
      builderOperationModeIds?: string | string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<ExportBundle, void>({
      path: `/api/migration/export`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Produces a self-contained, provider-agnostic exchange bundle for the specified project. All child entities (agents, stages, classifiers, context transformers, tools, global actions, guardrails, knowledge base) are included. Provider UUID references are replaced by provider hints (`type` + `apiType`) so the bundle can be imported into any environment. Credentials are never included. Entity IDs in the bundle are preserved as local cross-references and remapped to fresh UUIDs on import.
   *
   * @tags Projects
   * @name ProjectsExportList
   * @summary Export a project as an exchange bundle
   * @request GET:/api/projects/{id}/export
   * @secure
   */
  projectsExportList = (id: string, params: RequestParams = {}) =>
    this.request<ProjectExchangeBundleV1, void>({
      path: `/api/projects/${id}/export`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Imports a project from a provider-agnostic exchange bundle. All entity IDs are remapped to fresh UUIDs so repeated imports never overwrite existing data. Provider hints are resolved to local provider IDs by matching `type` + `apiType` (first match wins). If no matching local provider is found for a hint, the corresponding provider field is set to null. Returns the newly assigned project ID and a count of created entities.
   *
   * @tags Projects
   * @name ProjectsImportCreate
   * @summary Import a project from an exchange bundle
   * @request POST:/api/projects/import
   * @secure
   */
  projectsImportCreate = (
    data: ProjectExchangeBundleV1,
    params: RequestParams = {},
  ) =>
    this.request<ProjectExchangeImportResult, void>({
      path: `/api/projects/import`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Lists all secrets in the store. Secret values are never returned. Also returns orphan refs — secrets that exist in the store but are not referenced by any provider config or environment.
   *
   * @tags Secrets
   * @name SecretsList
   * @summary List all secrets
   * @request GET:/api/secrets
   * @secure
   */
  secretsList = (params: RequestParams = {}) =>
    this.request<SecretListResponse, any>({
      path: `/api/secrets`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the decrypted plaintext value of a secret. Restricted to super_admin only. Use only in emergency situations.
   *
   * @tags Secrets
   * @name SecretsValueList
   * @summary Reveal secret value
   * @request GET:/api/secrets/{id}/value
   * @secure
   */
  secretsValueList = (id: string, params: RequestParams = {}) =>
    this.request<SecretValueResponse, void>({
      path: `/api/secrets/${id}/value`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a secret by its ID. Returns 409 if the secret is still referenced by a provider config or environment.
   *
   * @tags Secrets
   * @name SecretsDelete
   * @summary Delete a secret
   * @request DELETE:/api/secrets/{id}
   * @secure
   */
  secretsDelete = (id: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/secrets/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a new tester persona for use in scenario testing
   *
   * @tags Testers
   * @name ProjectsTestersCreate
   * @summary Create a new tester
   * @request POST:/api/projects/{projectId}/testers
   * @secure
   */
  projectsTestersCreate = (
    projectId: string,
    data: {
      /**
       * Unique identifier for the tester (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Display name of the tester persona
       * @minLength 1
       */
      name: string;
      /** Detailed description of the tester persona and its behaviour */
      description?: string | null;
      /**
       * Prompt that defines the tester persona behaviour during a conversation
       * @minLength 1
       */
      prompt: string;
      /** Mini-prompt evaluated at each turn to decide whether the tester should hang up (used when personaCanHangUp is enabled on the scenario); must return true to continue or false to hang up */
      hangUpPrompt?: string | null;
      /**
       * ID of the LLM provider to use for this tester
       * @minLength 1
       */
      llmProviderId?: string;
      /** LLM provider-specific settings for this tester */
      llmSettings?: LlmSettings;
      /** Key-value user profile data passed when the tester starts a conversation */
      userProfile?: Record<string, any>;
      /**
       * Tags for categorizing and filtering this tester
       * @default []
       */
      tags?: string[];
      /** Additional tester-specific metadata */
      metadata?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the tester */
        id: string;
        /** ID of the project this tester belongs to */
        projectId: string;
        /** Display name of the tester persona */
        name: string;
        /** Detailed description of the tester persona */
        description: string | null;
        /** Prompt that defines the tester persona behaviour */
        prompt: string;
        /** Mini-prompt evaluated at each turn to decide whether the tester should hang up */
        hangUpPrompt: string | null;
        /** ID of the LLM provider */
        llmProviderId: string | null;
        /** LLM provider-specific settings */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** Key-value user profile data */
        userProfile: Record<string, any>;
        /** Tags for categorizing and filtering this tester */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the tester was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the tester was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/testers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of testers with optional filtering and sorting
   *
   * @tags Testers
   * @name ProjectsTestersList
   * @summary List testers
   * @request GET:/api/projects/{projectId}/testers
   * @secure
   */
  projectsTestersList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of testers in the current page */
        items: {
          /** Unique identifier for the tester */
          id: string;
          /** ID of the project this tester belongs to */
          projectId: string;
          /** Display name of the tester persona */
          name: string;
          /** Detailed description of the tester persona */
          description: string | null;
          /** Prompt that defines the tester persona behaviour */
          prompt: string;
          /** Mini-prompt evaluated at each turn to decide whether the tester should hang up */
          hangUpPrompt: string | null;
          /** ID of the LLM provider */
          llmProviderId: string | null;
          /** LLM provider-specific settings */
          llmSettings?:
            | OpenAILlmSettings
            | OpenAILegacyLlmSettings
            | AnthropicLlmSettings
            | GeminiLlmSettings
            | GroqLlmSettings
            | MistralLlmSettings
            | DeepSeekLlmSettings
            | OpenRouterLlmSettings
            | TogetherAILlmSettings
            | FireworksAILlmSettings
            | PerplexityLlmSettings
            | CohereLlmSettings
            | XAILlmSettings
            | OllamaLlmSettings;
          /** Key-value user profile data */
          userProfile: Record<string, any>;
          /** Tags for categorizing and filtering this tester */
          tags: string[];
          /** Additional metadata */
          metadata: Record<string, any>;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the tester was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the tester was last updated
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /**
         * Total number of testers matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      any
    >({
      path: `/api/projects/${projectId}/testers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single tester by its unique identifier
   *
   * @tags Testers
   * @name ProjectsTestersDetail
   * @summary Get tester by ID
   * @request GET:/api/projects/{projectId}/testers/{id}
   * @secure
   */
  projectsTestersDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the tester */
        id: string;
        /** ID of the project this tester belongs to */
        projectId: string;
        /** Display name of the tester persona */
        name: string;
        /** Detailed description of the tester persona */
        description: string | null;
        /** Prompt that defines the tester persona behaviour */
        prompt: string;
        /** Mini-prompt evaluated at each turn to decide whether the tester should hang up */
        hangUpPrompt: string | null;
        /** ID of the LLM provider */
        llmProviderId: string | null;
        /** LLM provider-specific settings */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** Key-value user profile data */
        userProfile: Record<string, any>;
        /** Tags for categorizing and filtering this tester */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the tester was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the tester was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/testers/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing tester with optimistic locking
   *
   * @tags Testers
   * @name ProjectsTestersUpdate
   * @summary Update tester
   * @request PUT:/api/projects/{projectId}/testers/{id}
   * @secure
   */
  projectsTestersUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * Updated display name
       * @minLength 1
       */
      name?: string;
      /** Updated description */
      description?: string | null;
      /**
       * Updated persona prompt
       * @minLength 1
       */
      prompt?: string;
      /** Updated hang-up decision mini-prompt */
      hangUpPrompt?: string | null;
      /**
       * Updated LLM provider ID
       * @minLength 1
       */
      llmProviderId?: string;
      /** Updated LLM provider-specific settings */
      llmSettings?: LlmSettings;
      /** Updated user profile data */
      userProfile?: Record<string, any>;
      /** Updated tags */
      tags?: string[];
      /** Updated metadata */
      metadata?: Record<string, any>;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the tester */
        id: string;
        /** ID of the project this tester belongs to */
        projectId: string;
        /** Display name of the tester persona */
        name: string;
        /** Detailed description of the tester persona */
        description: string | null;
        /** Prompt that defines the tester persona behaviour */
        prompt: string;
        /** Mini-prompt evaluated at each turn to decide whether the tester should hang up */
        hangUpPrompt: string | null;
        /** ID of the LLM provider */
        llmProviderId: string | null;
        /** LLM provider-specific settings */
        llmSettings?:
          | OpenAILlmSettings
          | OpenAILegacyLlmSettings
          | AnthropicLlmSettings
          | GeminiLlmSettings
          | GroqLlmSettings
          | MistralLlmSettings
          | DeepSeekLlmSettings
          | OpenRouterLlmSettings
          | TogetherAILlmSettings
          | FireworksAILlmSettings
          | PerplexityLlmSettings
          | CohereLlmSettings
          | XAILlmSettings
          | OllamaLlmSettings;
        /** Key-value user profile data */
        userProfile: Record<string, any>;
        /** Tags for categorizing and filtering this tester */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the tester was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the tester was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/testers/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a tester with optimistic locking
   *
   * @tags Testers
   * @name ProjectsTestersDelete
   * @summary Delete tester
   * @request DELETE:/api/projects/{projectId}/testers/{id}
   * @secure
   */
  projectsTestersDelete = (
    projectId: string,
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/testers/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific tester
   *
   * @tags Testers
   * @name ProjectsTestersAuditLogsList
   * @summary Get tester audit logs
   * @request GET:/api/projects/{projectId}/testers/{id}/audit-logs
   * @secure
   */
  projectsTestersAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/testers/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a new test scenario defining the conversation flow, data extraction, and success criteria
   *
   * @tags Scenarios
   * @name ProjectsScenariosCreate
   * @summary Create a new scenario
   * @request POST:/api/projects/{projectId}/scenarios
   * @secure
   */
  projectsScenariosCreate = (
    projectId: string,
    data: {
      /**
       * Unique identifier for the scenario (auto-generated if not provided)
       * @minLength 1
       */
      id?: string;
      /**
       * Display name of the scenario
       * @minLength 1
       */
      name: string;
      /** Detailed description of the scenario purpose and expected flow */
      description?: string | null;
      /**
       * Language code of the conversation (e.g. en-US)
       * @minLength 1
       */
      language: string;
      /**
       * ID of the stage where the conversation begins
       * @minLength 1
       */
      startingStageId: string;
      /**
       * Maximum number of conversation turns before the scenario is terminated
       * @min 1
       */
      maxTurns: number;
      /**
       * Stage IDs that signal a successful conversation ending
       * @default []
       */
      endingStageIds?: string[];
      /**
       * Whether the tester persona is allowed to hang up the conversation
       * @default false
       */
      personaCanHangUp?: boolean;
      /** Opening message sent by the tester when the first stage awaits user input, instead of calling the LLM. Defaults to "[Conversation begins.]" when not set. */
      conversationOpener?: string;
      /** Stage variables to extract at the end of the run and their expected values */
      dataExtraction?: DataExtractionEntry[];
      /**
       * ID of the context transformer used to post-process extracted data
       * @minLength 1
       */
      contextTransformerId?: string;
      /** Expected values after post-processing — each entry has an optional value and comparison mode (default "eq") */
      dataPostProcessingExpected?: Record<string, ExpectedValueEntry>;
      /**
       * Tags for categorizing and filtering this scenario
       * @default []
       */
      tags?: string[];
      /** Additional scenario-specific metadata */
      metadata?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the scenario */
        id: string;
        /** ID of the project this scenario belongs to */
        projectId: string;
        /** Display name of the scenario */
        name: string;
        /** Detailed description of the scenario */
        description: string | null;
        /** Language code of the conversation */
        language: string;
        /** ID of the stage where the conversation begins */
        startingStageId: string;
        /** Maximum number of conversation turns */
        maxTurns: number;
        /** Stage IDs that signal a successful ending */
        endingStageIds: string[];
        /** Whether the tester persona is allowed to hang up */
        personaCanHangUp: boolean;
        /** Opening message sent by the tester when the first stage awaits user input */
        conversationOpener: string | null;
        /** Data extraction configuration */
        dataExtraction: DataExtractionEntry[] | null;
        /** ID of the context transformer for post-processing */
        contextTransformerId: string | null;
        /** Expected values after post-processing — each entry has an optional value and comparison mode (default "eq") */
        dataPostProcessingExpected: Record<string, ExpectedValueEntry>;
        /** Tags for categorizing and filtering */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the scenario was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the scenario was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/scenarios`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of scenarios with optional filtering and sorting
   *
   * @tags Scenarios
   * @name ProjectsScenariosList
   * @summary List scenarios
   * @request GET:/api/projects/{projectId}/scenarios
   * @secure
   */
  projectsScenariosList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of scenarios in the current page */
        items: {
          /** Unique identifier for the scenario */
          id: string;
          /** ID of the project this scenario belongs to */
          projectId: string;
          /** Display name of the scenario */
          name: string;
          /** Detailed description of the scenario */
          description: string | null;
          /** Language code of the conversation */
          language: string;
          /** ID of the stage where the conversation begins */
          startingStageId: string;
          /** Maximum number of conversation turns */
          maxTurns: number;
          /** Stage IDs that signal a successful ending */
          endingStageIds: string[];
          /** Whether the tester persona is allowed to hang up */
          personaCanHangUp: boolean;
          /** Opening message sent by the tester when the first stage awaits user input */
          conversationOpener: string | null;
          /** Data extraction configuration */
          dataExtraction: DataExtractionEntry[] | null;
          /** ID of the context transformer for post-processing */
          contextTransformerId: string | null;
          /** Expected values after post-processing — each entry has an optional value and comparison mode (default "eq") */
          dataPostProcessingExpected: Record<string, ExpectedValueEntry>;
          /** Tags for categorizing and filtering */
          tags: string[];
          /** Additional metadata */
          metadata: Record<string, any>;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the scenario was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the scenario was last updated
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /**
         * Total number of scenarios matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      any
    >({
      path: `/api/projects/${projectId}/scenarios`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single scenario by its unique identifier
   *
   * @tags Scenarios
   * @name ProjectsScenariosDetail
   * @summary Get scenario by ID
   * @request GET:/api/projects/{projectId}/scenarios/{id}
   * @secure
   */
  projectsScenariosDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the scenario */
        id: string;
        /** ID of the project this scenario belongs to */
        projectId: string;
        /** Display name of the scenario */
        name: string;
        /** Detailed description of the scenario */
        description: string | null;
        /** Language code of the conversation */
        language: string;
        /** ID of the stage where the conversation begins */
        startingStageId: string;
        /** Maximum number of conversation turns */
        maxTurns: number;
        /** Stage IDs that signal a successful ending */
        endingStageIds: string[];
        /** Whether the tester persona is allowed to hang up */
        personaCanHangUp: boolean;
        /** Opening message sent by the tester when the first stage awaits user input */
        conversationOpener: string | null;
        /** Data extraction configuration */
        dataExtraction: DataExtractionEntry[] | null;
        /** ID of the context transformer for post-processing */
        contextTransformerId: string | null;
        /** Expected values after post-processing — each entry has an optional value and comparison mode (default "eq") */
        dataPostProcessingExpected: Record<string, ExpectedValueEntry>;
        /** Tags for categorizing and filtering */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the scenario was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the scenario was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/scenarios/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing scenario with optimistic locking
   *
   * @tags Scenarios
   * @name ProjectsScenariosUpdate
   * @summary Update scenario
   * @request PUT:/api/projects/{projectId}/scenarios/{id}
   * @secure
   */
  projectsScenariosUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * Updated display name
       * @minLength 1
       */
      name?: string;
      /** Updated description */
      description?: string | null;
      /**
       * Updated language code
       * @minLength 1
       */
      language?: string;
      /**
       * Updated starting stage ID
       * @minLength 1
       */
      startingStageId?: string;
      /**
       * Updated maximum turn count
       * @min 1
       */
      maxTurns?: number;
      /** Updated ending stage IDs */
      endingStageIds?: string[];
      /** Updated hang-up flag */
      personaCanHangUp?: boolean;
      /** Updated conversation opener message */
      conversationOpener?: string | null;
      /** Updated data extraction configuration */
      dataExtraction?: DataExtractionEntry[];
      /**
       * Updated context transformer ID
       * @minLength 1
       */
      contextTransformerId?: string | null;
      /** Updated post-processing expected values — each entry has an optional value and comparison mode (default "eq") */
      dataPostProcessingExpected?: Record<string, ExpectedValueEntry>;
      /** Updated tags */
      tags?: string[];
      /** Updated metadata */
      metadata?: Record<string, any>;
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the scenario */
        id: string;
        /** ID of the project this scenario belongs to */
        projectId: string;
        /** Display name of the scenario */
        name: string;
        /** Detailed description of the scenario */
        description: string | null;
        /** Language code of the conversation */
        language: string;
        /** ID of the stage where the conversation begins */
        startingStageId: string;
        /** Maximum number of conversation turns */
        maxTurns: number;
        /** Stage IDs that signal a successful ending */
        endingStageIds: string[];
        /** Whether the tester persona is allowed to hang up */
        personaCanHangUp: boolean;
        /** Opening message sent by the tester when the first stage awaits user input */
        conversationOpener: string | null;
        /** Data extraction configuration */
        dataExtraction: DataExtractionEntry[] | null;
        /** ID of the context transformer for post-processing */
        contextTransformerId: string | null;
        /** Expected values after post-processing — each entry has an optional value and comparison mode (default "eq") */
        dataPostProcessingExpected: Record<string, ExpectedValueEntry>;
        /** Tags for categorizing and filtering */
        tags: string[];
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the scenario was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the scenario was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/scenarios/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a scenario with optimistic locking
   *
   * @tags Scenarios
   * @name ProjectsScenariosDelete
   * @summary Delete scenario
   * @request DELETE:/api/projects/{projectId}/scenarios/{id}
   * @secure
   */
  projectsScenariosDelete = (
    projectId: string,
    id: string,
    data: {
      /**
       * Current version number for optimistic locking
       * @min 1
       */
      version: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/scenarios/${id}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves audit logs for a specific scenario
   *
   * @tags Scenarios
   * @name ProjectsScenariosAuditLogsList
   * @summary Get scenario audit logs
   * @request GET:/api/projects/{projectId}/scenarios/{id}/audit-logs
   * @secure
   */
  projectsScenariosAuditLogsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/scenarios/${id}/audit-logs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a new scenario run instance with status queued, ready to be picked up by the testing engine
   *
   * @tags Scenario Runs
   * @name ProjectsScenarioRunsCreate
   * @summary Create a new scenario run
   * @request POST:/api/projects/{projectId}/scenario-runs
   * @secure
   */
  projectsScenarioRunsCreate = (
    projectId: string,
    data: {
      /**
       * ID of the scenario to run
       * @minLength 1
       */
      scenarioId: string;
      /** Map of tester persona ID to number of conversations to run for that tester */
      testers: Record<string, number>;
      /** Additional metadata for this run */
      metadata?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the scenario run */
        id: string;
        /** ID of the project this run belongs to */
        projectId: string;
        /** ID of the scenario being run */
        scenarioId: string;
        /** Map of tester persona ID to number of conversations assigned to that tester */
        testers: Record<string, number>;
        /** Computed total number of conversations across all testers */
        totalConversations: number;
        /** Current status of the scenario run */
        status: ScenarioRunStatus;
        /** Human-readable details about the current status, e.g. failure reason or cancellation actor */
        statusDetails: string | null;
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the run was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the run was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/scenario-runs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of scenario runs with optional filtering and sorting
   *
   * @tags Scenario Runs
   * @name ProjectsScenarioRunsList
   * @summary List scenario runs
   * @request GET:/api/projects/{projectId}/scenario-runs
   * @secure
   */
  projectsScenarioRunsList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of scenario runs in the current page */
        items: {
          /** Unique identifier for the scenario run */
          id: string;
          /** ID of the project this run belongs to */
          projectId: string;
          /** ID of the scenario being run */
          scenarioId: string;
          /** Map of tester persona ID to number of conversations assigned to that tester */
          testers: Record<string, number>;
          /** Computed total number of conversations across all testers */
          totalConversations: number;
          /** Current status of the scenario run */
          status: ScenarioRunStatus;
          /** Human-readable details about the current status, e.g. failure reason or cancellation actor */
          statusDetails: string | null;
          /** Additional metadata */
          metadata: Record<string, any>;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the run was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the run was last updated
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /**
         * Total number of scenario runs matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      any
    >({
      path: `/api/projects/${projectId}/scenario-runs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single scenario run by its unique identifier
   *
   * @tags Scenario Runs
   * @name ProjectsScenarioRunsDetail
   * @summary Get scenario run by ID
   * @request GET:/api/projects/{projectId}/scenario-runs/{id}
   * @secure
   */
  projectsScenarioRunsDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the scenario run */
        id: string;
        /** ID of the project this run belongs to */
        projectId: string;
        /** ID of the scenario being run */
        scenarioId: string;
        /** Map of tester persona ID to number of conversations assigned to that tester */
        testers: Record<string, number>;
        /** Computed total number of conversations across all testers */
        totalConversations: number;
        /** Current status of the scenario run */
        status: ScenarioRunStatus;
        /** Human-readable details about the current status, e.g. failure reason or cancellation actor */
        statusDetails: string | null;
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the run was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the run was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/scenario-runs/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Permanently deletes a scenario run and all its associated conversations. Only runs in terminal states (passed, failed, cancelled) can be deleted.
   *
   * @tags Scenario Runs
   * @name ProjectsScenarioRunsDelete
   * @summary Delete a scenario run
   * @request DELETE:/api/projects/{projectId}/scenario-runs/{id}
   * @secure
   */
  projectsScenarioRunsDelete = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/scenario-runs/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Cancels a scenario run that is currently queued or in progress. Already-running conversation slots will complete but no new slots will start.
   *
   * @tags Scenario Runs
   * @name ProjectsScenarioRunsCancelCreate
   * @summary Cancel a scenario run
   * @request POST:/api/projects/{projectId}/scenario-runs/{id}/cancel
   * @secure
   */
  projectsScenarioRunsCancelCreate = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the scenario run */
        id: string;
        /** ID of the project this run belongs to */
        projectId: string;
        /** ID of the scenario being run */
        scenarioId: string;
        /** Map of tester persona ID to number of conversations assigned to that tester */
        testers: Record<string, number>;
        /** Computed total number of conversations across all testers */
        totalConversations: number;
        /** Current status of the scenario run */
        status: ScenarioRunStatus;
        /** Human-readable details about the current status, e.g. failure reason or cancellation actor */
        statusDetails: string | null;
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the run was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the run was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/scenario-runs/${id}/cancel`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns whether the scenario run scheduler (circuit breaker) is currently enabled
   *
   * @tags Scenario Runs
   * @name ScenarioRunsSchedulerList
   * @summary Get scheduler status
   * @request GET:/api/scenario-runs/scheduler
   * @secure
   */
  scenarioRunsSchedulerList = (params: RequestParams = {}) =>
    this.request<
      {
        /** Whether the scenario run scheduler is currently enabled */
        enabled: boolean;
      },
      any
    >({
      path: `/api/scenario-runs/scheduler`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Enables or disables the scenario run scheduler circuit breaker. Disabling stops new executions from starting; in-flight runs complete normally.
   *
   * @tags Scenario Runs
   * @name ScenarioRunsSchedulerUpdate
   * @summary Update scheduler status
   * @request PUT:/api/scenario-runs/scheduler
   * @secure
   */
  scenarioRunsSchedulerUpdate = (
    data: {
      /** Set to true to enable the scheduler, false to disable it */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Whether the scenario run scheduler is currently enabled */
        enabled: boolean;
      },
      void
    >({
      path: `/api/scenario-runs/scheduler`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of scenario conversations. Use the scenarioRunId query parameter to filter by run.
   *
   * @tags Scenario Conversations
   * @name ProjectsScenarioConversationsList
   * @summary List scenario conversations
   * @request GET:/api/projects/{projectId}/scenario-conversations
   * @secure
   */
  projectsScenarioConversationsList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
      /** Filter conversations by scenario run ID */
      scenarioRunId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Array of scenario conversations in the current page */
        items: {
          /** Unique identifier for the scenario conversation */
          id: string;
          /** ID of the project this conversation belongs to */
          projectId: string;
          /** ID of the scenario run this conversation belongs to */
          scenarioRunId: string;
          /** ID of the scenario being tested */
          scenarioId: string;
          /** ID of the tester persona used in this conversation */
          testerId: string;
          /** ID of the underlying conversation used to run this scenario conversation */
          conversationId: string | null;
          /** Current execution status of this conversation */
          status: "queued" | "in_progress" | "passed" | "failed" | "cancelled";
          /** Extracted stage variable values at the end of the conversation */
          dataExtractionResults: Record<string, any>;
          /** Post-processed data transformation results */
          dataTransformationResults: Record<string, any>;
          /** Additional metadata */
          metadata: Record<string, any>;
          /** Version number for optimistic locking */
          version: number;
          /**
           * Timestamp when the scenario conversation was created
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Timestamp when the scenario conversation was last updated
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /**
         * Total number of scenario conversations matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      any
    >({
      path: `/api/projects/${projectId}/scenario-conversations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a single scenario conversation by its unique identifier
   *
   * @tags Scenario Conversations
   * @name ProjectsScenarioConversationsDetail
   * @summary Get scenario conversation by ID
   * @request GET:/api/projects/{projectId}/scenario-conversations/{id}
   * @secure
   */
  projectsScenarioConversationsDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique identifier for the scenario conversation */
        id: string;
        /** ID of the project this conversation belongs to */
        projectId: string;
        /** ID of the scenario run this conversation belongs to */
        scenarioRunId: string;
        /** ID of the scenario being tested */
        scenarioId: string;
        /** ID of the tester persona used in this conversation */
        testerId: string;
        /** ID of the underlying conversation used to run this scenario conversation */
        conversationId: string | null;
        /** Current execution status of this conversation */
        status: "queued" | "in_progress" | "passed" | "failed" | "cancelled";
        /** Extracted stage variable values at the end of the conversation */
        dataExtractionResults: Record<string, any>;
        /** Post-processed data transformation results */
        dataTransformationResults: Record<string, any>;
        /** Additional metadata */
        metadata: Record<string, any>;
        /** Version number for optimistic locking */
        version: number;
        /**
         * Timestamp when the scenario conversation was created
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Timestamp when the scenario conversation was last updated
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/scenario-conversations/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new outbound campaign in draft status. References a distribution list for contacts.
   *
   * @tags Outbound Campaigns
   * @name ProjectsOutboundCampaignsCreate
   * @summary Create an outbound campaign
   * @request POST:/api/projects/{projectId}/outbound-campaigns
   * @secure
   */
  projectsOutboundCampaignsCreate = (
    projectId: string,
    data: {
      /**
       * Name of the outbound campaign
       * @minLength 1
       */
      name: string;
      /** Outbound channel type */
      channelType: "twilio_voice" | "twilio_messaging" | "whatsapp";
      /**
       * ID of the channel provider to use for sending messages/placing calls
       * @minLength 1
       */
      channelProviderId: string;
      /**
       * Stage ID to start conversations at
       * @minLength 1
       */
      stageId: string;
      /**
       * Optional agent ID override for this campaign
       * @minLength 1
       */
      agentId?: string;
      /**
       * WhatsApp message template name (required for whatsapp channel, optional for others)
       * @minLength 1
       */
      templateName?: string;
      /**
       * ID of the distribution list to use as the contact source
       * @minLength 1
       */
      distributionListId: string;
      /** Optional tag filter — only entries with matching tags will be targeted */
      tagFilter?: string[];
      /**
       * Maximum number of concurrent outbound connections (1-50, default: 1)
       * @min 1
       * @max 50
       * @default 1
       */
      maxConcurrency?: number;
      /**
       * Maximum retry attempts per contact (0-10, default: 3)
       * @min 0
       * @max 10
       * @default 3
       */
      retryAttempts?: number;
      /**
       * Minimum cooldown between retries in minutes (5-1440, default: 120)
       * @min 5
       * @max 1440
       * @default 120
       */
      retryCooldownMinutes?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Campaign ID */
        id: string;
        /** Project ID */
        projectId: string;
        /** Campaign name */
        name: string;
        /** Outbound channel type */
        channelType: "twilio_voice" | "twilio_messaging" | "whatsapp";
        /** Channel provider ID */
        channelProviderId: string;
        /** Starting stage ID */
        stageId: string;
        /** Optional agent ID override */
        agentId: string | null;
        /** WhatsApp template name (if applicable) */
        templateName: string | null;
        /** Max concurrent connections */
        maxConcurrency: number;
        /** Max retry attempts per contact */
        retryAttempts: number;
        /** Cooldown between retries in minutes */
        retryCooldownMinutes: number;
        /** Campaign status */
        status: "draft" | "running" | "paused" | "completed" | "cancelled";
        /** ID of the referenced distribution list */
        distributionListId: string | null;
        /** Tag filter applied to the distribution list */
        tagFilter: string[] | null;
        /** Total number of entries in the campaign */
        totalEntries?: number;
        /** Number of completed entries */
        completedEntries?: number;
        /** Number of failed entries */
        failedEntries?: number;
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/outbound-campaigns`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a paginated list of outbound campaigns for a project.
   *
   * @tags Outbound Campaigns
   * @name ProjectsOutboundCampaignsList
   * @summary List outbound campaigns
   * @request GET:/api/projects/{projectId}/outbound-campaigns
   * @secure
   */
  projectsOutboundCampaignsList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        items: {
          /** Campaign ID */
          id: string;
          /** Project ID */
          projectId: string;
          /** Campaign name */
          name: string;
          /** Outbound channel type */
          channelType: "twilio_voice" | "twilio_messaging" | "whatsapp";
          /** Channel provider ID */
          channelProviderId: string;
          /** Starting stage ID */
          stageId: string;
          /** Optional agent ID override */
          agentId: string | null;
          /** WhatsApp template name (if applicable) */
          templateName: string | null;
          /** Max concurrent connections */
          maxConcurrency: number;
          /** Max retry attempts per contact */
          retryAttempts: number;
          /** Cooldown between retries in minutes */
          retryCooldownMinutes: number;
          /** Campaign status */
          status: "draft" | "running" | "paused" | "completed" | "cancelled";
          /** ID of the referenced distribution list */
          distributionListId: string | null;
          /** Tag filter applied to the distribution list */
          tagFilter: string[] | null;
          /** Total number of entries in the campaign */
          totalEntries?: number;
          /** Number of completed entries */
          completedEntries?: number;
          /** Number of failed entries */
          failedEntries?: number;
          version: number;
          /**
           * Creation timestamp
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Last update timestamp
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        total: number;
        page: number;
        limit: number;
        totalPages: number;
      },
      any
    >({
      path: `/api/projects/${projectId}/outbound-campaigns`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Outbound Campaigns
   * @name ProjectsOutboundCampaignsDetail
   * @summary Get outbound campaign
   * @request GET:/api/projects/{projectId}/outbound-campaigns/{id}
   * @secure
   */
  projectsOutboundCampaignsDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Campaign ID */
        id: string;
        /** Project ID */
        projectId: string;
        /** Campaign name */
        name: string;
        /** Outbound channel type */
        channelType: "twilio_voice" | "twilio_messaging" | "whatsapp";
        /** Channel provider ID */
        channelProviderId: string;
        /** Starting stage ID */
        stageId: string;
        /** Optional agent ID override */
        agentId: string | null;
        /** WhatsApp template name (if applicable) */
        templateName: string | null;
        /** Max concurrent connections */
        maxConcurrency: number;
        /** Max retry attempts per contact */
        retryAttempts: number;
        /** Cooldown between retries in minutes */
        retryCooldownMinutes: number;
        /** Campaign status */
        status: "draft" | "running" | "paused" | "completed" | "cancelled";
        /** ID of the referenced distribution list */
        distributionListId: string | null;
        /** Tag filter applied to the distribution list */
        tagFilter: string[] | null;
        /** Total number of entries in the campaign */
        totalEntries?: number;
        /** Number of completed entries */
        completedEntries?: number;
        /** Number of failed entries */
        failedEntries?: number;
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/outbound-campaigns/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a campaign. Only draft, completed, or cancelled campaigns can be deleted.
   *
   * @tags Outbound Campaigns
   * @name ProjectsOutboundCampaignsDelete
   * @summary Delete outbound campaign
   * @request DELETE:/api/projects/{projectId}/outbound-campaigns/{id}
   * @secure
   */
  projectsOutboundCampaignsDelete = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/outbound-campaigns/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Outbound Campaigns
   * @name ProjectsOutboundCampaignsStartCreate
   * @summary Start campaign
   * @request POST:/api/projects/{projectId}/outbound-campaigns/{id}/start
   * @secure
   */
  projectsOutboundCampaignsStartCreate = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Campaign ID */
        id: string;
        /** Project ID */
        projectId: string;
        /** Campaign name */
        name: string;
        /** Outbound channel type */
        channelType: "twilio_voice" | "twilio_messaging" | "whatsapp";
        /** Channel provider ID */
        channelProviderId: string;
        /** Starting stage ID */
        stageId: string;
        /** Optional agent ID override */
        agentId: string | null;
        /** WhatsApp template name (if applicable) */
        templateName: string | null;
        /** Max concurrent connections */
        maxConcurrency: number;
        /** Max retry attempts per contact */
        retryAttempts: number;
        /** Cooldown between retries in minutes */
        retryCooldownMinutes: number;
        /** Campaign status */
        status: "draft" | "running" | "paused" | "completed" | "cancelled";
        /** ID of the referenced distribution list */
        distributionListId: string | null;
        /** Tag filter applied to the distribution list */
        tagFilter: string[] | null;
        /** Total number of entries in the campaign */
        totalEntries?: number;
        /** Number of completed entries */
        completedEntries?: number;
        /** Number of failed entries */
        failedEntries?: number;
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/outbound-campaigns/${id}/start`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Pauses the campaign. In-flight calls complete normally; no new entries are started.
   *
   * @tags Outbound Campaigns
   * @name ProjectsOutboundCampaignsPauseCreate
   * @summary Pause campaign
   * @request POST:/api/projects/{projectId}/outbound-campaigns/{id}/pause
   * @secure
   */
  projectsOutboundCampaignsPauseCreate = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Campaign ID */
        id: string;
        /** Project ID */
        projectId: string;
        /** Campaign name */
        name: string;
        /** Outbound channel type */
        channelType: "twilio_voice" | "twilio_messaging" | "whatsapp";
        /** Channel provider ID */
        channelProviderId: string;
        /** Starting stage ID */
        stageId: string;
        /** Optional agent ID override */
        agentId: string | null;
        /** WhatsApp template name (if applicable) */
        templateName: string | null;
        /** Max concurrent connections */
        maxConcurrency: number;
        /** Max retry attempts per contact */
        retryAttempts: number;
        /** Cooldown between retries in minutes */
        retryCooldownMinutes: number;
        /** Campaign status */
        status: "draft" | "running" | "paused" | "completed" | "cancelled";
        /** ID of the referenced distribution list */
        distributionListId: string | null;
        /** Tag filter applied to the distribution list */
        tagFilter: string[] | null;
        /** Total number of entries in the campaign */
        totalEntries?: number;
        /** Number of completed entries */
        completedEntries?: number;
        /** Number of failed entries */
        failedEntries?: number;
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/outbound-campaigns/${id}/pause`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Outbound Campaigns
   * @name ProjectsOutboundCampaignsResumeCreate
   * @summary Resume campaign
   * @request POST:/api/projects/{projectId}/outbound-campaigns/{id}/resume
   * @secure
   */
  projectsOutboundCampaignsResumeCreate = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Campaign ID */
        id: string;
        /** Project ID */
        projectId: string;
        /** Campaign name */
        name: string;
        /** Outbound channel type */
        channelType: "twilio_voice" | "twilio_messaging" | "whatsapp";
        /** Channel provider ID */
        channelProviderId: string;
        /** Starting stage ID */
        stageId: string;
        /** Optional agent ID override */
        agentId: string | null;
        /** WhatsApp template name (if applicable) */
        templateName: string | null;
        /** Max concurrent connections */
        maxConcurrency: number;
        /** Max retry attempts per contact */
        retryAttempts: number;
        /** Cooldown between retries in minutes */
        retryCooldownMinutes: number;
        /** Campaign status */
        status: "draft" | "running" | "paused" | "completed" | "cancelled";
        /** ID of the referenced distribution list */
        distributionListId: string | null;
        /** Tag filter applied to the distribution list */
        tagFilter: string[] | null;
        /** Total number of entries in the campaign */
        totalEntries?: number;
        /** Number of completed entries */
        completedEntries?: number;
        /** Number of failed entries */
        failedEntries?: number;
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/outbound-campaigns/${id}/resume`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Cancels the campaign. Pending/retrying entries are marked as skipped.
   *
   * @tags Outbound Campaigns
   * @name ProjectsOutboundCampaignsCancelCreate
   * @summary Cancel campaign
   * @request POST:/api/projects/{projectId}/outbound-campaigns/{id}/cancel
   * @secure
   */
  projectsOutboundCampaignsCancelCreate = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Campaign ID */
        id: string;
        /** Project ID */
        projectId: string;
        /** Campaign name */
        name: string;
        /** Outbound channel type */
        channelType: "twilio_voice" | "twilio_messaging" | "whatsapp";
        /** Channel provider ID */
        channelProviderId: string;
        /** Starting stage ID */
        stageId: string;
        /** Optional agent ID override */
        agentId: string | null;
        /** WhatsApp template name (if applicable) */
        templateName: string | null;
        /** Max concurrent connections */
        maxConcurrency: number;
        /** Max retry attempts per contact */
        retryAttempts: number;
        /** Cooldown between retries in minutes */
        retryCooldownMinutes: number;
        /** Campaign status */
        status: "draft" | "running" | "paused" | "completed" | "cancelled";
        /** ID of the referenced distribution list */
        distributionListId: string | null;
        /** Tag filter applied to the distribution list */
        tagFilter: string[] | null;
        /** Total number of entries in the campaign */
        totalEntries?: number;
        /** Number of completed entries */
        completedEntries?: number;
        /** Number of failed entries */
        failedEntries?: number;
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/outbound-campaigns/${id}/cancel`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Outbound Campaigns
   * @name ProjectsOutboundCampaignsEntriesList
   * @summary List campaign entries
   * @request GET:/api/projects/{projectId}/outbound-campaigns/{campaignId}/entries
   * @secure
   */
  projectsOutboundCampaignsEntriesList = (
    projectId: string,
    campaignId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/api/projects/${projectId}/outbound-campaigns/${campaignId}/entries`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Outbound Campaigns
   * @name ProjectsOutboundCampaignsEntriesDetail
   * @summary Get campaign entry
   * @request GET:/api/projects/{projectId}/outbound-campaigns/{campaignId}/entries/{id}
   * @secure
   */
  projectsOutboundCampaignsEntriesDetail = (
    projectId: string,
    campaignId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/outbound-campaigns/${campaignId}/entries/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Outbound Campaigns
   * @name ProjectsOutboundCampaignsStatsList
   * @summary Get campaign statistics
   * @request GET:/api/projects/{projectId}/outbound-campaigns/{id}/stats
   * @secure
   */
  projectsOutboundCampaignsStatsList = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        campaignId: string;
        totalEntries: number;
        pending: number;
        calling: number;
        retrying: number;
        completed: number;
        failed: number;
        skipped: number;
        /** Breakdown of call result types */
        callResults?: Record<string, number>;
      },
      any
    >({
      path: `/api/projects/${projectId}/outbound-campaigns/${id}/stats`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Outbound Campaigns
   * @name OutboundCampaignsSchedulerList
   * @summary Get scheduler status
   * @request GET:/api/outbound-campaigns/scheduler
   * @secure
   */
  outboundCampaignsSchedulerList = (params: RequestParams = {}) =>
    this.request<
      {
        /** Whether the outbound campaign executor is enabled */
        enabled: boolean;
      },
      any
    >({
      path: `/api/outbound-campaigns/scheduler`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Outbound Campaigns
   * @name OutboundCampaignsSchedulerUpdate
   * @summary Update scheduler status
   * @request PUT:/api/outbound-campaigns/scheduler
   * @secure
   */
  outboundCampaignsSchedulerUpdate = (
    data: {
      /** Set to true to enable, false to disable */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Whether the outbound campaign executor is enabled */
        enabled: boolean;
      },
      any
    >({
      path: `/api/outbound-campaigns/scheduler`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Distribution Lists
   * @name ProjectsDistributionListsCreate
   * @summary Create a distribution list
   * @request POST:/api/projects/{projectId}/distribution-lists
   * @secure
   */
  projectsDistributionListsCreate = (
    projectId: string,
    data: {
      /**
       * Name of the distribution list
       * @minLength 1
       */
      name: string;
      /** Optional description */
      description?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Distribution list ID */
        id: string;
        /** Project ID */
        projectId: string;
        /** List name */
        name: string;
        /** Optional description */
        description: string | null;
        /** Total number of entries in the list */
        totalEntries?: number;
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      any
    >({
      path: `/api/projects/${projectId}/distribution-lists`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Distribution Lists
   * @name ProjectsDistributionListsList
   * @summary List distribution lists
   * @request GET:/api/projects/{projectId}/distribution-lists
   * @secure
   */
  projectsDistributionListsList = (
    projectId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        items: {
          /** Distribution list ID */
          id: string;
          /** Project ID */
          projectId: string;
          /** List name */
          name: string;
          /** Optional description */
          description: string | null;
          /** Total number of entries in the list */
          totalEntries?: number;
          version: number;
          /**
           * Creation timestamp
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Last update timestamp
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        total: number;
        page: number;
        limit: number;
        totalPages: number;
      },
      any
    >({
      path: `/api/projects/${projectId}/distribution-lists`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Distribution Lists
   * @name ProjectsDistributionListsDetail
   * @summary Get distribution list
   * @request GET:/api/projects/{projectId}/distribution-lists/{id}
   * @secure
   */
  projectsDistributionListsDetail = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Distribution list ID */
        id: string;
        /** Project ID */
        projectId: string;
        /** List name */
        name: string;
        /** Optional description */
        description: string | null;
        /** Total number of entries in the list */
        totalEntries?: number;
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/distribution-lists/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Distribution Lists
   * @name ProjectsDistributionListsPartialUpdate
   * @summary Update distribution list
   * @request PATCH:/api/projects/{projectId}/distribution-lists/{id}
   * @secure
   */
  projectsDistributionListsPartialUpdate = (
    projectId: string,
    id: string,
    data: {
      /**
       * Updated list name
       * @minLength 1
       */
      name?: string;
      /** Updated description */
      description?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Distribution list ID */
        id: string;
        /** Project ID */
        projectId: string;
        /** List name */
        name: string;
        /** Optional description */
        description: string | null;
        /** Total number of entries in the list */
        totalEntries?: number;
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/distribution-lists/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Distribution Lists
   * @name ProjectsDistributionListsDelete
   * @summary Delete distribution list
   * @request DELETE:/api/projects/{projectId}/distribution-lists/{id}
   * @secure
   */
  projectsDistributionListsDelete = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/distribution-lists/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description First column is contactId. A special _tags column (comma-separated) can be used for entry tagging.
   *
   * @tags Distribution Lists
   * @name ProjectsDistributionListsCsvCreate
   * @summary Upload CSV to distribution list
   * @request POST:/api/projects/{projectId}/distribution-lists/{id}/csv
   * @secure
   */
  projectsDistributionListsCsvCreate = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        entriesCreated: number;
        entriesSkipped: number;
        totalEntries: number;
        columns: string[];
      },
      any
    >({
      path: `/api/projects/${projectId}/distribution-lists/${id}/csv`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Distribution Lists
   * @name ProjectsDistributionListsEntriesBulkCreate
   * @summary Bulk add entries
   * @request POST:/api/projects/{projectId}/distribution-lists/{id}/entries/bulk
   * @secure
   */
  projectsDistributionListsEntriesBulkCreate = (
    projectId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        entriesCreated: number;
        entriesSkipped: number;
        totalEntries: number;
        columns: string[];
      },
      any
    >({
      path: `/api/projects/${projectId}/distribution-lists/${id}/entries/bulk`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Distribution Lists
   * @name ProjectsDistributionListsEntriesList
   * @summary List entries
   * @request GET:/api/projects/{projectId}/distribution-lists/{listId}/entries
   * @secure
   */
  projectsDistributionListsEntriesList = (
    projectId: string,
    listId: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        items: {
          id: string;
          listId: string;
          projectId: string;
          contactId: string;
          profileData: Record<string, any>;
          tags: string[] | null;
          /**
           * Entry creation timestamp
           * @format date-time
           */
          createdAt: string | null;
        }[];
        total: number;
        page: number;
        limit: number;
        totalPages: number;
      },
      any
    >({
      path: `/api/projects/${projectId}/distribution-lists/${listId}/entries`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Distribution Lists
   * @name ProjectsDistributionListsEntriesDetail
   * @summary Get entry
   * @request GET:/api/projects/{projectId}/distribution-lists/{listId}/entries/{id}
   * @secure
   */
  projectsDistributionListsEntriesDetail = (
    projectId: string,
    listId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        id: string;
        listId: string;
        projectId: string;
        contactId: string;
        profileData: Record<string, any>;
        tags: string[] | null;
        /**
         * Entry creation timestamp
         * @format date-time
         */
        createdAt: string | null;
      },
      void
    >({
      path: `/api/projects/${projectId}/distribution-lists/${listId}/entries/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Distribution Lists
   * @name ProjectsDistributionListsEntriesDelete
   * @summary Delete entry
   * @request DELETE:/api/projects/{projectId}/distribution-lists/{listId}/entries/{id}
   * @secure
   */
  projectsDistributionListsEntriesDelete = (
    projectId: string,
    listId: string,
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/projects/${projectId}/distribution-lists/${listId}/entries/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Accepts a WebRTC SDP offer from the client and returns an SDP answer with all ICE candidates embedded (gather-and-return; no trickle ICE). The client must add a microphone audio track and open a "control" DataChannel (ordered: true) before creating the offer. The server adds an outbound audio track to the answer for AI voice output. Once the control DataChannel is open, authenticate by sending an "auth" JSON message over it. All JSON messages use the same protocol as WebSocket. Voice audio flows over native RTP/SRTP media tracks.
   *
   * @tags WebRTC
   * @name WebrtcOfferCreate
   * @summary Exchange SDP offer/answer for WebRTC session
   * @request POST:/api/webrtc/offer
   */
  webrtcOfferCreate = (
    data: {
      /** SDP offer string generated by the client RTCPeerConnection */
      sdpOffer: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** SDP answer with all ICE candidates embedded (gather-and-return, no trickle ICE) */
        sdpAnswer: string;
      },
      void
    >({
      path: `/api/webrtc/offer`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Places an outbound call to the specified phone number using the given Twilio Voice channel provider. A conversation record is created immediately. The call session is established asynchronously when the callee answers and Twilio fires the voice webhook. The voice webhook URL is passed directly as the `url` parameter unless the provider has an `applicationSid` configured.
   *
   * @tags Twilio Voice
   * @name TwilioVoiceCallCreate
   * @summary Initiate an outgoing Twilio Voice call
   * @request POST:/api/twilio/voice/call
   */
  twilioVoiceCallCreate = (
    query: {
      /**
       * API key used to authenticate and identify the project
       * @minLength 1
       */
      apiKey: string;
      /**
       * Stage ID to start new conversations at. When omitted, falls back to the project-level default starting stage.
       * @minLength 1
       */
      stageId?: string;
      /** Optional agent ID override */
      agentId?: string;
      /**
       * ID of the Twilio Voice channel provider record
       * @minLength 1
       */
      channelProviderId: string;
    },
    data: {
      /**
       * Destination phone number in E.164 format (e.g. +15551234567)
       * @minLength 1
       */
      to: string;
      /** Stage ID to start the conversation at. When omitted, falls back to the project-level default starting stage. */
      stageId?: string;
      /** Optional agent ID override for this conversation */
      agentId?: string;
      /** Optional metadata to attach to the conversation record */
      metadata?: Record<string, any>;
      /** Optional user profile data to inject and deep-merge into the user's existing profile on the users table. */
      userProfile?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Twilio Call SID of the initiated outbound call */
        callSid: string;
        /** ID of the pre-created conversation record for this call attempt */
        conversationId: string;
      },
      void
    >({
      path: `/api/twilio/voice/call`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Starts a conversation for the specified recipient. The AI generates and sends the opening message automatically. Future inbound replies from the recipient will be attached to the same virtual session.
   *
   * @tags Twilio Messaging
   * @name TwilioMessagingSendCreate
   * @summary Initiate an outgoing Twilio Messaging conversation
   * @request POST:/api/twilio/messaging/send
   */
  twilioMessagingSendCreate = (
    query: {
      /**
       * API key used to authenticate and identify the project
       * @minLength 1
       */
      apiKey: string;
      /**
       * Stage ID to start new conversations at. When omitted, falls back to the project-level default starting stage.
       * @minLength 1
       */
      stageId?: string;
      /** Optional agent ID override */
      agentId?: string;
      /**
       * ID of the Twilio Messaging channel provider record
       * @minLength 1
       */
      channelProviderId: string;
    },
    data: {
      /**
       * Destination phone number in E.164 format (e.g. +15551234567)
       * @minLength 1
       */
      to: string;
      /** Stage ID to start the conversation at. When omitted, falls back to the project-level default starting stage. */
      stageId?: string;
      /** Optional agent ID override for this conversation */
      agentId?: string;
      /** Optional metadata to attach to the conversation record */
      metadata?: Record<string, any>;
      /** Optional user profile data to inject and deep-merge into the user's existing profile on the users table. */
      userProfile?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** ID of the conversation record created for this outgoing conversation */
        conversationId: string;
      },
      void
    >({
      path: `/api/twilio/messaging/send`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Sends an approved WhatsApp template message to the specified phone number and pre-creates a conversation record. WhatsApp requires an approved template for business-initiated conversations. Future inbound replies will be attached to the same virtual session.
   *
   * @tags WhatsApp
   * @name WhatsappSendCreate
   * @summary Initiate an outgoing WhatsApp conversation
   * @request POST:/api/whatsapp/send
   */
  whatsappSendCreate = (
    query: {
      /**
       * API key used to authenticate and identify the project
       * @minLength 1
       */
      apiKey: string;
      /**
       * Stage ID to start new conversations at. When omitted, falls back to the project-level default starting stage.
       * @minLength 1
       */
      stageId?: string;
      /** Optional agent ID override */
      agentId?: string;
      /**
       * ID of the WhatsApp channel provider record
       * @minLength 1
       */
      channelProviderId: string;
    },
    data: {
      /**
       * Destination WhatsApp phone number in E.164 format (e.g. +15551234567)
       * @minLength 1
       */
      to: string;
      /**
       * Name of the approved WhatsApp message template to use
       * @minLength 1
       */
      templateName: string;
      /** Positional parameter values to substitute into the template body ({{1}}, {{2}}, …) */
      templateParams?: string[];
      /** Stage ID to start the conversation at. When omitted, falls back to the project-level default starting stage. */
      stageId?: string;
      /** Optional agent ID override for this conversation */
      agentId?: string;
      /** Optional metadata to attach to the conversation record */
      metadata?: Record<string, any>;
      /** Optional user profile data to inject and deep-merge into the user's existing profile on the users table. */
      userProfile?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Meta message ID of the sent template message */
        messageId: string;
        /** ID of the pre-created conversation record */
        conversationId: string;
      },
      void
    >({
      path: `/api/whatsapp/send`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Webhook endpoint for receiving inbound text messages from Telegram users. The webhook URL must be registered with the Bot API via the `setupWebhook` endpoint.
   *
   * @tags Telegram
   * @name TelegramWebhookCreate
   * @summary Receive incoming Telegram messages
   * @request POST:/api/telegram/webhook
   */
  telegramWebhookCreate = (
    query: {
      /**
       * API key used to authenticate and identify the project
       * @minLength 1
       */
      apiKey: string;
      /**
       * Stage ID to start new conversations at. When omitted, falls back to the project-level default starting stage.
       * @minLength 1
       */
      stageId?: string;
      /** Optional agent ID override */
      agentId?: string;
      /**
       * ID of the Telegram channel provider record
       * @minLength 1
       */
      channelProviderId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/telegram/webhook`,
      method: "POST",
      query: query,
      ...params,
    });
  /**
   * @description Registers the server webhook URL with the Telegram Bot API so incoming messages are forwarded to this instance. Called from the admin UI after configuring a Telegram channel provider.
   *
   * @tags Telegram
   * @name TelegramDeployWebhookCreate
   * @summary Deploy Telegram webhook
   * @request POST:/api/telegram/deploy-webhook
   * @secure
   */
  telegramDeployWebhookCreate = (
    data: {
      /**
       * ID of the Telegram channel provider record whose bot token will be used
       * @minLength 1
       */
      channelProviderId: string;
      /**
       * API key to embed in the webhook URL. The webhook callback will include this key as a query parameter.
       * @minLength 1
       */
      apiKey: string;
      /**
       * Custom origin (protocol + host) for the webhook URL, e.g. https://api.example.com. If omitted, inferred from the incoming request
       * @format uri
       */
      origin?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<DeployTelegramWebhookResponse, void>({
      path: `/api/telegram/deploy-webhook`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns paginated benchmark suites ordered by creation date descending
   *
   * @tags Benchmarks
   * @name BenchmarksSuitesList
   * @summary List benchmark suites
   * @request GET:/api/benchmarks/suites
   * @secure
   */
  benchmarksSuitesList = (
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Benchmark suites in the current page */
        items: {
          /** Unique benchmark suite ID */
          id: string;
          /** Suite name */
          name: string;
          /** Suite description */
          description: string | null;
          /** Cron expression for scheduled runs */
          cronExpression: string | null;
          /** Whether the suite is active */
          isActive: boolean;
          /** Tags */
          tags: string[];
          /** Operator ID who created the suite */
          createdBy: string | null;
          /** Optimistic locking version */
          version: number;
          /**
           * Creation timestamp
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Last update timestamp
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /**
         * Total number of suites matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      any
    >({
      path: `/api/benchmarks/suites`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new benchmark suite with optional cron schedule
   *
   * @tags Benchmarks
   * @name BenchmarksSuitesCreate
   * @summary Create a benchmark suite
   * @request POST:/api/benchmarks/suites
   * @secure
   */
  benchmarksSuitesCreate = (
    data: {
      /**
       * Human-readable name for the suite
       * @minLength 1
       */
      name: string;
      /** Optional description of what this suite tests */
      description?: string;
      /** node-cron expression for scheduled execution, e.g. "0 * * * *". Omit for manual-only suites. */
      cronExpression?: string;
      /**
       * Whether the suite is active and eligible for scheduled execution
       * @default true
       */
      isActive?: boolean;
      /**
       * Optional tags for filtering and organisation
       * @default []
       */
      tags?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique benchmark suite ID */
        id: string;
        /** Suite name */
        name: string;
        /** Suite description */
        description: string | null;
        /** Cron expression for scheduled runs */
        cronExpression: string | null;
        /** Whether the suite is active */
        isActive: boolean;
        /** Tags */
        tags: string[];
        /** Operator ID who created the suite */
        createdBy: string | null;
        /** Optimistic locking version */
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/benchmarks/suites`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns a single benchmark suite by ID
   *
   * @tags Benchmarks
   * @name BenchmarksSuitesDetail
   * @summary Get a benchmark suite
   * @request GET:/api/benchmarks/suites/{id}
   * @secure
   */
  benchmarksSuitesDetail = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        /** Unique benchmark suite ID */
        id: string;
        /** Suite name */
        name: string;
        /** Suite description */
        description: string | null;
        /** Cron expression for scheduled runs */
        cronExpression: string | null;
        /** Whether the suite is active */
        isActive: boolean;
        /** Tags */
        tags: string[];
        /** Operator ID who created the suite */
        createdBy: string | null;
        /** Optimistic locking version */
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/benchmarks/suites/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing benchmark suite
   *
   * @tags Benchmarks
   * @name BenchmarksSuitesUpdate
   * @summary Update a benchmark suite
   * @request PUT:/api/benchmarks/suites/{id}
   * @secure
   */
  benchmarksSuitesUpdate = (
    id: string,
    data: {
      /** Current version for optimistic locking */
      version: number;
      /**
       * Human-readable name for the suite
       * @minLength 1
       */
      name?: string;
      /** Optional description */
      description?: string | null;
      /** node-cron expression; set to null to remove the schedule */
      cronExpression?: string | null;
      /** Whether the suite is active */
      isActive?: boolean;
      /** Tags for filtering */
      tags?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique benchmark suite ID */
        id: string;
        /** Suite name */
        name: string;
        /** Suite description */
        description: string | null;
        /** Cron expression for scheduled runs */
        cronExpression: string | null;
        /** Whether the suite is active */
        isActive: boolean;
        /** Tags */
        tags: string[];
        /** Operator ID who created the suite */
        createdBy: string | null;
        /** Optimistic locking version */
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/benchmarks/suites/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a benchmark suite and all its associated configs (cascade). Blocked if any runs exist for the suite.
   *
   * @tags Benchmarks
   * @name BenchmarksSuitesDelete
   * @summary Delete a benchmark suite
   * @request DELETE:/api/benchmarks/suites/{id}
   * @secure
   */
  benchmarksSuitesDelete = (id: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/benchmarks/suites/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Returns paginated benchmark configs belonging to a suite
   *
   * @tags Benchmarks
   * @name BenchmarksSuitesConfigsList
   * @summary List configs for a suite
   * @request GET:/api/benchmarks/suites/{id}/configs
   * @secure
   */
  benchmarksSuitesConfigsList = (
    id: string,
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Benchmark configs in the current page */
        items: {
          /** Unique ID */
          id: string;
          /** Parent suite ID */
          suiteId: string;
          /** Name */
          name: string;
          /** Description */
          description: string | null;
          /** Provider config ID */
          providerConfigId: string;
          /** Input type */
          inputType: "messages" | "text" | "audio";
          /** Input payload */
          inputData: Record<string, any>;
          /** Repeat count per run */
          repeats: number;
          /** Optimistic locking version */
          version: number;
          /**
           * Creation timestamp
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Last update timestamp
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /**
         * Total number of configs matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      void
    >({
      path: `/api/benchmarks/suites/${id}/configs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns paginated benchmark provider configs ordered by creation date descending
   *
   * @tags Benchmarks
   * @name BenchmarksProviderConfigsList
   * @summary List benchmark provider configs
   * @request GET:/api/benchmarks/provider-configs
   * @secure
   */
  benchmarksProviderConfigsList = (
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Benchmark provider configs in the current page */
        items: {
          /** Unique ID */
          id: string;
          /** Name */
          name: string;
          /** Provider type */
          providerType: "llm" | "tts" | "asr";
          /** Provider entity ID */
          providerId: string;
          /** Provider settings */
          settings: Record<string, any>;
          /** Additional provider-specific configuration (e.g. TTS model, voiceId, audioFormat, speed, languageCode) */
          providerSettings: Record<string, any>;
          /** Optimistic locking version */
          version: number;
          /**
           * Creation timestamp
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Last update timestamp
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /**
         * Total number of provider configs matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      any
    >({
      path: `/api/benchmarks/provider-configs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a reusable provider configuration snapshot for use in benchmark configs
   *
   * @tags Benchmarks
   * @name BenchmarksProviderConfigsCreate
   * @summary Create a benchmark provider config
   * @request POST:/api/benchmarks/provider-configs
   * @secure
   */
  benchmarksProviderConfigsCreate = (
    data: {
      /**
       * Human-readable name for this provider config
       * @minLength 1
       */
      name: string;
      /** Type of provider being configured */
      providerType: "llm" | "tts" | "asr";
      /**
       * ID of the provider entity to use
       * @minLength 1
       */
      providerId: string;
      /** Provider-specific settings (model, voice, language, etc.) */
      settings: Record<string, any>;
      /** Additional provider-specific configuration to apply on top of settings. TTS example: { model, voiceId, audioFormat, speed, languageCode, etc. } */
      providerSettings?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique ID */
        id: string;
        /** Name */
        name: string;
        /** Provider type */
        providerType: "llm" | "tts" | "asr";
        /** Provider entity ID */
        providerId: string;
        /** Provider settings */
        settings: Record<string, any>;
        /** Additional provider-specific configuration (e.g. TTS model, voiceId, audioFormat, speed, languageCode) */
        providerSettings: Record<string, any>;
        /** Optimistic locking version */
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/benchmarks/provider-configs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns a single benchmark provider config by ID
   *
   * @tags Benchmarks
   * @name BenchmarksProviderConfigsDetail
   * @summary Get a benchmark provider config
   * @request GET:/api/benchmarks/provider-configs/{id}
   * @secure
   */
  benchmarksProviderConfigsDetail = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        /** Unique ID */
        id: string;
        /** Name */
        name: string;
        /** Provider type */
        providerType: "llm" | "tts" | "asr";
        /** Provider entity ID */
        providerId: string;
        /** Provider settings */
        settings: Record<string, any>;
        /** Additional provider-specific configuration (e.g. TTS model, voiceId, audioFormat, speed, languageCode) */
        providerSettings: Record<string, any>;
        /** Optimistic locking version */
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/benchmarks/provider-configs/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing benchmark provider config
   *
   * @tags Benchmarks
   * @name BenchmarksProviderConfigsUpdate
   * @summary Update a benchmark provider config
   * @request PUT:/api/benchmarks/provider-configs/{id}
   * @secure
   */
  benchmarksProviderConfigsUpdate = (
    id: string,
    data: {
      /** Current version for optimistic locking */
      version: number;
      /**
       * Human-readable name
       * @minLength 1
       */
      name?: string;
      /**
       * Provider entity ID
       * @minLength 1
       */
      providerId?: string;
      /** Provider-specific settings */
      settings?: Record<string, any>;
      /** Additional provider-specific configuration; set to null to clear */
      providerSettings?: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique ID */
        id: string;
        /** Name */
        name: string;
        /** Provider type */
        providerType: "llm" | "tts" | "asr";
        /** Provider entity ID */
        providerId: string;
        /** Provider settings */
        settings: Record<string, any>;
        /** Additional provider-specific configuration (e.g. TTS model, voiceId, audioFormat, speed, languageCode) */
        providerSettings: Record<string, any>;
        /** Optimistic locking version */
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/benchmarks/provider-configs/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a benchmark provider config. Blocked if any benchmark configs reference it.
   *
   * @tags Benchmarks
   * @name BenchmarksProviderConfigsDelete
   * @summary Delete a benchmark provider config
   * @request DELETE:/api/benchmarks/provider-configs/{id}
   * @secure
   */
  benchmarksProviderConfigsDelete = (id: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/benchmarks/provider-configs/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a new benchmark test case, linked to a suite and provider config
   *
   * @tags Benchmarks
   * @name BenchmarksConfigsCreate
   * @summary Create a benchmark config
   * @request POST:/api/benchmarks/configs
   * @secure
   */
  benchmarksConfigsCreate = (
    data: {
      /**
       * ID of the benchmark suite this config belongs to
       * @minLength 1
       */
      suiteId: string;
      /**
       * Human-readable name for this test case
       * @minLength 1
       */
      name: string;
      /** Optional description */
      description?: string;
      /**
       * ID of the benchmark provider config to use
       * @minLength 1
       */
      providerConfigId: string;
      /** Type of input data: messages (LLM), text (TTS), or audio (ASR) */
      inputType: "messages" | "text" | "audio";
      /** Input payload. LLM: { messages: LlmMessage[] }. TTS: { text: string }. ASR: { audioBase64: string, mimeType: string, fileName?: string } */
      inputData: Record<string, any>;
      /**
       * Number of times to repeat the test per run
       * @min 1
       * @max 100
       * @default 3
       */
      repeats?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique ID */
        id: string;
        /** Parent suite ID */
        suiteId: string;
        /** Name */
        name: string;
        /** Description */
        description: string | null;
        /** Provider config ID */
        providerConfigId: string;
        /** Input type */
        inputType: "messages" | "text" | "audio";
        /** Input payload */
        inputData: Record<string, any>;
        /** Repeat count per run */
        repeats: number;
        /** Optimistic locking version */
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/benchmarks/configs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns a single benchmark config by ID
   *
   * @tags Benchmarks
   * @name BenchmarksConfigsDetail
   * @summary Get a benchmark config
   * @request GET:/api/benchmarks/configs/{id}
   * @secure
   */
  benchmarksConfigsDetail = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        /** Unique ID */
        id: string;
        /** Parent suite ID */
        suiteId: string;
        /** Name */
        name: string;
        /** Description */
        description: string | null;
        /** Provider config ID */
        providerConfigId: string;
        /** Input type */
        inputType: "messages" | "text" | "audio";
        /** Input payload */
        inputData: Record<string, any>;
        /** Repeat count per run */
        repeats: number;
        /** Optimistic locking version */
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/benchmarks/configs/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Updates an existing benchmark config
   *
   * @tags Benchmarks
   * @name BenchmarksConfigsUpdate
   * @summary Update a benchmark config
   * @request PUT:/api/benchmarks/configs/{id}
   * @secure
   */
  benchmarksConfigsUpdate = (
    id: string,
    data: {
      /** Current version for optimistic locking */
      version: number;
      /**
       * Test case name
       * @minLength 1
       */
      name?: string;
      /** Description */
      description?: string | null;
      /**
       * Provider config ID
       * @minLength 1
       */
      providerConfigId?: string;
      /** Input type */
      inputType?: "messages" | "text" | "audio";
      /** Input payload */
      inputData?: Record<string, any>;
      /**
       * Repeat count
       * @min 1
       * @max 100
       */
      repeats?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique ID */
        id: string;
        /** Parent suite ID */
        suiteId: string;
        /** Name */
        name: string;
        /** Description */
        description: string | null;
        /** Provider config ID */
        providerConfigId: string;
        /** Input type */
        inputType: "messages" | "text" | "audio";
        /** Input payload */
        inputData: Record<string, any>;
        /** Repeat count per run */
        repeats: number;
        /** Optimistic locking version */
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/benchmarks/configs/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a benchmark config. Blocked if any config executions exist (i.e., the config has been run). Delete the associated runs first.
   *
   * @tags Benchmarks
   * @name BenchmarksConfigsDelete
   * @summary Delete a benchmark config
   * @request DELETE:/api/benchmarks/configs/{id}
   * @secure
   */
  benchmarksConfigsDelete = (id: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/benchmarks/configs/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Triggers a manual benchmark run for the specified suite. The run is queued and executed asynchronously.
   *
   * @tags Benchmarks
   * @name BenchmarksRunsCreate
   * @summary Trigger a benchmark run
   * @request POST:/api/benchmarks/runs
   * @secure
   */
  benchmarksRunsCreate = (
    data: {
      /**
       * ID of the benchmark suite to execute
       * @minLength 1
       */
      suiteId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Unique benchmark run ID */
        id: string;
        /** Suite ID */
        suiteId: string;
        /** How the run was triggered */
        trigger: "manual" | "scheduled";
        /** Run status */
        status: "pending" | "in_progress" | "completed" | "failed";
        /**
         * When the run started
         * @format date-time
         */
        startedAt: string | null;
        /**
         * When the run completed
         * @format date-time
         */
        completedAt: string | null;
        /** Top-level error message if the run failed */
        error: string | null;
        /** Config executions within this run (included on single-run GET) */
        executions?: {
          /** Unique execution ID (the unique run_id that links a config to its results) */
          id: string;
          /** Parent benchmark run ID */
          runId: string;
          /** Benchmark config ID */
          configId: string;
          /** Execution status */
          status: "pending" | "in_progress" | "completed" | "failed";
          /** Aggregated statistics, populated after completion */
          stats: BenchmarkStats;
          /**
           * When this execution started
           * @format date-time
           */
          startedAt: string | null;
          /**
           * When this execution completed
           * @format date-time
           */
          completedAt: string | null;
          /** Error message if the execution failed */
          error: string | null;
          /** Optimistic locking version */
          version: number;
          /**
           * Creation timestamp
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Last update timestamp
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /** Optimistic locking version */
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/benchmarks/runs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns paginated benchmark runs, optionally filtered by suiteId or status
   *
   * @tags Benchmarks
   * @name BenchmarksRunsList
   * @summary List benchmark runs
   * @request GET:/api/benchmarks/runs
   * @secure
   */
  benchmarksRunsList = (
    query?: {
      /**
       * Starting index for pagination (default: 0)
       * @min 0
       * @default 0
       */
      offset?: number | null;
      /**
       * Maximum number of items to return. Defaults to 100; maximum 1000
       * @min 0
       * @exclusiveMin true
       * @max 1000
       */
      limit?: number | null;
      /** Full-text search query string (optional) */
      textSearch?: string | null;
      /** Field(s) to sort by. Use "-" prefix for descending order (e.g., "-createdAt") */
      orderBy?: string | string[];
      /** Field(s) to group results by (optional) */
      groupBy?: string | string[];
      /** Dynamic field filters as key-value pairs. Use bracket notation in query string (e.g., filters[projectId]=value, filters[name][op]=like&filters[name][value]=test). Values can be direct values, arrays (for IN), or operation objects */
      filters?: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ListFilterOperation
      >;
      /** Filter by suite ID */
      suiteId?: string;
      /** Filter by run status */
      status?: "pending" | "in_progress" | "completed" | "failed";
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** Benchmark runs in the current page */
        items: {
          /** Unique benchmark run ID */
          id: string;
          /** Suite ID */
          suiteId: string;
          /** How the run was triggered */
          trigger: "manual" | "scheduled";
          /** Run status */
          status: "pending" | "in_progress" | "completed" | "failed";
          /**
           * When the run started
           * @format date-time
           */
          startedAt: string | null;
          /**
           * When the run completed
           * @format date-time
           */
          completedAt: string | null;
          /** Top-level error message if the run failed */
          error: string | null;
          /** Config executions within this run (included on single-run GET) */
          executions?: {
            /** Unique execution ID (the unique run_id that links a config to its results) */
            id: string;
            /** Parent benchmark run ID */
            runId: string;
            /** Benchmark config ID */
            configId: string;
            /** Execution status */
            status: "pending" | "in_progress" | "completed" | "failed";
            /** Aggregated statistics, populated after completion */
            stats: BenchmarkStats;
            /**
             * When this execution started
             * @format date-time
             */
            startedAt: string | null;
            /**
             * When this execution completed
             * @format date-time
             */
            completedAt: string | null;
            /** Error message if the execution failed */
            error: string | null;
            /** Optimistic locking version */
            version: number;
            /**
             * Creation timestamp
             * @format date-time
             */
            createdAt: string | null;
            /**
             * Last update timestamp
             * @format date-time
             */
            updatedAt: string | null;
          }[];
          /** Optimistic locking version */
          version: number;
          /**
           * Creation timestamp
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Last update timestamp
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /**
         * Total number of runs matching the query
         * @min 0
         */
        total: number;
        /**
         * Starting index of the current page
         * @min 0
         */
        offset: number;
        /**
         * Maximum number of items requested for the current page. Defaults to 100; maximum 1000
         * @min 0
         * @exclusiveMin true
         * @max 1000
         * @default 100
         */
        limit?: number | null;
      },
      any
    >({
      path: `/api/benchmarks/runs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Returns a single benchmark run with its embedded config executions
   *
   * @tags Benchmarks
   * @name BenchmarksRunsDetail
   * @summary Get a benchmark run
   * @request GET:/api/benchmarks/runs/{id}
   * @secure
   */
  benchmarksRunsDetail = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        /** Unique benchmark run ID */
        id: string;
        /** Suite ID */
        suiteId: string;
        /** How the run was triggered */
        trigger: "manual" | "scheduled";
        /** Run status */
        status: "pending" | "in_progress" | "completed" | "failed";
        /**
         * When the run started
         * @format date-time
         */
        startedAt: string | null;
        /**
         * When the run completed
         * @format date-time
         */
        completedAt: string | null;
        /** Top-level error message if the run failed */
        error: string | null;
        /** Config executions within this run (included on single-run GET) */
        executions?: {
          /** Unique execution ID (the unique run_id that links a config to its results) */
          id: string;
          /** Parent benchmark run ID */
          runId: string;
          /** Benchmark config ID */
          configId: string;
          /** Execution status */
          status: "pending" | "in_progress" | "completed" | "failed";
          /** Aggregated statistics, populated after completion */
          stats: BenchmarkStats;
          /**
           * When this execution started
           * @format date-time
           */
          startedAt: string | null;
          /**
           * When this execution completed
           * @format date-time
           */
          completedAt: string | null;
          /** Error message if the execution failed */
          error: string | null;
          /** Optimistic locking version */
          version: number;
          /**
           * Creation timestamp
           * @format date-time
           */
          createdAt: string | null;
          /**
           * Last update timestamp
           * @format date-time
           */
          updatedAt: string | null;
        }[];
        /** Optimistic locking version */
        version: number;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
        /**
         * Last update timestamp
         * @format date-time
         */
        updatedAt: string | null;
      },
      void
    >({
      path: `/api/benchmarks/runs/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a benchmark run and all its associated executions and results. Blocked if the run is currently in progress.
   *
   * @tags Benchmarks
   * @name BenchmarksRunsDelete
   * @summary Delete a benchmark run
   * @request DELETE:/api/benchmarks/runs/{id}
   * @secure
   */
  benchmarksRunsDelete = (id: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/benchmarks/runs/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Returns all raw iteration results for a given config execution ID
   *
   * @tags Benchmarks
   * @name BenchmarksExecutionsResultsList
   * @summary Get iteration results for a config execution
   * @request GET:/api/benchmarks/executions/{id}/results
   * @secure
   */
  benchmarksExecutionsResultsList = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        /** Unique result ID */
        id: string;
        /** Parent config execution ID */
        configExecutionId: string;
        /**
         * Zero-based iteration index
         * @min 0
         */
        iterationIndex: number;
        /**
         * When this iteration started
         * @format date-time
         */
        startedAt: string | null;
        /**
         * When this iteration completed
         * @format date-time
         */
        completedAt: string | null;
        /** Full iteration result data */
        result: BenchmarkIterationResultData;
        /**
         * Creation timestamp
         * @format date-time
         */
        createdAt: string | null;
      }[],
      any
    >({
      path: `/api/benchmarks/executions/${id}/results`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
